import apiUrl from '../../../../constants'
import commonFunction from '../../../../commonFunction'
import constantVariable from '../../../../constantVariable'
import authFunction from '../../../../authFunction'
import Vue from 'vue'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import { AES, enc } from 'crypto-js';
import {
  BasicSelect
} from 'vue-search-select'

// Import component871083
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

import DoughnutChart from '../../../charts/DoughnutChart'

import validator from "vee-validate";

Vue.use(validator);

import VueAudio from 'vue-audio';

//import pdf from 'vue-pdf'

Vue.filter('formatDatesingle', function (value) {
  if (value) {
    return moment(String(value)).format('DD-MM-YYYY HH:mm:ss')
  }
});

export default {
  name: 'trackshipment',
  components: {
//    pdf,
    VueAudio,
    DoughnutChart,
    BasicSelect,
    Paginate,
    Loading,
    DatePicker
  },
  data: function () {
    return {
     // === B2B CRM ALT Instruction Section Start === -- Added input paramters 
      reattemptTimeSlotWithDate:'',
      pickupAddress: '',
      contactNumber:'',
      // === B2B CRM ALT Instruction Section End ===
      NAStr: "NA",
      isEwayBillNumberValid: false,
      finalS3urlExt: null,
      mpsdetails1: '',
      SearchType: null,
      ParentAWBNo: '',
      userRole: '',
      oldReAttemptDate: '',
      arrayofobj: [],
      counter: 0,
      categoryCatalogue: [],
      alternateContactNo: '',
      newAlternateContactNo: '',
      pageno: 0,
      pagecount: 0,
      isLoadingCurrentStatusDiv: false,
      isLoadingPagination: false,
      fullPage: false,
      filter: '',
      page: 'b2b',
      ticketLabel: 'Raise Ticket',
      userTypeForTicket: '',
      ARRANGED_ASSIGN_OPS_TEAM: 11,
      ADDRESS_CHANGE: 9,
      ADDRESS_UPDATED: 8,
      ASSIGNED_CS_TEAM: 14,
      ASSIGNED_OPS_TEAM: 12,
      STATUS_CHANGED: 15,
      PAYMENT_DETAILS_CHANGE_REQUESTED: 45,
      UPDATE_CONTACT_DETAILS: 17,
      UPDATE_EMAIL_ADDRESS: 97,
      UPDATE_ALTERNATE_CONTACT_NO: 98,
      CONTACT_DETAILS_UPDATED: 19,
      FAKE_NDR: 133,
      REFUSED_DOORSTEP_DELIVERY: 136,
      DELAY_IN_PICKUP_SUB_REASON: 131,
      FAKE_NPR: 119,
      FAKE_PICKUP: 120,
      DENIED_PICKUP: 121,
      CHANGE_REATTEMPT_DATE: 80,
      ATTEMPT_DELIVERY: 58,
      // === B2B CRM ALT Instruction Section Start === -- retrived constant search tagging value 
      Alternate_Instruction_Pickup: constantVariable.Alternate_Instruction_Pickup,
      Alternate_Instruction_Delivery: constantVariable.Alternate_Instruction_Delivery,
      Hold_Pickup: constantVariable.Hold_Pickup,
      Pickup_Details_Updates: constantVariable.Pickup_Details_Updates,
      Reattempt_Time_Slot_Pickup: constantVariable.Reattempt_Time_Slot_Pickup,
      Reattempt_Time_Slot_Delivery: constantVariable.Reattempt_Time_Slot_Delivery,
      Contact_Updated: constantVariable.Contact_Updated,
      Attempt_Pickup: constantVariable.Attempt_Pickup,
      Attempt_Delivery: constantVariable.Attempt_Delivery,
      Address_Updated: constantVariable.Address_Updated,
      Updated_Contact: constantVariable.Updated_Contact,
      // === B2B CRM ALT Instruction Section End ===
      REATTEMPT_DATE_CHANGED: 40,
      ADDDESS_CHANGE_REQUESTED: 42,
      REQUEST_FOR_RTO_NOTIFICATION: 43,
      CHANGE_DELIVERY_PINCODE: 149,
      CHANGE_RTO_PINCODE: 150,
      CHANGE_DTO_PINCODE: 151,
      CHANGE_PICKUP_PINCODE: 152,
      // #changedesti
      //#7472
      B2BCLIENTSUPPORT:constantVariable.B2BCLIENTSUPPORT,
      B2BCLIENTHEAD: constantVariable.B2BCLIENTHEAD,
      B2BOPSHEAD: constantVariable.B2BOPSHEAD,
      B2BOPSSUPPORT:constantVariable.B2BOPSSUPPORT,
      B2BCENTRALOPS:constantVariable.B2BCENTRALOPS,
      CHANGE_DESTINATION_AS_PER_CLIENT: 199,
      CHANGE_DESTINATION_AS_PER_OPS: constantVariable.ChangeDestinationAsPerClientOPS,
      WRONG_PINCODE_GIVEN_BY_CLIENT_ON_INVOICE: constantVariable.WrongPincodeGivenByClientOnInvoice,
      CHANGE_DESTINATION: 28,
      SERVICEABLE_FROM_OTHER_BRANCH_SUBREASON_ID: constantVariable.SERVICEABLE_FROM_OTHER_BRANCH_SUBREASON_ID,
      DESTINATION_UPDATED: 61,
      DESTINATION_REQUESTED: 377,
      disabledFlag :false,  //
      validateB2BEwayclick:false,
            // #changedesti
              //#7472


      //ADDRESS_UPDATED: 8, //Address Updated ACTION
      CHANGE_DELIVERY_ADDRESS_AS_PER_CLIENT: 195,
      CHANGE_ADDRESS: 26,
      RTO_NOTIFIED: 4,
      RTO: 63,
      fakeNdrStatus: 0,
      escalation: 0,
      ticketTaggingDisplay: true,
      ticket: {
        disabled: false
      },
      subDepartmentList: [],
      catelegoryFilteredOptions: [],
      categoryOptionObj: {
        value: '',
        text: '',
        Status: '',
        ShipmentStatus: ''
      },
      arrDisplaySubTypes: [{
          'name': 'forward',
          'subtypes': [{
              'id': constantVariable.FUTURE_DELIVERY,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.SELF_COLLECT,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.URGENT_DELIVERY,
              'types': [{
                  'id': constantVariable.ARRANGE_DELIVERY
                },
                {
                  'id': constantVariable.CANCELLATION_REQUEST
                },
                {
                  'id': constantVariable.HOLD_REASON
                }
              ]
            },
            {
              'id': constantVariable.CSAW_RTO_REATTEMPT,
              'types': [{
                  'id': constantVariable.CANCELLATION_REQUEST
                },
                {
                  'id': constantVariable.HOLD_REASON
                },
                {
                  'id': constantVariable.ARRANGE_DELIVERY
                }
              ]
            },
            {
              'id': constantVariable.HOLD_SUB_REASON,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.LATE_DELIVERY,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.PRICE_ISSUE,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.PRODUCT_ISSUE,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.DUPLICATE_ORDER,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.FAKE_ORDER,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.ODA_LOCATION,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.PURCHASED_FROM_OTHER_SOURCE,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.MIND_CHANGE,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.CUSTOMER_OUT_OF_STATION,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.CUSTOMER_WANT_OPEN_DELIVERY,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.DUE_TO_FAKE_UPDATE,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.NEVER_ORDERED,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.COD_NOT_AVAILABLE,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.SR_DEMAND_FOR_EXTRA_AMOUNT,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.ORDERED_BY_MISTAKE,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.NO_SUCH_REASON,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.NOT_INTERESTED_TO_TAKE,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.SR_MISBEHAVIOUR,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.INCORRECT_PINCODE,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.CUSTOMER_SHIFTED,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.SOMEONE_ELSE_ORDERED,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.FORGOT_TO_APPLY_PROMOCODE,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.REFUND_PENDING_OF_PREVIOUS_ORDER,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.DEMISE_IN_FAMILY,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            }
          ]
        },
        {
          'name': 'reverse',
          'subtypes': [{
              'id': constantVariable.FUTURE_PICKUP,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            },
            {
              'id': constantVariable.PICKUP_WITHOUT_QC,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            },
            {
              'id': constantVariable.EXCEPTIONAL_PICKUP,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            },
            {
              'id': constantVariable.URGENT_PICKUP,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            },
            {
              'id': constantVariable.CSAW_DTO_REATTEMPT,
              'types': [{
                  'id': constantVariable.CANCELLATION_REQUEST
                },
                {
                  'id': constantVariable.HOLD_REASON
                },
                {
                  'id': constantVariable.ARRANGE_PICKUP
                }
              ]
            },
            {
              'id': constantVariable.HOLD_SUB_REASON,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.QC_FAILED,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            },
            {
              'id': constantVariable.AS_PER_CLIENT,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            },
            {
              'id': constantVariable.PRODUCT_USED,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            },
            {
              'id': constantVariable.PRODUCT_HANDEDOVER,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            },
            {
              'id': constantVariable.OUT_SERVICE_AREA,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            },
            {
              'id': constantVariable.DUPLICATE_REQUEST,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            },
            {
              'id': constantVariable.RETURN_REASON_MISMATCH,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            }
          ]
        }
      ],
      category: {
        'Forward': [{
            'Status': 'Delivered',
            'ShipmentStatus': 'Delivered',
            'name': 'Delivered'
          },

          {
            'Status': 'Pending',
            'ShipmentStatus': 'ReinitiatedPickups',
            'name': 'Pending'
          },

          {
            'Status': 'Dispute',
            'ShipmentStatus': 'Inscan',
            'name': 'Dispute'
          },
          {
            'Status': 'ForwardDispute',
            'ShipmentStatus': 'Inscan',
            'name': 'Dispute'
          },
          {
            'Status': 'Dispute',
            'ShipmentStatus': 'Investigate',
            'name': 'Investigation'
          },
          {
            'Status': 'ForwardDispute',
            'ShipmentStatus': 'Investigate',
            'name': 'Investigation'
          },
          {
            'Status': 'Lost',
            'ShipmentStatus': 'Investigate',
            'name': 'Investigation'
          },
          {
            'Status': 'RTO',
            'ShipmentStatus': 'Investigate',
            'name': 'Investigation'
          },
          {
            'Status': 'RTODispute',
            'ShipmentStatus': 'Investigate',
            'name': 'Investigation'
          },
          {
            'Status': 'RTOShortage',
            'ShipmentStatus': 'Investigate',
            'name': 'Investigation'
          },
          {
            'Status': 'Shipped',
            'ShipmentStatus': 'Investigate',
            'name': 'Investigation'
          },
          {
            'Status': 'Shortage',
            'ShipmentStatus': 'Investigate',
            'name': 'Investigation'
          },
          {
            'Status': 'STD',
            'ShipmentStatus': '',
            'name': 'STD'
          },
          {
            'Status': 'Lost',
            'ShipmentStatus': 'BagIn',
            'name': 'Lost'
          },
          {
            'Status': 'Lost',
            'ShipmentStatus': 'InScan',
            'name': 'Lost'
          },
          {
            'Status': 'Lost',
            'ShipmentStatus': 'Lost',
            'name': 'Lost'
          },
          {
            'Status': 'Lost',
            'ShipmentStatus': 'Overage',
            'name': 'Lost'
          },
          {
            'Status': 'NTS',
            'ShipmentStatus': 'NTS',
            'name': 'NTS'
          },
          {
            'Status': 'NTS',
            'ShipmentStatus': 'Overage',
            'name': 'NTS'
          },
          {
            'Status': 'RTO',
            'ShipmentStatus': 'BagIn',
            'name': 'RTO Undelivered'
          },
          {
            'Status': 'RTO',
            'ShipmentStatus': 'Handover',
            'name': 'RTO Undelivered'
          },
          {
            'Status': 'RTO',
            'ShipmentStatus': 'HVTExp',
            'name': 'RTO Undelivered'
          },
          {
            'Status': 'RTO',
            'ShipmentStatus': 'InScan',
            'name': 'RTO Undelivered'
          },
          {
            'Status': 'RTO',
            'ShipmentStatus': 'Overage',
            'name': 'RTO Undelivered'
          },
          {
            'Status': 'RTO',
            'ShipmentStatus': 'SAInscanPending',
            'name': 'RTO Undelivered'
          },
          {
            'Status': 'RTO',
            'ShipmentStatus': 'SVCInscanPending',
            'name': 'RTO Undelivered'
          },
          {
            'Status': 'Shipped',
            'ShipmentStatus': 'BagIn',
            'name': 'Shipped'
          },
          {
            'Status': 'Pending',
            'ShipmentStatus': 'PickupDone',
            'name': 'Shipped'
          },
          {
            'Status': 'Shipped',
            'ShipmentStatus': 'Handover',
            'name': 'Shipped'
          },
          {
            'Status': 'Shipped',
            'ShipmentStatus': 'HVTExp',
            'name': 'Shipped'
          },
          {
            'Status': 'Shipped',
            'ShipmentStatus': 'InScan',
            'name': 'Shipped'
          },
          {
            'Status': 'Shipped',
            'ShipmentStatus': 'Overage',
            'name': 'Shipped'
          },
          {
            'Status': 'Shipped',
            'ShipmentStatus': 'SAInscanPending',
            'name': 'Shipped'
          },
          {
            'Status': 'Shipped',
            'ShipmentStatus': 'SVCInscanPending',
            'name': 'Shipped'
          },
          {
            'Status': 'Shortage',
            'ShipmentStatus': 'SAInscanPending',
            'name': 'Shipped'
          },
          {
            'Status': 'STD',
            'ShipmentStatus': 'BagIn',
            'name': 'STD'
          },
          {
            'Status': 'STD',
            'ShipmentStatus': 'InScan',
            'name': 'STD'
          },
          {
            'Status': 'STD',
            'ShipmentStatus': 'Overage',
            'name': 'STD'
          },
          {
            'Status': 'STD',
            'ShipmentStatus': 'STD',
            'name': 'STD'
          },
          {
            'Status': 'STD',
            'ShipmentStatus': 'Investigate',
            'name': 'Shipped'
          },
          {
            'Status': 'RTO',
            'ShipmentStatus': 'WHHandOver',
            'name': 'WH Handover'
          },
          {
            'Status': 'Pending',
            'ShipmentStatus': 'Pending',
            'name': 'Pending'
          },
          //Not Picked category for B2B
          {
            'Status': 'Pending',
            'ShipmentStatus': 'OutForPickup',
            'name': 'Not Picked'
          },
          {
            'Status': 'Invalid',
            'ShipmentStatus': 'Invalid',
            'name': 'Invalid'
          },
          {
            'Status': 'RTOTerminal',
            'ShipmentStatus': 'RTOTerminal',
            'name': 'RTOTerminal'
          },
        ],
        'Reverse': [{
            'Status': 'DTO',
            'ShipmentStatus': 'WHHandOver',
            'name': 'DTO WHHandover'
          },
          {
            'Status': 'STD',
            'ShipmentStatus': 'BagIn',
            'name': 'STD'
          },
          {
            'Status': 'STD',
            'ShipmentStatus': 'InScan',
            'name': 'STD'
          },
          {
            'Status': 'STD',
            'ShipmentStatus': 'Overage',
            'name': 'STD'
          },
          {
            'Status': 'STD',
            'ShipmentStatus': 'STD',
            'name': 'STD'
          },
          {
            'Status': 'Pending',
            'ShipmentStatus': 'Pending',
            'name': 'Not Picked'
          },
          {
            'Status': 'Pending',
            'ShipmentStatus': 'PickupAssinged',
            'name': 'Not Picked'
          },
          {
            'Status': 'Pending',
            'ShipmentStatus': 'OutForPickup',
            'name': 'Not Picked'
          },
          {
            'Status': 'Pending',
            'ShipmentStatus': 'PickupDone',
            'name': 'Pick Done'
          },
          {
            'Status': 'Pending',
            'ShipmentStatus': 'PickupNotDone',
            'name': 'Not Picked'
          },
          {
            'Status': 'RPCancel',
            'ShipmentStatus': 'RPCancel',
            'name': 'Cancelled'
          },
          {
            'Status': 'Pending',
            'ShipmentStatus': 'PickupDoneBySR',
            'name': 'Pick Done'
          },
          {
            'Status': 'Pending',
            'ShipmentStatus': 'ReinitiatedPickups',
            'name': 'Not Picked'
          },
          {
            'Status': 'Pending',
            'ShipmentStatus': 'Handover',
            'name': 'Not Picked'
          },
          {
            'Status': 'Shipped',
            'ShipmentStatus': 'Inscan',
            'name': 'DTO Undelivered'
          },
          {
            'Status': 'Shipped',
            'ShipmentStatus': 'BagIn',
            'name': 'DTO Undelivered'
          },
          {
            'Status': 'SPCancel',
            'ShipmentStatus': 'SPCancel',
            'name': ''
          },
          {
            'Status': 'Shipped',
            'ShipmentStatus': 'Handover',
            'name': 'Shipped'
          },
          {
            'Status': 'Shipped',
            'ShipmentStatus': 'SVCInScanPending',
            'name': 'Shipped'
          },
        ]

      },
      ticketResultMsg: '',
      ticketResultModal: false,
      saveandcloseModal: false,
      Callpatching: {
        CallPatchingModal: false,
        Name: '',
        ShippingID: '',
        optNumberType: '1',
        addressType: '',
        mobileNumber: '',
        altMobileNumber: '',
        businessType: 'B2B'
      },
      submitted: false,
      checkAllSelected: true,
      OtherShipments: {
        isLoading: false,
        showChart: false,
        chartData: {
          labels: [],
          datasets: [{
            backgroundColor: [],
            data: []
          }]
        },
        DeliveredCnt: 0,
        DTOCnt: 0,
        NotPickedCnt: 0,
        PickDoneCnt: 0,
        CancelledCnt: 0,
        DTOUndeliveredCnt: 0,
      },
      PageTitle: 'trackshipment',
      ShipmentLogModal: false,
      isLoading: false,
      isModelLoading: false,
      ticketIDLoader: false,
      fullPage: true,
      glyphprogress: true,
      short_short_connecting_line: false,
      short_short_glyphprogress: false,
      short_glyphprogress: false,
      connecting_line: true,
      short_connecting_line: false,
      ShippingIDTypeMainDiv: false,
      MobileNumberTypeMainDiv: false,
      BagNumberTypeMainDiv: false,
      OTPDetails: {
        OTP: '',
        DelivereyOTP: '',
        OTPDiv: false,
        DeliveryOTPDiv: false,
        ShowOTPNo: false,
        showDeliveryOTPNo: false,
      },
      CustomerDetails: {
        CustomerName: '',
        EmailID: '',
        //PhoneNo: 'aed75a1fa8eb09af6210',
        PhoneNo: '',
        PhoneNoDisplay: '',
        Pincode: '',
        Address: '',
        PhoneNoAlt: '',
        PhoneNoAltDisplay: '',
        AddressStr: ''
      },

      PickupAddress: {
        Name: '',
        Address: '',
        City: '',
        State: '',
        Pincode: '',
        PhoneNo: '',
        PhoneNoDisplay: '',
        PhoneNoAlt: '',
        PhoneNoAltDisplay: ''
      },

      CustomerAlternateAddress: {
        CustomerName: '',
        EmailID: '',
        Pincode: '',
        Address: '',
        AddressStr: ''
      },
      RTODetails: {
        CustomerName: '',
        EmailID: '',
        PhoneNo: '',
        PhoneNoDisplay: '',
        PhoneNoAlt: '',
        PhoneNoAltDisplay: '',
        AddressStr: '',
        Address: '',
        Pincode: ''
      },
      SalesDemo: {
        Bussiness: '',
        ParentAWB: '',
        ChildAWB: '',
        SenderName: '',
        ShippingID: '',
        Status: '',
        BusinessAccountName: '',
        ServiceType: '',
        ShipmentStatus: '',
        EDD: '',
        PDD: '',
        BusinessFlow: '',
        DelayedDateStr: '',
        DeliveryDateTime: '',
        ClientName: '',
        IsLatestOFD: false,
        IsCSAW: 'No',
        MPSBoxCount:'',
        ClientType:'',       // b2b_restrict_rto_client
        // === B2B CRM ALT Instruction Section Start === -- Added PickupTimeSlotWithDate for visibility in trackshipment page
        PickupTimeSlotWithDate:''
        // === B2B CRM ALT Instruction Section End ===
      },
      ShipmentTransactionLogSummary: {
        ManifestDate: null,
        OriginHubID: '',
        CurrentHubID: '',
        FinalDestinationID: '',
        DataReceived: '',
        OriginHubData: '',
        BusinessFlow: '',
        currentHubData: '',
        currentHubDataLiShow: true,
        currentHubDataDivShow: true,
        currentHubDataMainDivShow: true,
        DestinationHubData: '',
        DestinationHubDataLiShow: true,
        OriginHubDataLiShow: true,
        ClientID: '',
        IsLatestManifestDataReceived: false,
        IsLatestOriginHubInScan: false,
        IsLatestCurrentHubInscanDate: false,
        IsLatestDestinationHubInscanDate: false,
        IsLatestOFD: false,
        IsLatestDeliveryDateTime: false
      },
      ShipmentLog: {
        ShipmentLogCnt: '',
        ShipmentLogDiv: '',
        ShipmentLogElement: {
          CurrentHubID: '',
          HubName: '',
          UserProcess: '',
          Comments: '',
          UserName: '',
          ProcessLocation: '',
          CreatedDate: ''
        },
        ShipmentLogBarArr: []
      },
      OrderDetails: {
        OrderNo: '',
        Quantity: '',
        OrderType: '',
        ReattemptDate: '',
        CollectibleAmount: '',
        NotificationStatus: '',
        TotalAttemptCount: '',
        LastNDR: '',
        LastCSAW: '',
        OutForDeliveryStr: true,
        EmailServiceCenter: '', // Current Hub EmailID
        InvoiceTotal: '',
        googleInitialiseData: [{
          latitude: '',
          longitude: ''
        }],
        srUserData: {
          FirstName: '',
          LastName: '',
          MobileNumber: '',
        },
        srLocationDetails: {
          srid: '',
        },
        deliveryUserID: '',
        ToPayFTCamount:"",
        RTOAWB:""
      },
      MultipleProductInfo: {
        MultipleProductInfoModal: false,
        MultipleProductInfoArr: [],
      },
      IVRCallRecording: {
        IVRCallRecordingUrlModal: false,
        AudioUrl: '',
        IVRCallRecordingBtn: false,
        IVRCallRecordingModal: false,
        IVRCallRecordingArr: [],
        IVRCallPatchingBtn: false,
      },
      map: [],
      locationMapModal: false,
      displayCurrentLocation: '',
      OtherShipmentLogArr: [],
      poIdShipmentArr: [],
      POIDTypeMainDiv: false,
      AllShipmentLogArrData: [],
      UnCategorizedArrData: [],
      OtherShipmentLogCnt: '',
      RaiseTicketDiv: false,
      OtherShipmentShippingIDCheckedArr: [],
      allSelected: false,
      Role: {
        roleid: '',
        rolename: ''
      },
      SelectTypeOptionArr: [{
          value: 'ParentAWB',
          text: 'Parent AWB'
        },
        {
          value: 'ShippingID',
          text: 'Shipping ID'
        }
      ],
      SelectTypeOptionObj: {
        value: 'ParentAWB',
        text: 'Parent AWB'
      },
      BagNoObj: { //
        BagDetails: {},
        AuditLogArr: [],
        TransitStatusArr: [],
        TransitStatusModal: false,
        BagShipmentDetailsModal: false,
        BagInShipmentCount: 0,
        BagShipmentDetailsArr: [],
      },
      //  ShippingID: 'xb-s1'  // Testing bag
      //  ShippingID: '2711877969', // Testing ShippingID
      // ShippingID: '12271382721',
      ShippingID: '',
      Ticketmodal: false,
      consigneeDetailsModal: false,
      tableShipment: false,
      ticketShipmentData: [],
      ticketExistedData: [],
      ticketIDS: [],
      shipmentTickets: [],
      ticket: {},
      username: '',
      mobileNumber: '',
      ticketId: '',
      source: [],
      sourceId: '',
      selectedSourceObj: {
        value: '',
        text: ''
      },
      ticketType: [],
      ticketTypeId: '',
      selectedTicketObj: {
        value: '',
        text: ''
      },
      reason: [],
      reasonId: '',
      selectedReasonObj: {
        value: '',
        text: ''
      },
      subReason: [],
      subReasonId: '',
      selectedSubReasonObj: {
        value: '',
        text: ''
      },
      action: [],
      actionId: '',
      selectedActionObj: {
        value: '',
        text: ''
      },
      ticketStatus: [],
      ticketStatusId: '',
      selectedTicketStatusObj: {},
      searchOptions: [],
      shippingIdDetails: [],
      searchId: '',
      selectedSearchObj: {
        value: '',
        text: ''
      },
      reAttemptDate: '',
      mobileNo: '',
      startDate: new Date(),
      endDate: new Date(),
      validated: false,
      shortcuts: [{
        text: 'Today',
        startDate: new Date()
      }],
      format: 'YYYY-MM-DD',
      disabledDates: {
        to: new Date(Date.now() - 8640000)
      },
      address: '',
      location: '',
      pincode: '',
      orderType: [{
        value: 'cod/prepaid',
        text: 'COD <> Prepaid'
      }],
      orderTypeId: '',
      selectedOrderTypeObj: {
        value: '',
        text: ''
      },
      netPayment: '',
      comments: '',
      email: '',
      userid: '',
      DepartmentID: '',
      DepartmentName: '',
      SummaryOptionObj: [],
      SummarySelectOptionObj: {
        value: '',
        text: ''
      },
      SendSMS: {
        submitted: false,
        SendSMSModal: false,
        ActualSMSCode: "",
        SendSMSArr: [],
        Message: "",
        SelectedSendSMSObj: {
          value: '',
          text: ''
        },
        SMSData: [],
        SendSMSKey: "xbsndvT",
        ReasonArr: [],
        Reason: "",
        SelectedReasonObj: {
          value: '',
          text: ''
        }
      },
      CallTypeOptionObj: [],
      CallType: '',
      resultTicket: [],
      TicketLogModal: false,
      listExisitngTicketModal: false,
      updateExistingBulkTicket: false,
      showBulkTicketDiv: false,
      ticketIDLog: '',
      selectAllRecord: false,
      newReAttemptDate: '',
      newAddress: '',
      newPincode: '',
      newEmailAddress: '',
      payMethods: [{
          text: 'COD',
          value: 1
        },
        {
          text: 'Prepaid',
          value: 2
        }
      ],
      selectedMethodObj: {
        value: '',
        text: ''
      },
      methodId: '',
      disPayment: false,
      disPaymentMethod: false,
      modalshowProductType: false,
      //#7472
      hubList: [],
      kamPocList: [],
      opsPocList: [],
      hubIds: '',
      kamPocIds: '',
      opsPocIds: '',
      selectedHubObj: {
        value: '',
        text: ''
      },
      selectedKamPocObj: {
        value: '',
        text: ''
      },
      selectedOpsPocObj: {
        value: '',
        text: ''
      },
      UploadRTODocsmodal: false,
      //#7472
      UploadDestinationDocsmodal: false,
      showDestinationDocsViewOnly: false,
      salesReturnNoteNo: '',
      salesReturnNoteValue: '',
      EwaybillNo: '',
      imagefilepath: '',
      fileExtension: '',
      rtodocdata: '',
      isShow: false,
      isShowError: false,
      SalesReturnNoteRTODocDataLink: '',
      SalesReturnNoteRTODocDataKey: '',
      ebnRTODocDataLink: '',
      ebnRTODocDataKey: '',
      SalesReturnNoteuploadData: '',
      uploadSalesReturnNote: null,
      RTOresultTicket: '',
      resultTotalSum: '',
      salesReturnKey: 0, //#b2b_partial_rto
      SumOfTotalInvoices: '',
      getRTOTicketsdata: '',
      getDestinationTicketsdata: '',//#7472
      displayImageInBox: '',
      previewImageData: [],
      previewImageModel: false,
      previewImageModelChangeDesti: false, //#changedesti //#7472
      proofstatus:'',//#changedesti //#7472
      ChangeDestiDoc:'',//#changedesti //#7472
      titleNameLinkchangedest : '', //#7472
      titleNameLink: '',
      validatedSave: false,
      ebnExpiryDate:null, //#5278_b2b_expirydate ebn validity date 
      //#7472 consignee details section starts here
      isLoading: false,
      UpdateConsigneeDetails: false,
      isPincodeServiceable: true,    //#7472
      isServiceableFromOtherBranchPincode: false,    //#serviceable_other_branch
      ticketdetails :{},
      pendingCreateTicketContext: null,
  
      gstNo: '',
      // pincode: '',

      consigneeDetailslist: [],
      filteredConsigneeList: [],
      userHublist:[],
  
      AddNewConsigneeFlag: false,
  
      locationPrefix: '',
      NewConsigneeCode: '',
  
      consignee: {
        id: '',
        consigneecode: '',
        consigneegstno: '',
        consigneecompanyname: '',
        consigneeaddress: '',
        consigneemobile: '',
        consigneetelephone: '',
        consigneespoc: '',
        consigneestate: '',
        consigneecity: '',
        consigneehub: '',
        consigneemail: ''
      },
      isConsigneeValidated: false,  
      ViewConsigneeDetails: false,
      savedConsigneeSnapshot: null ,

       //#7472 consignee details section ends here
       //#sr_vehicle_7686
       b2b_sr_vehicle_details:{
        vehicle_number:'',
        driver_name:'',
        driver_mobile_number:''
       }
    }
  },
  created: function () {
    if (this.$route.params.type && this.$route.params.type === "M") {
      this.SelectTypeOptionObj.value = "MobileNumber";
      this.SelectTypeOptionObj.text = "Mobile Number";
    } else if (this.$route.params.type && this.$route.params.type === "B") {
      this.SelectTypeOptionObj.value = "BagNumber";
      this.SelectTypeOptionObj.text = "Bag Number";
    } else {
      // empty else
    }
    if (this.$route.params.id) {
      this.ShippingID = this.$route.params.id;
      this.$router.push({
        path: '/b2b/trackshipment',
      })
      this.B2BTrackShipment();
      this.resetForm();
    }
  },
  computed: {
    //#7472
    filteredClientTickets() {
      return this.shipmentTickets.filter(t => t.typename && t.typename.toLowerCase().includes('change destination as per client'));
    },
    filteredOpsTickets() {
      return this.shipmentTickets.filter(t => t.typename && t.typename.toLowerCase().includes('change destination as per ops'));
    },
    showServiceableFromOtherBranchHubDropdown() {
      return this.selectedReasonObj &&
        this.selectedReasonObj.value === this.CHANGE_DESTINATION &&
        this.isServiceableFromOtherBranchSubReasonSelected() &&
        this.isServiceableFromOtherBranchPincode &&
        this.DepartmentID === this.B2BOPSSUPPORT;
    },
    getFilteredPageCount() {
      if (this.DepartmentID == this.B2BCLIENTHEAD) {
        return Math.ceil(this.filteredClientTickets.length / 10);
      } else if (this.DepartmentID == this.B2BOPSHEAD) {
        return Math.ceil(this.filteredOpsTickets.length / 10);
      } else {
        return this.pagecount;
      }
    },
  // === B2B CRM ALT Instruction Section Start === -- Added label for 'Reattempt Pickup Time Slot With Date' , 'Reattempt Delivery Time Slot With Date' and 'Pickup Hold Till Date'   --Added minSelectableDateTime & maxSelectableDateTime
  dynamicTimeSlotLabel() {
    if (this.selectedReasonObj.value === constantVariable.Alternate_Instruction_Pickup && this.selectedSubReasonObj.value === constantVariable.Hold_Pickup) {
      return 'Pickup Hold Till Date';
    } else if (this.selectedReasonObj.value === constantVariable.Alternate_Instruction_Delivery) {
      return 'Reattempt Delivery Time Slot With Date';
    }
    return 'Reattempt Pickup Time Slot With Date';
  },
  minSelectableDateTime() {
      // Today with current time
      return new Date();
  },
  maxSelectableDateTime() {
      // 30 days from now, end of day
      const end = new Date();
      end.setDate(end.getDate() + 30);
      end.setHours(23, 59, 59, 999);
      return end;
  },
  //#7472
  isEbnMandatory() {
    if (this.isDestinationDocsUploadFlow() && Number(this.salesReturnNoteValue) < 50000) {
      return false;
    }
    return !(
      Number(this.salesReturnNoteValue) < 50000 &&
      this.isChangeDestinationAsPerClientTicket(this.ticket)
    );
  },
  //#sr_vehicle_7686 show accoridng to conditions
  showBASRDetails() {
    return (
      this.SalesDemo.AppointmentDate &&
      this.SalesDemo.AppointmentDate !== 'null' &&
      (this.SalesDemo.UserProcess.toLowerCase() === 'out for delivery' || this.SalesDemo.UserProcess.toLowerCase() === 'allocated to sr')
    );
  },
  //#7472 show change destination docs upload modal according to conditions
  isApprovalFlow() {
    return (
      (this.DepartmentID === this.B2BCLIENTHEAD  || this.DepartmentID === this.B2BOPSHEAD) &&
      this.ticketLabel === 'Edit Ticket' &&
      this.selectedReasonObj.value === this.CHANGE_DESTINATION &&
      (
        this.selectedSubReasonObj.text === 'Change destination as per Ops'  ||
        this.selectedSubReasonObj.text === 'Change destination as per Client'
      )
    );
  },
  // Ops Head approver summary: Old vs New Pincode/Branch for Change Destination tickets on Edit
  showOpsHeadDestinationApprovalTable() {
    return (
      this.DepartmentID === this.B2BOPSHEAD &&
      this.ticketLabel === 'Edit Ticket' &&
      this.selectedReasonObj.value === this.CHANGE_DESTINATION
    );
  },
  opsHeadDestinationApprovalRow() {
    if (!this.showOpsHeadDestinationApprovalTable) return null;
    const t = this.ticket || {};
    const adl = t.adlinfo || {};
    const cd = adl.consigneeDetails || {};
    const summary = this.ShipmentTransactionLogSummary || {};
    // console.log(this.CustomerDetails, this.ticket,summary,">>>>>>>>>>>>>>>")
    // Old (current shipment state before the change destination request)
    const oldPincode = (this.CustomerDetails && this.CustomerDetails.PinCode) || '';
    const oldHubId = summary.CurrentHubID || '';
    const oldHubRaw = this.formatHubDisplayById(oldHubId) || summary.currentHubData || oldHubId || '';
    // Show branch name only (e.g. PNQ/WKD), not full status/location string
    const oldHubDisplay = this.extractBranchNameOnly(oldHubRaw);

    // New (as requested on the ticket)
    const newPincode = this.ticket.pincode || '';
    const newHubId = this.ticket.hub || adl.hubIds || '';
    const newHubDisplay = adl.selectedHubObj || cd.consigneehub || this.extractBranchNameOnly(this.formatHubDisplayById(newHubId) || newHubId || '');

    return {
      oldPincode,
      oldHubDisplay,
      newPincode,
      newHubDisplay,
      reason: (this.ticket.typename || '') + ''
    };
  },

  
    filteredShipmentTickets() {
        // console.log("DepartmentID", this.DepartmentID);

        if (this.DepartmentID == this.B2BCLIENTHEAD) {
            return this.shipmentTickets.filter(ticket =>
                ticket.typename &&
                ticket.typename.toLowerCase().includes("change destination as per client")
            );
        }

        if (this.DepartmentID == this.B2BOPSHEAD) {
            return this.shipmentTickets.filter(ticket =>
                ticket.typename &&
                ticket.typename.toLowerCase().includes("change destination as per ops")
            );
        }

        return this.shipmentTickets;
    }
  },
  //#7472
  watch: {
    gstNo(val) {
      this.fetchConsigneeByGST();
    }
  },
  
  // === B2B CRM ALT Instruction Section End ===
  mounted() {
    // this.fetchHubData();
    [this.subDepartmentList, this.DepartmentID, this.userdetail, this.permissiondata, this.userTypeForTicket, this.SummarySelectOptionObj, this.SummaryOptionObj] = commonFunction.getuserDetailsAndpermissionData();
    // this.accessRestrictor();  // Test
    this.Role.roleid = this.userdetail[0].roles[0].roleid;
    this.userRole = this.Role.rolename = this.userdetail[0].roles[0].rolename;

    this.OrderDetails.googleInitialiseData[0].latitude = 18.545885;
    this.OrderDetails.googleInitialiseData[0].longitude = 73.908419;
    this.displayCurrentLocation = '';
    this.userid = this.userdetail[0].userid;
    this.username = this.userdetail[0].email;
    this.email = this.userdetail[0].email;
    this.OldDeliveryUserOrUserId = this.userdetail[0].OldDeliveryUserOrUserId;
    this.firstname = this.userdetail[0].FirstName;
    this.lastname = this.userdetail[0].LastName;
    this.mobileNumber = this.userdetail[0].MobileNumber;
    //  this.getDepartmentNameFromId(); // NotInUse

    // this.getAccessToIVRCallRecording(); // NotInUse

  },
  methods: {
    trigger: function () {
      this.OnFilterClick();
    },
    // === B2B CRM ALT Instruction Section Start === -- Implemented disablePastTime method to restrict time selection to past slots when today's date is selected in the date-time picker
     disablePastTime(date) {
      const selectedDate = new Date(date);
      const now = new Date();

      // Only restrict time if selected date is today
      if (
        selectedDate.toDateString() === now.toDateString()
      ) {
        const hours = [];
        const minutes = [];
        const seconds = [];

        for (let i = 0; i < now.getHours(); i++) {
          hours.push(i);
        }

        if (selectedDate.getHours() === now.getHours()) {
          for (let i = 0; i < now.getMinutes(); i++) {
            minutes.push(i);
          }

          if (selectedDate.getMinutes() === now.getMinutes()) {
            for (let i = 0; i < now.getSeconds(); i++) {
              seconds.push(i);
            }
          }
        }

        return {
          disabledHours: () => hours,
          disabledMinutes: () => minutes,
          disabledSeconds: () => seconds
        };
      }

      return {
        disabledHours: () => [],
        disabledMinutes: () => [],
        disabledSeconds: () => []
      };
    },
    //#7472
    getApprovalEmail(ticket) {
      if (this.DepartmentID == this.B2BCLIENTHEAD) {
        return ticket.kam_poc_email || 'NA';
      }
      if (this.DepartmentID == this.B2BOPSHEAD) {
        return ticket.ops_poc_email || 'NA';
      }
      return 'NA';
    },
    // === B2B CRM ALT Instruction Section End === 
    resetUpdateTicketModal() {
      this.selectAllRecord = false;
      this.ticketIDS = [];
      this.ticketExistedData = [];
    },

    openUpdateTicketModal() {

      if (this.ticketIDS.length == 0) {
        this.$alertify.error('Please select ticket.');
        return false;
      }
      this.ticketLabel = '';
      this.updateExistingBulkTicket = false;
      this.showBulkTicketDiv = true;
      this.source = [];
      this.ticketType = [];
      this.reason = [];
      this.subReason = [];

      if (this.ticketExistedData.length == 1) {
        this.newReAttemptDate = this.ticketExistedData[0].shippingData.reattemptdate;
        this.newAddress = this.ticketExistedData[0].shippingData.address;

        this.newPincode = this.ticketExistedData[0].shippingData.pincode;
        this.orderTypeId = this.ticketExistedData[0].shippingData.ordertype;
        this.netPayment = this.ticketExistedData[0].shippingData.netpayment;
        this.newAlternateContactNo = this.ticketExistedData[0].shippingData.alternatecontactnumber;
        this.newEmailAddress = this.ticketExistedData[0].shippingData.emailaddress;
      } else {
        let intTicketDataLength = this.ticketExistedData.length;
        let boolIsMultipleSource = false;
        if (intTicketDataLength > 1) {

          for (let i = 0; i < intTicketDataLength; i++) {

            if (this.ticketExistedData[0].shippingData.sourceid != this.ticketExistedData[i].shippingData.sourceid) {
              boolIsMultipleSource = true;
              break;
            }
          }

          if (true == boolIsMultipleSource) {
            this.selectedSourceObj.text = "Multiple";
            this.selectedSourceObj.value = "Multiple";
          }
        }
      }
      this.selectedTicketStatusObj = {
        text: '',
        value: ''
      };
      this.ticketStatus = [];
      this.ticketStatusId = '';
      this.action = [];
      this.actionId = '';
      this.selectedActionObj = {
        value: '',
        text: ''
      };

      if (this.subReasonId == 44) {
        var method = {
          value: '',
          text: ''
        };
        if (this.ticketExistedData[0].shippingData.ordertype == 'PrePaid') {
          method = {
            value: 2,
            text: 'Prepaid'
          };
          this.selectedMethod(method);
        } else {
          method = {
            value: 1,
            text: 'COD'
          };
          this.selectedMethod(method);
        }
      }
      this.disPayment = true;
      this.disPaymentMethod = true;

      this.getTicketAction(this.subReasonId, 'Edit');


    },

    selectTicket(selectedObj, index, event) {
      this.allSelected = false;
      if (event.target.checked) {
        this.ticketExistedData.push({
          'index': index, // 'shippingData': selectedObj
          'shippingData': {
            'shippingid': selectedObj.shippingid,
            'ticketid': selectedObj.ticketid,
            'sourceid': selectedObj.sourceid,
            'tickettypeid': selectedObj.tickettypeid,
            'reasonid': selectedObj.reasonid,
            'subreasonid': selectedObj.subreasonid,
            'ticketstatus': selectedObj.ticketstatus,
            'hub': selectedObj.hub,
            'attempts': selectedObj.attempts,
            'comments': selectedObj.comments,
            'businessflow': selectedObj.businessflow
          }
        });

        let intPosition = this.ticketExistedData.findIndex(o => o.index == index);

        if (this.selectedReasonObj.text == 'Arrange delivery' || this.selectedReasonObj.text == 'Arrange pickup' ||
          (this.selectedReasonObj.text == 'Non Behavioral' && this.selectedSubReasonObj.text == 'Delay in service') ||
          (this.selectedReasonObj.text == 'SR related' && this.selectedSubReasonObj.text == 'Fake update')) {

          this.ticketExistedData[intPosition].shippingData.reattemptdate = selectedObj.reattemptdate;
        }

        if (this.selectedSubReasonObj.text == 'Change RTO address' || this.selectedSubReasonObj.text == 'Change DTO address' ||
          this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Change Pickup address' || this.selectedSubReasonObj.text == 'Change delivery address as per Client' ||
          this.selectedSubReasonObj.text == 'Redirect to Bank' || this.selectedSubReasonObj.text == 'Change misroute pincode') {

          this.ticketExistedData[intPosition].shippingData.name = selectedObj.name;
          this.ticketExistedData[intPosition].shippingData.address = selectedObj.address;
          this.ticketExistedData[intPosition].shippingData.pincode = selectedObj.pincode;
        }

        if (this.selectedSubReasonObj.text == 'Change payment mode / amount') {

          this.ticketExistedData[intPosition].shippingData.ordertype = selectedObj.ordertype;
          this.ticketExistedData[intPosition].shippingData.netpayment = selectedObj.netpayment;
        }

        if (this.selectedReasonObj.text == 'Update Contact Details' && this.selectedSubReasonObj.text == 'Update Alternate Contact No') {

          this.ticketExistedData[intPosition].shippingData.alternatecontactnumber = selectedObj.alternatecontactnumber;
        }

        if (this.selectedReasonObj.text == 'Update Contact Details' && this.selectedSubReasonObj.text == 'Update Email Address') {

          this.ticketExistedData[intPosition].shippingData.emailaddress = selectedObj.emailaddress;
        }

      } else {
        this.ticketExistedData.splice(this.ticketExistedData.findIndex(o => o.index == index), 1);
      }

    },

    selectAllCheckbox() {
      //this.rackIds = [];
      if (this.selectAllRecord) {
        var i = 0;

        for (let indexId in this.ticket) {

          if (this.ticketIDS.indexOf(this.ticket[indexId].ticketid) == -1) {
            this.ticketIDS.push(this.ticket[indexId].ticketid);

            this.ticketExistedData.push({
              'index': i, // 'shippingData': this.shipmentTickets[indexId],
              'shippingData': {
                'shippingid': this.ticket[indexId].shippingid,
                'hub': this.ticket[indexId].hub,
                'attempts': this.ticket[indexId].attempts,
                'comments': this.ticket[indexId].comments,
                'businessflow': this.ticket[indexId].businessflow
              }

            });

            if (this.selectedReasonObj.text == 'Arrange delivery' || this.selectedReasonObj.text == 'Arrange pickup' ||
              (this.selectedReasonObj.text == 'Non Behavioral' && this.selectedSubReasonObj.text == 'Delay in service') ||
              (this.selectedReasonObj.text == 'SR related' && this.selectedSubReasonObj.text == 'Fake update')) {

              this.ticketExistedData[indexId].shippingData.reattemptdate = this.ticket[indexId].reattemptdate;
            }

            if (this.selectedSubReasonObj.text == 'Change RTO address' || this.selectedSubReasonObj.text == 'Change DTO address' ||
              this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Change Pickup address' || this.selectedSubReasonObj.text == 'Change delivery address as per Client' ||
              this.selectedSubReasonObj.text == 'Redirect to Bank' || this.selectedSubReasonObj.text == 'Change misroute pincode') {

              this.ticketExistedData[indexId].shippingData.name = this.ticket[indexId].name;
              this.ticketExistedData[indexId].shippingData.address = this.ticket[indexId].address;
              this.ticketExistedData[indexId].shippingData.pincode = this.ticket[indexId].pincode;
            }

            if (this.selectedSubReasonObj.text == 'Change payment mode / amount') {

              this.ticketExistedData[indexId].shippingData.ordertype = this.ticket[indexId].ordertype;
              this.ticketExistedData[indexId].shippingData.netpayment = this.ticket[indexId].netpayment;
            }

            if (this.selectedReasonObj.text == 'Update Contact Details' && this.selectedSubReasonObj.text == 'Update Alternate Contact No') {

              this.ticketExistedData[indexId].shippingData.alternatecontactnumber = this.ticket[indexId].alternatecontactnumber;
            }

            if (this.selectedReasonObj.text == 'Update Contact Details' && this.selectedSubReasonObj.text == 'Update Email Address') {

              this.ticketExistedData[indexId].shippingData.emailaddress = this.ticket[indexId].emailaddress;
            }
          }
          i++;
        }
      } else {
        for (let indexId in this.ticket) {
          if (this.ticketIDS.indexOf(this.ticket[indexId].ticketid) >= 0) {

            this.ticketIDS.splice(this.ticketIDS.indexOf(this.ticket[indexId].ticketid), 1);
            this.ticketExistedData.splice(this.ticketExistedData.findIndex(o => o.index == this.ticket[indexId].indexId), 1);
          }
        }
      }

    },
    /* Start IVRCallRecording functionality*/

    getAccessToIVRCallRecording() {
      var permissiondataEncrypt = window.localStorage.getItem('permissiondata');
      var bytes = CryptoJS.AES.decrypt(permissiondataEncrypt.toString(), 'Key');
      var plaintext = bytes.toString(CryptoJS.enc.Utf8);
      var permissiondata = JSON.parse(plaintext);
      let trackshipmentArr = permissiondata.filter(function (val) {
        return val.url == "/b2b/trackshipment";
      });
      let childrenArr = trackshipmentArr[0].children;

      if (childrenArr.some(rowObj => rowObj.url == "/IVRCallRecording")) {
        this.IVRCallRecording.IVRCallRecordingBtn = true;
      } else {
        this.IVRCallRecording.IVRCallRecordingBtn = false;
        // console.log("No access to IVR Call Recording - Object not found." + JSON.stringify(childrenArr));
      }

      // IVRCallPatching Access
      if (childrenArr.some(rowObj => rowObj.url == "/SIP Trunk") || childrenArr.some(rowObj => rowObj.url == "/GSM Gateway")) {
        this.IVRCallRecording.IVRCallPatchingBtn = true;
      } else {
        this.IVRCallRecording.IVRCallPatchingBtn = false;
        console.log("Component Base access trackshipmentsummary" + JSON.stringify(childrenArr));
      }
      // {"id":"427","name":"SIP Trunk","url":"/SIP Trunk","icons":"SIP Trunk","sequence":1,"ismenu":false,"parentid":174,"children":[]},{"id":"428","name":"GSM Gateway","url":"/GSM Gateway","icons":"GSM Gateway","sequence":2,"ismenu":false,"parentid":174,"children":[]},{"id":"648","name":"IVR Call Recording","url":"/IVRCallRecording","icons":"IVRCallRecording","sequence":3,"ismenu":true,"parentid":174,"children":[]}]

    },

    showIVRCallRecordingModal() {
      try {
        this.IVRCallRecording.IVRCallRecordingArr = [];
        //  let ShippingID = this.ShippingID;
        let ShippingID = 11120514030;
        this.isLoadingCurrentStatusDiv = true;
        axios({
            method: 'GET',
            url: apiUrl.crmivr_url + 'DownloadRecordings.php?ShippingID=' + ShippingID,
            // data: "fromDate=" + date + "&toDate=" + date,
            headers: commonFunction.getusertoken(),
            datatype: 'json',
          })
          .then(result => {
            this.isLoadingCurrentStatusDiv = false;
            let resultDataCrm = result.data;
            if (resultDataCrm.ReturnCode == 100) {
              let resultData = resultDataCrm.result;
              this.IVRCallRecording.IVRCallRecordingArr = resultData;
              this.IVRCallRecording.IVRCallRecordingModal = true;

            } else {
              let msg = resultDataCrm.ReturnMessage;
              this.$alertify.error(msg);
            }
          }, error => {
            this.isLoadingCurrentStatusDiv = false;
            var commonVariable = commonFunction.showNetworkError(error);
            this.$alertify.error(commonVariable);
          });
      } catch (error) {
        this.isLoadingCurrentStatusDiv = false;
        let msg = error + " - showIVRCallRecordingModal";
        this.$alertify.error(msg);
      }
    },

    // Start Modal Logic end
    getIVRCallRecordingUrlModal(id) {
      try {
        this.IVRCallRecording.AudioUrl = null;
        // Modal Logic
        this.IVRCallRecording.IVRCallRecordingModal = false;
        // console.log("getIVRCallRecordingUrl id " + id);

        this.isLoadingCurrentStatusDiv = true;
        axios({
            method: 'POST',
            url: apiUrl.crmivr_url + 'GetRecordingURL.php?uniqueid=' + id,
            //   data: "fromDate=" + date + "&toDate=" + date,
            headers: commonFunction.getusertoken(),
            datatype: 'json',
          })
          .then(result => {
            this.isLoadingCurrentStatusDiv = false;
            let resultDataCrm = result.data;
            if (resultDataCrm.ReturnCode == 100) {
              let AudioUrl = resultDataCrm.result;

              // Modal Logic
              if (AudioUrl) {
                this.IVRCallRecording.AudioUrl = AudioUrl;
                this.IVRCallRecording.IVRCallRecordingUrlModal = true;

              } else {
                this.IVRCallRecording.AudioUrl = null;
                this.isLoadingCurrentStatusDiv = false;
                let msg = "Url is not provided.";
                this.$alertify.error(msg);

              }
              // Modal Logic end

            } else {
              this.isLoadingCurrentStatusDiv = false;
              let msg = resultDataCrm.ReturnMessage;
              this.$alertify.error(msg);
            }
          }, error => {
            this.isLoadingCurrentStatusDiv = false;
            var commonVariable = commonFunction.showNetworkError(error);
            this.$alertify.error(commonVariable);
          });
      } catch (error) {
        this.isLoadingCurrentStatusDiv = false;
        let msg = error + " - getIVRCallRecordingUrl";
        this.$alertify.error(msg);
      }
    },


    // New window logic
    getIVRCallRecordingUrl(id) {
      try {
        this.IVRCallRecording.AudioUrl = null;
        // console.log("getIVRCallRecordingUrl id " + id);

        axios({
            method: 'POST',
            url: apiUrl.crmivr_url + 'GetRecordingURL.php?uniqueid=' + id,
            //   data: "fromDate=" + date + "&toDate=" + date,
            headers: commonFunction.getusertoken(),
            datatype: 'json',
          })
          .then(result => {
            this.isLoadingCurrentStatusDiv = false;
            let resultDataCrm = result.data;
            if (resultDataCrm.ReturnCode == 100) {
              let AudioUrl = resultDataCrm.result;

              // new window Logic
              if (AudioUrl) {
                window.open(AudioUrl, "_blank");
              } else {
                this.isLoadingCurrentStatusDiv = false;
                let msg = "Url is not provided.";
                this.$alertify.error(msg);
              }

            } else {
              this.isLoadingCurrentStatusDiv = false;
              let msg = resultDataCrm.ReturnMessage;
              this.$alertify.error(msg);
            }
          }, error => {
            this.isLoadingCurrentStatusDiv = false;
            var commonVariable = commonFunction.showNetworkError(error);
            this.$alertify.error(commonVariable);
          });
      } catch (error) {
        this.isLoadingCurrentStatusDiv = false;
        let msg = error + " - getIVRCallRecordingUrl";
        this.$alertify.error(msg);
      }
    },

    closeIVRCallRecordingUrlModal() {
      this.IVRCallRecording.IVRCallRecordingUrlModal = false;
      this.IVRCallRecording.IVRCallRecordingModal = true;
    },

    sorArrtByDate: function (arr) {
      // Set slice() to avoid to generate an infinite loop!
      return arr.slice().sort(function (a, b) {

        var date = a.CreatedDate;
        var parts = date.split("-");
        var convertedDate = `${parts[1]}-${parts[0]}-${parts[2]}`
        var convertedDatetimeA = new Date(convertedDate);

        var dateB = b.CreatedDate;
        var partsB = dateB.split("-");
        var convertedDateB = `${partsB[1]}-${partsB[0]}-${partsB[2]}`;
        var convertedDatetimeB = new Date(convertedDateB);
        return convertedDatetimeB - convertedDatetimeA;

        //  return new Date(moment(String(b.CreatedDate)).format('YYYY-MM-DD hh:mm:ss')) - new Date(moment(String(a.CreatedDate)).format('YYYY-MM-DD hh:mm:ss'));
      });
    },

    async getIVRCallRecordingData() {
      try {

        //  let ShippingID = this.ShippingID;
        let ShippingID = 1367020713537; //1367020713537;
        // this.isLoadingCurrentStatusDiv = true;
        axios({
            method: 'GET',
            url: apiUrl.crmivr_url + 'DownloadRecordings.php?ShippingID=' + ShippingID,
            datatype: 'json',
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            //   this.isLoadingCurrentStatusDiv = false;
            let resultDataCrm = result.data;
            if (resultDataCrm.ReturnCode == 100) {
              let resultData = resultDataCrm.result;

              let i = 0;
              let resultDataCnt = resultData.length;
              for (i = 0; i < resultDataCnt; i++) {
                let CreatedDate = moment(String(resultData[i].calldate)).format('DD-MM-YYYY hh:mm:ss');
                let resultDataObj = {
                  "Status": "",
                  "ShipmentStatus:": "",
                  "ClientID": 0,
                  "ProcessCode": resultData[i].uniqueid,
                  "Comments": "Call Duration : " + resultData[i].duration,
                  "CurrentHubName": null,
                  "UserProcess": resultData[i].UserProcess,
                  "ProcessLocation": null,
                  "CreatedDate": CreatedDate,
                  "UserName": "Call Recording",
                  "ClientBusinessAccountId": 0
                };

                this.ShipmentLog.ShipmentLogBarArr.push(resultDataObj);

              }



              // this.ShipmentLog.ShipmentLogBarArr.sort(function(a,b){
              //   // Turn your strings into dates, and then subtract them
              //   // to get a value that is either negative, positive, or zero.
              //  var date=a.CreatedDate;
              //   var parts = date.split("-");
              //   var convertedDate = `${parts[1]}-${parts[0]}-${parts[2]}`;
              //   var convertedDatetimeA = new Date(convertedDate);

              //   var dateB=b.CreatedDate;
              //   var partsB = dateB.split("-");
              //    var convertedDateB = `${partsB[1]}-${partsB[0]}-${partsB[2]}`;
              //    var convertedDatetimeB = new Date(convertedDateB);

              //   return convertedDatetimeB - convertedDatetimeA;
              // });



            } else {
              let msg = resultDataCrm.ReturnMessage;
              //  this.$alertify.error(msg);
            }
          }, error => {
            //   this.isLoadingCurrentStatusDiv = false;
            var commonVariable = commonFunction.showNetworkError(error);
            this.$alertify.error(commonVariable);
          });
      } catch (error) {
        // this.isLoadingCurrentStatusDiv = false;
        let msg = error + " - getIVRCallRecordingData";
        this.$alertify.error(msg);
      }
    },

    /* End IVRCallRecording functionality*/


    showMultipleProductInfoModal() {
      this.MultipleProductInfo.MultipleProductInfoModal = true;
    },


    resetTrackshipmentsummary() {
      this.ShippingID = "";
      this.OtherShipmentShippingIDCheckedArr = [];
      this.UnCategorizedArrData = [];
      // Hide all main Div
      this.BagNumberTypeMainDiv = false;
      this.ShippingIDTypeMainDiv = false;
      this.MobileNumberTypeMainDiv = false;
      this.RaiseTicketDiv = false;
      let dataObj = {
        "value": "ParentAWB",
        "text": "Parent AWB"
      };
      this.selectTypeOption(dataObj);
    },


    resetShippingDetails() {
      this.ShippingID = "";
      this.$refs.RefShippingID.focus();
    },

    // Start c EDD PDD From Old Sytem
    // getEDDPDD() {

    //   try {
    //     this.isLoading = true;
    //     this.input = ({
    //       "ShippingID": this.ShippingID,
    //     })
    //     axios({
    //         method: 'POST',
    //         'url': apiUrl.api_url + 'getEDDPDD',
    //         'data': this.input
    //       })
    //       .then(result => {
    //         this.isLoading = false;
    //         let resultDataCrm = result.data.data;
    //         if (resultDataCrm.status) {
    //           let resultData = result.data.data.data;

    //           if (resultData.ReturnCode == 100) {
    //             this.SalesDemo.EDD = (resultData.listShipmentEDDPDD[0].EDD != "null" && resultData.listShipmentEDDPDD[0].EDD != "") ? resultData.listShipmentEDDPDD[0].EDD : null;
    //             this.SalesDemo.PDD = (resultData.listShipmentEDDPDD[0].PDD != "null" && resultData.listShipmentEDDPDD[0].PDD != "") ? resultData.listShipmentEDDPDD[0].PDD : null;
    //           } else {
    //             let msg = resultData.EDDPDDReturnMessage;
    //             //  this.$alertify.error(msg);
    //           }
    //         } else {
    //           let msg = resultDataCrm.msg;
    //           // this.$alertify.error(msg);
    //         }
    //       }, error => {
    //         this.isLoading = false;
    //         let msg = error;
    //         this.$alertify.error(msg);
    //       })
    //   } catch (error) {
    //     this.isLoading = false;
    //     let msg = error + " - getEDDPDD";
    //     this.$alertify.error(msg);
    //   }
    // },

    //Start SendSMS functionality
    getSMSReason() {

      this.SendSMS.ReasonArr = [];
      if (this.SalesDemo.BusinessFlow === 'Forward') {
        this.SendSMS.ReasonArr.push({
          'value': 'NORESPONSE_CUSTOMER_INTIMATION',
          'text': 'No Response'
        });
        this.SendSMS.ReasonArr.push({
          'value': 'XB_COLLECT_ORDER',
          'text': 'Self Collect'
        });
      } else if (this.SalesDemo.BusinessFlow === 'Reverse') {
        this.SendSMS.ReasonArr.push({
          'value': 'NORESPONSE_CUSTOMER_INTIMATION',
          'text': 'No Response'
        });
      }

    },

    selectedSMSReason(SelectedData) {
      try {
        this.SendSMS.SelectedReasonObj.text = SelectedData.text;
        this.SendSMS.SelectedReasonObj.value = SelectedData.value;
        this.SendSMS.Reason = SelectedData.value;
        this.SendSMS.ActualSMSCode = SelectedData.value;
        this.getSMSTextByActualSMSCode();
      } catch (error) {
        let msg = error + " - selectedSMSReason";
        this.$alertify.error(msg);
      }
    },

    sendSMSToNumber() {
      try {
        this.SendSMS.SMSData = [];
        this.isLoading = true;
        let Message = this.SendSMS.Message;
        let ActualSMSCode = this.SendSMS.ActualSMSCode;

        if (ActualSMSCode === "XB_COLLECT_ORDER") {
          this.SendSMS.SMSData.push(this.ShippingID);
          this.SendSMS.SMSData.push(null);
          this.SendSMS.SMSData.push(this.ShippingID);
          this.SendSMS.SMSData.push(null);
        } else if (ActualSMSCode === "NORESPONSE_CUSTOMER_INTIMATION") {
          this.SendSMS.SMSData.push(this.SalesDemo.ClientName);
          this.SendSMS.SMSData.push("test");
          this.SendSMS.SMSData.push(this.ShippingID);
          this.SendSMS.SMSData.push("test");
        }

        this.input = ({
          "MobileNumber": this.CustomerDetails.PhoneNo,
          "SMSID": this.SendSMS.ActualSMSCode,
          "SMSData": this.SendSMS.SMSData,
          "SendSMSKey": this.SendSMS.SendSMSKey,
          //   "ClientID": this.ShipmentTransactionLogSummary.ClientID,
          "ClientID": this.ShippingID,

        });

        let token = "";
        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'sendSMSToNumber',
          'data': this.input,
          headers: commonFunction.getusertoken(),
        }).then(result => {
          this.isLoading = false;
          let resultDataCrm = result.data.data;
          if (resultDataCrm.status) {
            let resultData = result.data.data.data;
            if (resultData.code === 200) {
              this.closeBModalCommonFunction('SendSMSModal');
              // let msg = resultData.message;
              let msg = this.CustomerDetails.PhoneNoDisplay + " - Message sent successfully";
              this.$alertify.success(msg);
            } else {
              let msg = resultData.message;
              this.$alertify.error(msg);
            }
          } else {
            let msg = resultDataCrm.msg;
            this.$alertify.error(msg);
          }
        }, error => {
          this.isLoading = false;
          let msg = error;
          this.$alertify.error(msg);
        })
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - sendSMSToNumber";
        this.$alertify.error(msg);
      }
    },

    handleSubmitForSendSMS(e) {
      try {
        this.SendSMS.submitted = true;
        this.$validator.validate().then(valid => {
          if (valid) {
            if (this.SalesDemo.ShipmentStatus !== "InScan" && this.SalesDemo.Status !== "Shipped") {
              let msg = "Shipment is not in desired status to send SMS.";
              this.$alertify.error(msg);
              return false;
            } else if (this.SendSMS.Reason === "") {
              let msg = "Please select Reason.";
              this.$alertify.error(msg);
              return false;
            } else if (this.SendSMS.Message === "") {
              let msg = "Please select message.";
              this.$alertify.error(msg);
              return false;
            }
            this.sendSMSToNumber();
          } else {
            let msg = "Validation Error - handleSubmitForSendSMS";
            this.$alertify.error(msg);
            return false;
          }
        });
      } catch (error) {
        let msg = error + " - handleSubmitForSendSMS";
        this.$alertify.error(msg);
      }
    },

    getSMSTextByActualSMSCode() {
      this.isLoading = true;
      let ActualSMSCode = this.SendSMS.ActualSMSCode;
      this.SendSMS.SendSMSArr = [];
      this.SendSMS.SelectedSendSMSObj = {
        value: '',
        text: ''
      };

      this.input = ({
        'actualsmscode': ActualSMSCode,
      });
      let token = "";
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getSMSTextByActualSMSCode',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        this.isLoading = false;
        let resultDataCrm = result.data.data;
        if (resultDataCrm.status) {
          let resultData = result.data.data.data;
          if (resultData.code === 200) {
            if (ActualSMSCode === "NORESPONSE_CUSTOMER_INTIMATION") {
              let SendSMSArrData = resultData.data
              this.SendSMS.SendSMSArr.push({
                'value': SendSMSArrData,
                'text': SendSMSArrData
              });

              this.SendSMS.SelectedSendSMSObj = this.SendSMS.SendSMSArr[0];
              this.SendSMS.Message = this.SendSMS.SelectedSendSMSObj.value;
            } else {
              let SendSMSArr = resultData.data;
              let ArrCnt = SendSMSArr.length;
              if (ArrCnt > 0) {
                for (let i = 0; i < ArrCnt; i++) {
                  this.SendSMS.SendSMSArr.push({
                    'value': SendSMSArr[i].smstext,
                    'text': SendSMSArr[i].smstext
                  });
                  MultipleProductInfoModal
                }
                this.SendSMS.SelectedSendSMSObj = this.SendSMS.SendSMSArr[0];
                this.SendSMS.Message = this.SendSMS.SelectedSendSMSObj.value;
              }
            }
          } else {
            this.isLoading = false;
            let msg = resultData.message;
            this.$alertify.error(msg);
          }
        } else {
          this.isLoading = false;
          let msg = resultDataCrm.msg;
          this.$alertify.error(msg);
        }
      }, error => {
        this.isLoading = false;
        let msg = error;
        this.$alertify.error(msg);
      })
    },


    openSendSMSModal() {
      try {
        this.resetSendSMSModalData();
        //  this.getSMSTextByActualSMSCode();
        this.getSMSReason();
        this.SendSMS.SendSMSModal = true;
      } catch (error) {
        this.SendSMS.SendSMSModal = false;
        let msg = error + " - openSendSMSModal";
        this.$alertify.error(msg);
      }
    },

    resetSendSMSModalData() {
      this.SendSMS.SendSMSArr = [];
      this.SendSMS.SelectedSendSMSObj = {
        value: '',
        text: ''
      };
      this.SendSMS.Message = "";
      this.SendSMS.ReasonArr = [];
      this.SendSMS.SelectedReasonObj = {
        value: '',
        text: ''
      };
      this.SendSMS.Reason = "";
      this.SendSMS.ActualSMSCode = ""; // Reason = ActualSMSCode
    },
    //End SendSMS functionality

    OpenCallPatchingModel(mobileNumber, altMobileNumber, customerName, addressType, businessType = "B2B") {

      try {
        this.CallTypeOptionObj = [];
        var permissiondataEncrypt = window.localStorage.getItem('permissiondata')
        var bytes = CryptoJS.AES.decrypt(permissiondataEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var permissiondata = JSON.parse(plaintext);

        let trackshipmentsummaryArr = permissiondata.filter(function (val) {
          return val.url == "b2b/trackshipment";
        });

        if (trackshipmentsummaryArr.length > 0 && trackshipmentsummaryArr[0].children) {
          //GSM Gateway SIP Trunk
          let SIPTrunk = trackshipmentsummaryArr[0].children.filter(function (val) {
            return val.name == "SIP Trunk";
          });

          if (SIPTrunk.length != 0) {
            this.CallTypeOptionObj.push("SIP Trunk");
            this.CallType = "SIP Trunk";
          }

          let GSMGateway = trackshipmentsummaryArr[0].children.filter(function (val) {
            return val.name == "GSM Gateway";
          });

          if (GSMGateway.length != 0) {
            this.CallTypeOptionObj.push("GSM Gateway");
          }
        } else {
          // Default to SIP Trunk if permissions not found
          this.CallTypeOptionObj.push("SIP Trunk");
          this.CallType = "SIP Trunk";
        }

        this.Callpatching.Name = customerName;
        this.Callpatching.optNumberType = 1;
        this.Callpatching.addressType = addressType;
        this.Callpatching.mobileNumber = mobileNumber;
        this.Callpatching.altMobileNumber = altMobileNumber;
        this.Callpatching.businessType = businessType;
        this.Callpatching.CallPatchingModal = true;
      } catch (error) {
        this.Callpatching.CallPatchingModal = false;
        let msg = error + " - OpenCallPatchingModel";
        this.$alertify.error(msg);
      }

    },

    async MakeCall() {
      try {
        if (this.ShippingID === '') {
          this.$alertify.error('Shipping id not found');
          return false;
        }
        if (!this.mobileNumber || this.mobileNumber === '') {
          this.$alertify.error('Agent mobile number not found.');
          return false;
        }
        var customerMobile = '';
        if (this.Callpatching.optNumberType == '1') {
          if (!this.Callpatching.mobileNumber) {
            this.$alertify.error('Primary mobile number not found.');
            return false;
          } else {
            customerMobile = this.Callpatching.mobileNumber;
          }
        } else if (this.Callpatching.optNumberType == '2') {
          if (!this.Callpatching.altMobileNumber) {
            this.$alertify.error('Alternate mobile number not found , Please try with Primary number.');
            return false;
          } else {
            customerMobile = this.Callpatching.altMobileNumber;
          }
        } else {
          this.$alertify.error('Please select mobile number type.');
          return false;
        }

        this.isLoading = true;
        this.input = ({
          'customernumber': customerMobile,
          'agentnumber': this.mobileNumber,
          'email': this.email,
          'shippingid': this.ShippingID,
          'clientid': this.ShipmentTransactionLogSummary.ClientID,
          'businessType':'B2B',
          'AdminID': this.userid,        //#self_service B2B Flow
          'hubid': this.ShipmentTransactionLogSummary.CurrentHubID       //#self_service B2B Flow
        });

        if (this.CallType == "GSM Gateway") {
          await axios({
              method: 'POST',
              url: apiUrl.crmivr_url + 'CRM_Call_Bridge.php?customernumber=' + this.input.customernumber + '&agentnumber=' + this.input.agentnumber,
              datatype: 'json',
            })
            .then(result => {
              this.isLoading = false;
              if (result.data.ReturnCode == 100) {
                this.$alertify.success("Call is in processing", 20);
              } else {
                let msg = result.data.ReturnMessage;
                this.$alertify.error(msg);
              }
            }, error => {
              this.isLoading = false;
              console.log(error);
              let msg = JSON.stringify(error);
              this.$alertify.error(msg);
            });
        }  else if (this.CallType == "SIP Trunk") {
          await axios({
            method: "POST",
            url: apiUrl.api_url + "makecall",
            data: this.input,
            headers: commonFunction.getusertoken(),
          }).then(result => {
              let resultDataCrm = result.data;
              if (resultDataCrm.status === "false") {
                let msg = resultDataCrm.msg;
                this.$alertify.error(msg);
              } else {
                this.$alertify.success("Call is in processing", 20);
              }
              this.isLoading = false;
            }, error => {
              console.log(error);
              let msg = JSON.stringify(error);
              this.$alertify.error(msg);
              this.isLoading = false;
            });
        } else {
          this.isLoading = false;
          this.$alertify.error("Call type not available!");
        }
      } catch (error) {
        this.Callpatching.CallPatchingModal = false;
        let msg = error + " - MakeCall";
        this.$alertify.error(msg);
      }

    },

    handleSubmitForSearch(e) {
      this.submitted = true;
      this.OtherShipmentShippingIDCheckedArr = [];
      this.UnCategorizedArrData = [];
      this.$validator.validate().then(valid => {
        if (valid) {
          this.B2BTrackShipment();
          this.resetForm();
        }
      });
    },

    trackShipmentDetails(ShippingID) {
      this.ShippingID = ShippingID;
      this.B2BTrackShipment();
      this.resetForm();
      window.scrollTo(0, 0);
    },

    myPopupFunction() {
      var popup = document.getElementById("myPopup");
      popup.classList.toggle("show");
    },

    openmap() {
      try {
        let srid = (this.OrderDetails.srLocationDetails.srid) ? this.OrderDetails.srLocationDetails.srid : 0;
        if (!srid) {
          this.$alertify.error('Trip is not started Or already closed by user');
          return false;
        }
        this.OrderDetails.googleInitialiseData = {
          latitude: 18.545885,
          longitude: 73.908419
        }
        this.locationMapModal = true;
        google.maps.event.addDomListener(window, "load", this.initialize());
      } catch (error) {
        this.locationMapModal = false;
        let msg = error + " - openmap";
        this.$alertify.error(msg);
      }
    },

    initialize() {
      var directionsService = new google.maps.DirectionsService;
      var directionsDisplay = new google.maps.DirectionsRenderer({
        //    suppressMarkers: true
      });
      var loc = [];
      var markerstore = {};

      var centerltlng = {
        lat: parseFloat(this.OrderDetails.googleInitialiseData.latitude),
        lng: parseFloat(this.OrderDetails.googleInitialiseData.longitude)
      }

      this.map[this.ShippingID] = new google.maps.Map(document.getElementById('map' + this.ShippingID), {
        zoom: 12,
        center: centerltlng
      });
      directionsDisplay.setOptions({
        polylineOptions: {
          strokeColor: 'black'
        }
      });
      directionsDisplay.setMap(this.map[this.ShippingID]);
      //console.log(this.OrderDetails.srLocationDetails);
      this.setmarkers(markerstore, directionsService, directionsDisplay, this.OrderDetails.srLocationDetails, this.map);
    },

    setmarkers(markerstore, directionsService, directionsDisplay, data, map) {
      var locationall = [];
      locationall.push(data);

      var infowindow = new google.maps.InfoWindow();
      var markers = locationall.map(function (location, i) {
        var symbol = {
          path: 'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z',
          scale: .7,
          strokeColor: 'white',
          strokeWeight: .10,
          fillOpacity: 1,
          fillColor: '#800000',
          offset: '5%',
          rotation: 90,
          anchor: new google.maps.Point(10, 25)
        }
        if (data.vehicletype == "bike")
          symbol = {
            url: '../../static/img/scooter.svg',
            anchor: new google.maps.Point(10, 25),
            size: new google.maps.Size(50, 50)
          };
        var markerone = new google.maps.Marker({
          position: new google.maps.LatLng(data.latitude, data.longitude),
          icon: symbol,
          optimized: false
        });

        google.maps.event.addListener(markerone, 'click', function (evt) {
          infowindow.setContent(data.location);
          infowindow.open(map[this.ShippingID], markerone);
        });
        markerstore[location.uid] = markerone;
        return markerone;
      });

      var markerCluster = new MarkerClusterer(map[this.ShippingID], markers, {
        imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'
      });
      //this.showroute(data, directionsService, directionsDisplay);
    },
    //  closeBagShipmentDetailsModal



    //  showBagShipmentDetailsModal
    showBagShipmentDetailsModal() {
      try {
        this.BagNoObj.BagShipmentDetailsModal = false;
        this.BagNoObj.BagShipmentDetailsArr = [];
        if (this.ShippingID === '') {
          this.$alertify.error('Please enter Bag Number.');
          return false;
        }
        this.isLoading = true;
        this.input = ({
          ShippingID: this.ShippingID
        })
        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'fetchBagShipmentDetailsByBagNumber',
            'data': this.input,
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            this.isLoading = false;
            let resultDataCrm = result.data.data;
            if (resultDataCrm.status) {
              let resultData = result.data.data.data;
              if (resultData.ResultCode === 100) {
                this.BagNoObj.BagShipmentDetailsArr = resultData.ResponseData;
                let BagInShipmentArr = resultData.ResponseData.filter(function (val) {
                  return val.status == "BagIn";
                });
                this.BagNoObj.BagInShipmentCount = BagInShipmentArr.length;
                this.BagNoObj.BagShipmentDetailsModal = true;
              } else {
                let msg = resultData.ReturnMessage;
                this.$alertify.error(msg);
              }
            } else {
              let msg = resultDataCrm.msg;
              this.$alertify.error(msg);
            }
          }, error => {
            let msg = error;
            this.$alertify.error(msg);
          })
      } catch (error) {
        let msg = error + " - showBagShipmentDetailsModal";
        this.$alertify.error(msg);
      }
    },






    // fetchBagTransitDetailsBySelectType
    fetchBagTransitDetailsBySelectType() {
      //  this.BagNoObj.TransitStatusModal = false;
      try {
        //undefinedFunction();
        this.BagNoObj.TransitStatusArr = [];
        if (this.ShippingID === '') {
          this.$alertify.error('Please enter Bag Number.');
          return false;
        }
        this.isLoading = true;
        this.isLoadingCurrentStatusDiv = true;
        this.input = ({
          ShippingID: this.ShippingID,
          SelectType: this.SelectTypeOptionObj.value
        })
        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'fetchBagTransitDetailsBySelectType',
            'data': this.input,
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            this.isLoading = false;
            this.isLoadingCurrentStatusDiv = false;
            let resultDataCrm = result.data.data;
            if (resultDataCrm.status) {
              let resultData = result.data.data.data;
              if (resultData.ResultCode === 100) {
                this.BagNoObj.TransitStatusArr = resultData.ResponseData;
                this.BagNoObj.TransitStatusModal = true;
              } else {
                let msg = resultData.ReturnMessage;
                this.$alertify.error(msg);
              }
            } else {
              let msg = resultDataCrm.msg;
              this.$alertify.error(msg);
            }
          }, error => {
            this.isLoading = false;
            this.isLoadingCurrentStatusDiv = false;
            let msg = error;
            this.$alertify.error(msg);
          })
      } catch (error) {
        this.isLoading = false;
        this.isLoadingCurrentStatusDiv = false;
        let msg = error + " - fetchBagTransitDetailsBySelectType";
        this.$alertify.error(msg);
      }
    },
    // showTransitStatusModal
    showTransitStatusModal() {
      this.fetchBagTransitDetailsBySelectType();
    },
    getPaperWorkTrackingForCLTCRM() {
      try {
        this.BagNoObj.TransitStatusArr = [];
        this.OtherShipmentShippingIDCheckedArr = [];
        if (this.ShippingID === '') {
          this.$alertify.error('Please enter ShippingID.');
          return false;
        }

        this.isLoading = true;
        this.isLoadingCurrentStatusDiv = true;

        let ParentAWB = this.SalesDemo.ParentAWB;
        this.ParentAWBNo = ParentAWB;
        this.input = ({
          "ParentAWB": ParentAWB,
        })
        axios({
            method: 'GET',
            'url': apiUrl.api_url + 'getPaperWorkTrackingForCLTCRM?parentAWB=' + this.ParentAWBNo,
            'data': this.input,
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            this.isLoading = false;
            this.isLoadingCurrentStatusDiv = false;
            let resultDataCrm = result.data.data;
            if (resultDataCrm.status) {
              let resultData = result.data.data.data;

              if (resultData.ResultCode === 100) {
                this.BagNoObj.TransitStatusArr = resultData.ResponseData;
                this.BagNoObj.TransitStatusModal = true;
              } else {
                let msg = resultData.ReturnMessage;
                this.$alertify.error(msg);
              }
            } else {
              let msg = resultDataCrm.msg;
              this.$alertify.error(msg);
            }
          }, error => {
            this.isLoading = false;
            this.isLoadingCurrentStatusDiv = false;
            let msg = error;
            this.$alertify.error(msg);
          })
      } catch (error) {
        this.isLoading = false;
        this.isLoadingCurrentStatusDiv = false;
        let msg = error + " - getPaperWorkTrackingForCLTCRM";
        this.$alertify.error(msg);
      }
    },
    // showPaperWorkModal
    showPaperWorkModal() {
      this.getPaperWorkTrackingForCLTCRM();
    },
    selectTypeOption(dataObj) {
      this.SelectTypeOptionObj = dataObj;
    },

    selectAll: function (e) {
      this.OtherShipmentShippingIDCheckedArr = [];
      let ShippingIDEle;
      if (this.allSelected) {
        var i = 0;
        for (ShippingIDEle in this.AllShipmentLogArrData) {
          this.OtherShipmentShippingIDCheckedArr.push(this.AllShipmentLogArrData[ShippingIDEle].ShippingID.toString());

          if (-1 == this.ticketShipmentData.findIndex(o => o.index == ShippingIDEle)) {
            this.ticketShipmentData.push({
              'index': i,
              'shippingData': {
                'ShippingID': this.AllShipmentLogArrData[ShippingIDEle].ShippingID,
                'CurrentHubID': this.AllShipmentLogArrData[ShippingIDEle].CurrentHubID,
                "TotalAttemptCount": this.AllShipmentLogArrData[ShippingIDEle].TotalAttemptCount,
                "UserProcess": this.AllShipmentLogArrData[ShippingIDEle].UserProcess,
                "NotificationType": this.AllShipmentLogArrData[ShippingIDEle].NotificationType,
                "NotificationStatus": this.AllShipmentLogArrData[ShippingIDEle].NotificationStatus,
                "ClientName": this.AllShipmentLogArrData[ShippingIDEle].ClientName,
                'BusinessFlow': this.AllShipmentLogArrData[ShippingIDEle].BusinessFlow,
                "Status": this.AllShipmentLogArrData[ShippingIDEle].Status,
                "CurrentStatus": this.AllShipmentLogArrData[ShippingIDEle].CurrentStatus,
                "CreatedDate": this.AllShipmentLogArrData[ShippingIDEle].CreatedDate,
                "OrderType": this.AllShipmentLogArrData[ShippingIDEle].OrderType
              }
            });
          }
          i++;
        }
      } else {
        this.OtherShipmentShippingIDCheckedArr = [];
        for (ShippingIDEle in this.AllShipmentLogArrData) {

          this.ticketShipmentData.splice(this.ticketShipmentData.findIndex(o => o.index == ShippingIDEle), 1);

        }
      }
    },

    select: function (selectedObj, index, event) {
      let checkedCounter = 0;
      let isChecked;
      let oneShipmentCheckbox;
      this.AllShipmentLogArrData.forEach(element => {
        oneShipmentCheckbox = document.getElementById(element.ShippingID);
        isChecked = oneShipmentCheckbox.checked;
        if (isChecked == true) {
          checkedCounter = checkedCounter + 1;
        }
      });
      if (this.AllShipmentLogArrData.length === checkedCounter && event.target.checked) {
        this.allSelected = true;
        this.selectAll();
      } else {
        this.allSelected = false;
      }
      // this.allSelected = false;
      if (event.target.checked) {
        //shippingId update by checking shippingID /ParentAWB
        const shippingIDtoUpdate = (this.SelectTypeOptionObj.value === 'ShippingID') ? selectedObj.ShippingID : this.SalesDemo.ParentAWB;
        const existingIndex = this.ticketShipmentData.findIndex(item => item.shippingData.ShippingID === shippingIDtoUpdate);
      
        if (existingIndex !== -1) {
          // ShippingID already exists in the ticketShipmentData, update the shippingData object at the existing index.
          this.ticketShipmentData[existingIndex].shippingData = {
            'ShippingID': shippingIDtoUpdate,
            'CurrentHubID': selectedObj.CurrentHubID,
            "TotalAttemptCount": selectedObj.TotalAttemptCount,
            "UserProcess": selectedObj.UserProcess,
            "NotificationType": selectedObj.NotificationType,
            "NotificationStatus": selectedObj.NotificationStatus,
            "ClientName": selectedObj.ClientName,
            'BusinessFlow': selectedObj.BusinessFlow,
            "Status": selectedObj.Status,
            "CurrentStatus": selectedObj.CurrentStatus,
            "CreatedDate": selectedObj.CreatedDate,
            "OrderType": selectedObj.OrderType
          };
        } else {
          // ShippingID doesn't exist in the ticketShipmentData, push shippingID
          this.ticketShipmentData.push({
            'index': index,
            'shippingData': {
              'ShippingID': shippingIDtoUpdate,
              'CurrentHubID': selectedObj.CurrentHubID,
              "TotalAttemptCount": selectedObj.TotalAttemptCount,
              "UserProcess": selectedObj.UserProcess,
              "NotificationType": selectedObj.NotificationType,
              "NotificationStatus": selectedObj.NotificationStatus,
              "ClientName": selectedObj.ClientName,
              'BusinessFlow': selectedObj.BusinessFlow,
              "Status": selectedObj.Status,
              "CurrentStatus": selectedObj.CurrentStatus,
              "CreatedDate": selectedObj.CreatedDate,
              "OrderType": selectedObj.OrderType
            }
          });
        }
      } else {
        this.ticketShipmentData.splice(this.ticketShipmentData.findIndex(o => o.index == index), 1);
       
      }
    },

    check: function (e) {
      if (e.target.checked) {

      }
    },

    selectedOptionObj: function (selectedObj) {
      this.resetForm();
      this.ticketShipmentData = [];
      this.AllShipmentLogArrData = [];

      let arrShipStatus = [];

      this.categoryOptionObj.text = this.categoryOptionObj.value = selectedObj.text;

      if ('Unidentified' == selectedObj.text && undefined != this.UnCategorizedArrData) {
        this.AllShipmentLogArrData = this.UnCategorizedArrData;

      } else {
        //this.UnCategorizedArrData= [];
        if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Forward') {

          for (let i = 0; i < this.category.Forward.length; i++) {
            if (this.category.Forward[i].name == selectedObj.value) {
              arrShipStatus.push(this.category.Forward[i]);
            }
          }
        }
        if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Reverse') {

          for (let i = 0; i < this.category.Reverse.length; i++) {

            if (this.category.Reverse[i].name == selectedObj.value) {
              arrShipStatus.push(this.category.Reverse[i]);
            }
          }
        }

        if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Forward') {

          for (let i = 0; i < this.OtherShipmentLogArr.length; i++) {

            let status = this.OtherShipmentLogArr[i].Status;

            let shipmentStatus = this.OtherShipmentLogArr[i].CurrentStatus;

            for (let j = 0; j < arrShipStatus.length; j++) {

              let otherStatus = arrShipStatus[j].Status;

              let otherShipmentStatus = arrShipStatus[j].ShipmentStatus;

              if (status.toLowerCase() === otherStatus.toLowerCase() && shipmentStatus.toLowerCase() == otherShipmentStatus.toLowerCase()) {
                this.AllShipmentLogArrData.push(this.OtherShipmentLogArr[i]);
              }
            }
          }
        }

        if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Reverse') {

          for (let i = 0; i < this.OtherShipmentLogArr.length; i++) {

            for (let j = 0; j < arrShipStatus.length; j++) {

              if (this.OtherShipmentLogArr[i].Status.toLowerCase() == arrShipStatus[j].Status.toLowerCase() &&
                this.OtherShipmentLogArr[i].CurrentStatus.toLowerCase() == arrShipStatus[j].ShipmentStatus.toLowerCase()) {

                this.AllShipmentLogArrData.push(this.OtherShipmentLogArr[i]);
              }
            }
          }
        }

      }

      if (this.AllShipmentLogArrData.length == 0 && 'Unidentified' == selectedObj.text && this.UnCategorizedArrData.length > 0) {

        this.AllShipmentLogArrData = this.UnCategorizedArrData;
      }
      let shipmentIndex = this.AllShipmentLogArrData.findIndex(o => o.ShippingID == this.ShippingID);

      if (-1 !== shipmentIndex && -1 === this.ticketShipmentData.findIndex(o => o.ShippingID == this.ShippingID)) {
        this.ticketShipmentData.push({
          'index': shipmentIndex,
          'shippingData': {
            'ShippingID': this.AllShipmentLogArrData[shipmentIndex].ShippingID,
            'CurrentHubID': this.AllShipmentLogArrData[shipmentIndex].CurrentHubID,
            "TotalAttemptCount": this.AllShipmentLogArrData[shipmentIndex].TotalAttemptCount,
            "UserProcess": this.AllShipmentLogArrData[shipmentIndex].UserProcess,
            "NotificationType": this.AllShipmentLogArrData[shipmentIndex].NotificationType,
            "NotificationStatus": this.AllShipmentLogArrData[shipmentIndex].NotificationStatus,
            "ClientName": this.AllShipmentLogArrData[shipmentIndex].ClientName,
            'BusinessFlow': this.AllShipmentLogArrData[shipmentIndex].BusinessFlow,
            "Status": this.AllShipmentLogArrData[shipmentIndex].Status,
            "CurrentStatus": this.AllShipmentLogArrData[shipmentIndex].CurrentStatus,
            "CreatedDate": this.AllShipmentLogArrData[shipmentIndex].CreatedDate,
            "OrderType": this.AllShipmentLogArrData[shipmentIndex].OrderType
          }
        });

        let eleRemoved = this.AllShipmentLogArrData.splice(shipmentIndex, 1);
        this.AllShipmentLogArrData.unshift(eleRemoved[0]);
        this.OtherShipmentShippingIDCheckedArr.push(this.ShippingID);
      }
       this.ShowRaiseTicketDiv()
    },
    // B2BTrackShipment
    B2BTrackShipment() {
      try {
        this.OtherShipments.DeliveredCnt = 0;
        this.OtherShipments.RTOCnt = 0;
        this.OtherShipments.UndeliverdCnt = 0;
        this.OtherShipments.chartData.data = {};
        this.OtherShipmentLogArr = [];
        this.OtherShipmentShippingIDCheckedArr = [];

        // Hide all main Div
        this.BagNumberTypeMainDiv = false;
        this.ShippingIDTypeMainDiv = false;
        this.MobileNumberTypeMainDiv = false;
        this.RaiseTicketDiv = false;
        this.POIDTypeMainDiv = false;


        if (this.ShippingID === '') {
          this.$alertify.error('Please enter Shipping ID.');
          return false;
        }
        this.ShippingID = this.ShippingID.trim();
        this.BagNoObj.TransitStatusModal = false;
        this.displayCurrentLocation = '';
        this.deliveryUserID = '';

        // SearchType Handling
        let SearchType = null
        if (this.SelectTypeOptionObj.value === 'ShippingID') {
          SearchType = "ChildAWB";
        } else if (this.SelectTypeOptionObj.value === 'ParentAWB') {
          SearchType = "ParentAWB";
        } else {
          SearchType = null;
        }
        this.SearchType = SearchType;

        let token = 'c423ed60f34c0021016fc65cb53a9ad4';
        let versionNumber = 'v1';
        this.input = ({
          'ShippingID': this.ShippingID,
          'SearchType': SearchType
        })
        this.isLoading = true;
        axios({
            'method': 'POST',
            'url': apiUrl.api_url + 'B2BTrackShipment',
            'data': this.input,
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            this.isLoading = false;
            let resultDataCrm = result.data.data;
            if (resultDataCrm.status) {
              let resultData = result.data.data.data;
              if (resultData.ReturnCode === 100) {
                // call GetB2BTrackLogs

                this.GetB2BTrackLogs();
                let resultDataFinal = resultData.ShipmentDetails;
                this.ShipmentStatus=resultDataFinal.ShipmentDetails.ShipmentStatus

                
                this.SalesDemo = resultDataFinal.ShipmentDetails;
                if(resultDataFinal && resultDataFinal.MpsBoxCount ){
                  this.SalesDemo.MPSBoxCount=resultDataFinal.MpsBoxCount;
                }else{
                  this.SalesDemo.MPSBoxCount=''
                }
                this.SalesDemo.ShippingID = resultDataFinal.ShippingID;
                
                this.SalesDemo.ClientType = resultDataFinal.ClientType;      // b2b_restrict_rto_client
                this.SalesDemo.PartialStatus = resultDataFinal.PartialStatus;  //#b2b_partial_rto

                this.PickupAddress = resultDataFinal.PickupAddress.Addresses[0];
                this.PickupAddressContactDetails = resultDataFinal.PickupAddress.ContactDetails[0];
                
                // Mask phone numbers for display
                if (this.PickupAddressContactDetails.PhoneNo) {
                  this.PickupAddressContactDetails.PhoneNoDisplay = this.displayPhoneNoPattern(this.PickupAddressContactDetails.PhoneNo);
                }
                if (this.PickupAddressContactDetails.PhoneNoAlt) {
                  this.PickupAddressContactDetails.PhoneNoAltDisplay = this.displayPhoneNoPattern(this.PickupAddressContactDetails.PhoneNoAlt);
                }

                // === B2B CRM ALT Instruction Section Start === -- Added PickupTimeSlotWithDate for visibility in trackshipment page
                this.SalesDemo.PickupTimeSlotWithDate = (
                  resultDataFinal &&
                  resultDataFinal.PickupTimeSlotWithDate &&
                  resultDataFinal.PickupTimeSlotWithDate !== "null"
                ) 
                  ? resultDataFinal.PickupTimeSlotWithDate
                  : null;
                // === B2B CRM ALT Instruction Section End ===

                this.SalesDemo.EDD = (resultData.ShipmentDetails.ShipmentDetails && resultData.ShipmentDetails.ShipmentDetails.EDD && resultData.ShipmentDetails.ShipmentDetails.EDD != "null") ? resultData.ShipmentDetails.ShipmentDetails.EDD : null;
                this.SalesDemo.PDD = (resultData.ShipmentDetails.ShipmentDetails &&  resultData.ShipmentDetails.ShipmentDetails.PDD && resultData.ShipmentDetails.ShipmentDetails.PDD != "null") ? resultData.ShipmentDetails.ShipmentDetails.PDD : null;
                // Currently We are fetching EDD and PDD from Old system
                // this.SalesDemo.EDD = null;
                // this.SalesDemo.PDD = null;
                // this.getEDDPDD();

                // primary and Secondary in one
                let CustomerDetails;
                if ((this.SalesDemo.IsRedirect || this.SalesDemo.IsRedirectToBank) && this.SalesDemo.RedirectToAddress === 'Secondary') {
                  CustomerDetails = resultDataFinal.CustomerAlternateAddress;
                } else {
                  CustomerDetails = resultDataFinal.CustomerPrimaryAddress;
                }

                // Secondary Address for Banking Client
                this.CustomerAlternateAddress = resultDataFinal.CustomerAlternateAddress;
                this.CustomerDetails = CustomerDetails;
                this.CustomerDetails.CustomerName = CustomerDetails.Name;

                // console.log("🚀 ~ this.CustomerDetails:", this.CustomerDetails)
                
                // #serviceable_other_branch : eligibility from ShipmentDetails.IsServiceableFromOtherBranch
                var shipmentDetailsForServiceability =
                  (resultDataFinal && resultDataFinal.ShipmentDetails) || {};
                this.isServiceableFromOtherBranchPincode = !!(
                  shipmentDetailsForServiceability.IsServiceableFromOtherBranch ||
                  resultDataFinal.IsServiceableFromOtherBranch
                );
                console.log("🚀 ~ isServiceableFromOtherBranchPincode:", this.isServiceableFromOtherBranchPincode)
                this.CustomerDetails.PhoneNo = resultDataFinal.PrimaryPhone.PhoneNo;

                this.CustomerDetails.PhoneNo = resultDataFinal.PrimaryPhone.PhoneNo;
                this.CustomerDetails.PhoneNoDisplay = this.displayPhoneNoPattern(this.CustomerDetails.PhoneNo);
                if (resultDataFinal.SecondaryPhone) {
                  this.CustomerDetails.PhoneNoAlt = resultDataFinal.SecondaryPhone.PhoneNo;
                  this.CustomerDetails.PhoneNoAltDisplay = this.displayPhoneNoPattern(this.CustomerDetails.PhoneNoAlt);
                } else {
                  this.CustomerDetails.PhoneNoAlt = null;
                }

                // For RTO Details
                let RTODetails = resultDataFinal.RTODetailsAddresses.Addresses[0];

                this.RTODetails = RTODetails;
                let AddressStrRTO;
                if (RTODetails.Address === null && RTODetails.City === null) {
                  AddressStrRTO = null;
                } else {
                  AddressStrRTO = RTODetails.Address + ", " + RTODetails.City + "-" + RTODetails.PinCode + ", " + RTODetails.State;
                }
                this.RTODetails.CustomerName = RTODetails.Name;
                this.RTODetails.AddressStr = AddressStrRTO;
                this.RTODetails.Address = RTODetails.Address;
                this.RTODetails.PinCode = RTODetails.PinCode;
                this.RTODetails.EmailID = RTODetails.EmailID;

                let RTODetailsContactDetails = resultDataFinal.RTODetailsAddresses.ContactDetails;
                this.RTODetails.PhoneNo = RTODetailsContactDetails[0].PhoneNo;
                this.RTODetails.PhoneNoDisplay = this.displayPhoneNoPattern(this.RTODetails.PhoneNo);
                if (RTODetailsContactDetails.length > 1) {
                  this.RTODetails.PhoneNoAlt = RTODetailsContactDetails[1].PhoneNo;
                  this.RTODetails.PhoneNoAltDisplay = this.displayPhoneNoPattern(this.RTODetails.PhoneNoAlt);
                } else {
                  this.RTODetails.PhoneNoAlt = null;
                }


                // OFD OR OFP CHecking
                if (this.SalesDemo.BusinessFlow === 'Forward' && (this.SalesDemo.ProcessCode === 'P035' || (this.SalesDemo.Status === 'RTO' && this.SalesDemo.ProcessCode === 'P054' && this.SalesDemo.ReasonCode === 'XBU00302'))) {
                  this.SalesDemo.IsLatestOFD = true;
                } else if (this.SalesDemo.BusinessFlow === 'Reverse' && (this.SalesDemo.ProcessCode === 'P034' || ((this.SalesDemo.Status === 'DTO' || this.SalesDemo.Status === 'Shipped') && this.SalesDemo.ProcessCode === 'P035'))) {
                  this.SalesDemo.IsLatestOFD = true;
                } else {
                  this.SalesDemo.IsLatestOFD = false;
                }

                // OTP Assignment
                this.OTPDetails.OTPDiv = false;
                this.OTPDetails.ShowOTPNo = false;
                this.OTPDetails.OTP = null;
                if (this.SalesDemo.BusinessFlow === 'Forward' && this.SalesDemo.IsLatestOFD) {
                  this.OTPDetails.OTPDiv = true;
                  this.OTPDetails.OTP = this.SalesDemo.DropSecurityCode; // OTP Assignment Forward
                } else if (this.SalesDemo.IsLatestOFD && this.SalesDemo.BusinessFlow === 'Reverse') {
                  this.OTPDetails.OTPDiv = true;
                  this.OTPDetails.OTP = this.SalesDemo.PickupSecurityCode; // OTP Assignment Reverse
                } else if (this.SalesDemo.BusinessFlow === 'Forward' && this.SalesDemo.ReasonCode === 'XBU00358') {
                  this.OTPDetails.OTPDiv = true;
                  this.OTPDetails.OTP = this.SalesDemo.DropSecurityCode; // OTP Assignment Forward
                } else if (this.SalesDemo.BusinessFlow === 'Reverse' && this.SalesDemo.ReasonCode === 'XBU00359') {
                  this.OTPDetails.OTPDiv = true;
                  this.OTPDetails.OTP = this.SalesDemo.PickupSecurityCode; // OTP Assignment Reverse
                } else {
                  this.OTPDetails.OTPDiv = false;
                  this.OTPDetails.ShowOTPNo = false;
                }


                // showDeliveryOTP Assignment
                this.OTPDetails.DeliveryOTPDiv = false;
                this.OTPDetails.showDeliveryOTPNo = false;
                this.OTPDetails.DelivereyOTP = null;
                if (this.SalesDemo.BusinessFlow === 'Forward' && this.SalesDemo.IsLatestOFD) {
                  this.OTPDetails.DeliveryOTPDiv = true;
                  this.OTPDetails.DelivereyOTP = this.SalesDemo.DelivereyOTP; // OTP Assignment Forward
                } else if (this.SalesDemo.IsLatestOFD && this.SalesDemo.BusinessFlow === 'Reverse') {
                  this.OTPDetails.DeliveryOTPDiv = true;
                  this.OTPDetails.DelivereyOTP = this.SalesDemo.DelivereyOTP; // OTP Assignment Reverse
                } else if (this.SalesDemo.BusinessFlow === 'Forward' && this.SalesDemo.ReasonCode === 'XBU00358') {
                  this.OTPDetails.DeliveryOTPDiv = true;
                  this.OTPDetails.DelivereyOTP = this.SalesDemo.DelivereyOTP; // OTP Assignment Forward
                } else if (this.SalesDemo.BusinessFlow === 'Reverse' && this.SalesDemo.ReasonCode === 'XBU00359') {
                  this.OTPDetails.DeliveryOTPDiv = true;
                  this.OTPDetails.DelivereyOTP = this.SalesDemo.DelivereyOTP; // OTP Assignment Reverse
                } else {
                  this.OTPDetails.DeliveryOTPDiv = true;
                  this.OTPDetails.showDeliveryOTPNo = true;
                }

                // For Sales Demo
                // === B2B CRM ALT Instruction Section Start === -- Handling origin hub id , destination hub id  and current hub id emty undefined condition
                this.ShipmentTransactionLogSummary.OriginHubID =
                    (resultDataFinal && resultDataFinal.ShipmentDetails && resultDataFinal.ShipmentDetails.OriginHubID)
                        ? resultDataFinal.ShipmentDetails.OriginHubID
                        : '';

                this.ShipmentTransactionLogSummary.CurrentHubID =
                    (resultDataFinal && resultDataFinal.ShipmentDetails && resultDataFinal.ShipmentDetails.CurrentHubID)
                        ? resultDataFinal.ShipmentDetails.CurrentHubID
                        : '';

                this.ShipmentTransactionLogSummary.FinalDestinationID =
                    (resultDataFinal && resultDataFinal.ShipmentDetails && resultDataFinal.ShipmentDetails.FinalDestinationID)
                        ? resultDataFinal.ShipmentDetails.FinalDestinationID
                        : '';
                // === B2B CRM ALT Instruction Section End ===
                
                this.ShipmentTransactionLogSummary.BusinessFlow = resultDataFinal.ShipmentDetails.BusinessFlow;
                this.ShipmentTransactionLogSummary.ClientID = resultDataFinal.ShipmentDetails.ClientID;

                // For getting Client Name Id
                if (resultDataFinal.ShipmentDetails.ClientID > 0) {
                  // this.getClientDetailsById(resultDataFinal.ShipmentDetails.ClientID);
                }
                this.SalesDemo.ClientName = resultDataFinal.ShipmentDetails.BusinessAccountName;

                // For OrderDetails
                // console.log("this.order details before is :",this.OrderDetails)
                this.OrderDetails = resultDataFinal.OrderDetails;
                //setting CollectibleAmount for B2B MPS update amount
                this.OrderDetails.CollectibleAmount=(resultDataFinal.CollectibleAmount)?resultDataFinal.CollectibleAmount:'';
                if(resultDataFinal.ShipmentDetails.ToPayFTCamount){
                  this.OrderDetails.ToPayFTCamount=resultDataFinal.ShipmentDetails.ToPayFTCamount;
                }
                if(resultDataFinal.ReferanceNo){
                  this.OrderDetails.OrderNo=resultDataFinal.ReferanceNo;
                }
                if(resultDataFinal.RTOAWB){
                  this.OrderDetails.RTOAWB=resultDataFinal.RTOAWB;
                }
                
                //#sr_vehicle_7686  Trigger BASR API only when shipment satisfy conditions
                if (this.showBASRDetails) {
                  this.getBASRDetails(this.SalesDemo.ParentAWB);
                }

                this.ShippingIDTypeMainDiv = true;

                if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Forward') {

                  for (let i = 0; i < this.category.Forward.length; i++) {

                    if (this.category.Forward[i].Status.toLowerCase() == resultDataFinal.ShipmentDetails.Status.toLowerCase() && this.category.Forward[i].ShipmentStatus.toLowerCase() == resultDataFinal.ShipmentDetails.ShipmentStatus.toLowerCase()) {

                      this.categoryOptionObj.text = this.category.Forward[i].name;
                      this.categoryOptionObj.value = this.category.Forward[i].name;
                    }
                  }
                }

                if (this.categoryOptionObj.text == '') {
                  this.categoryOptionObj.text = 'Unidentified';
                  this.categoryOptionObj.value = 'Unidentified';
                }

                //IsCSAW Logic
                if (['ClientInstructionAwaiting', 'Pending', 'Hold'].includes(this.OrderDetails.NotificationStatus)) {
                  this.SalesDemo.IsCSAW = "Yes";
                } else {
                  this.SalesDemo.IsCSAW = "No";
                }

                // not calling api mpsListingAgainstCrmParentAWB  for banking  "PhoneNo":"9999999999"
                // console.log("this.CustomerDetails.PhoneNo "+this.CustomerDetails.PhoneNo);
                if (1 || this.CustomerDetails.PhoneNo && this.CustomerDetails.PhoneNo != '9999999999') {
                  // call phone no api from shipmentupdate
                  this.mpsListingAgainstCrmParentAWB();
                } else {
                  this.getAllShipmentsWithoutPhoneNo();
                }

              } else {
                this.isLoading = false;
                let msg = resultData.ReturnMessage;
                this.$alertify.error(msg);
              }    
            } else {
              this.isLoading = false;
              let msg = resultDataCrm.msg;
              this.$alertify.error(msg);
            }
          }, error => {
            this.isLoading = false;
            var commonVariable = commonFunction.showNetworkError(error);
            this.$alertify.error(commonVariable);
          })
      } catch (error) {

        this.isLoading = false;
        let msg = error + " - B2BTrackShipment";
        this.$alertify.error(msg);
      }
    },

    showOTP() {
      try {
        if (!this.OTPDetails.OTP) {
          this.$alertify.error('NDR Code not available.');
          return false;
        }
        this.isLoading = true;
        this.input = ({
          "otp": this.OTPDetails.OTP.toString(),
          "userid": (this.userid) ? this.userid : 0,
          "email": (this.email) ? this.email : "",
          "username": (this.username) ? this.username : "",
          "firstname": (this.firstname) ? this.firstname : "",
          "lastname": (this.lastname) ? this.lastname : "",
        })
        axios({
            'method': 'POST',
            'url': apiUrl.api_url + 'insertOTPLog',
            'data': this.input,
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            this.isLoading = false;
            let resultDataCrm = result.data.data;
            if (resultDataCrm.status) {
              this.OTPDetails.ShowOTPNo = true;
            } else {
              let msg = resultDataCrm.msg;
              this.$alertify.error(msg);
            }
          }, error => {
            // console.log("error ===>" + JSON.stringify(error));
            this.isLoading = false;
            //let msg = error;
            let msg = "API Server is down for - Show NDR Code";
            this.$alertify.error(msg);
          })
      } catch (error) {
        let msg = error + " - showOTP";
        this.$alertify.error(msg);
      }
    },


    showDeliveryOTP() {
      try {
        if (!this.OTPDetails.DelivereyOTP) {
          this.$alertify.error('NDR Code not available.');
          return false;
        }
        this.isLoading = true;
        this.input = ({

          "otp": this.OTPDetails.DelivereyOTP.toString(),
          "userid": (this.userid) ? this.userid : 0,
          "email": (this.email) ? this.email : "",
          "username": (this.username) ? this.username : "",
          "firstname": (this.firstname) ? this.firstname : "",
          "lastname": (this.lastname) ? this.lastname : "",
          "otptype": "Delivery",
          // "otptype": (this.otptype) ? this.otptype : "",

        })
        axios({
            'method': 'POST',
            'url': apiUrl.api_url + 'insertOTPLog',
            'data': this.input,
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            this.isLoading = false;
            //  console.log(OTP);
            let resultDataCrm = result.data.data;
            if (resultDataCrm.status) {
              this.OTPDetails.showDeliveryOTPNo = true;
            } else {
              let msg = resultDataCrm.msg;
              this.$alertify.error(msg);
            }
          }, error => {
            // console.log("error ===>" + JSON.stringify(error));
            this.isLoading = false;
            //let msg = error;
            let msg = "API Server is down for - Show NDR Code";
            this.$alertify.error(msg);
          })
      } catch (error) {
        console.log(error);
        let msg = error + " - showDeliveryOTP";
        this.$alertify.error(msg);
      }
    },

    getAllShipmentsWithoutPhoneNo() {
      try {
        this.ticketIDLoader = true;
        this.OtherShipments.showChart = false;
        let businessFlow = this.ShipmentTransactionLogSummary.BusinessFlow;
        if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Forward') {
          this.OtherShipments.chartData.labels = ["Delivered", "RTO", "Undelivered"];
          this.OtherShipments.chartData.datasets[0].backgroundColor = ["green", "red", "yellow"];
          this.OtherShipments.chartData.datasets[0].data = [0, 0, 0];
        } else if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Reverse') {
          this.OtherShipments.chartData.labels = ["Pick Done", "Not Picked", "DTO", "Cancelled", "DTO Undelivered"];
          this.OtherShipments.chartData.datasets[0].backgroundColor = ["green", "orange", "blue", "red", "gray"];
          this.OtherShipments.chartData.datasets[0].data = [0, 0, 0, 0, 0];
        }
        this.OtherShipments.DeliveredCnt = 0;
        this.OtherShipments.RTOCnt = 0;
        this.OtherShipments.UndeliverdCnt = 0;
        this.OtherShipments.DTOCnt = 0;
        this.OtherShipments.NotPickedCnt = 0;
        this.OtherShipments.PickDoneCnt = 0;
        this.OtherShipments.CancelledCnt = 0;
        this.OtherShipments.DTOUndeliveredCnt = 0;
        this.isLoading = false;
        this.OtherShipmentLogArr = [];

        this.arrayofobj = [];
        this.categoryCatalogue = [];
        this.ticketIDLoader = false;
        let resultData = {};

        resultData.Shipments = [{
          "ShippingID": this.ShippingID,
          "Status": this.SalesDemo.Status,
          "CurrentStatus": this.SalesDemo.ShipmentStatus,
          "ClientID": this.SalesDemo.ClientID,
          "CreatedDate": this.SalesDemo.CreatedDate,
          "TotalAttemptCount": this.SalesDemo.TotalAttemptCount,
          "BusinessAccountName": this.SalesDemo.BusinessAccountName,
          "BusinessFlow": this.SalesDemo.BusinessFlow,
          "CurrentHubID": this.SalesDemo.CurrentHubID,
          "OriginHubID": this.SalesDemo.OriginHubID,
          "FinalDestinationID": this.SalesDemo.FinalDestinationID,
          "OrderType": this.OrderDetails.OrderType,
          "CollectibleAmount": this.OrderDetails.CollectibleAmount,
          "BusinessType": this.SalesDemo.BusinessType
        }];
        let flag = false;
        if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Forward') {
          for (let i = 0; i < resultData.Shipments.length; i++) {
            let indexStatus = this.category.Forward.findIndex(o => o.Status.toLowerCase() == resultData.Shipments[i].Status.toLowerCase() && o.ShipmentStatus.toLowerCase() == resultData.Shipments[i].CurrentStatus.toLowerCase());

            if (-1 !== indexStatus && undefined !== this.category.Forward[indexStatus]) {
              if (-1 === this.arrayofobj.findIndex(o => o.text == this.category.Forward[indexStatus].name)) {
                this.arrayofobj.push({
                  text: this.category.Forward[indexStatus].name,
                  value: this.category.Forward[indexStatus].name
                });
              }
            } else {
              flag = true;

              if (-1 === this.UnCategorizedArrData.findIndex(o => o.ShippingID == resultData.Shipments[i].ShippingID)) {
                this.UnCategorizedArrData.push(resultData.Shipments[i]);
              }

            }
          }
        }
        if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Reverse') {
          for (let i = 0; i < resultData.Shipments.length; i++) {
            let indexStatus = this.category.Reverse.findIndex(o => o.Status.toLowerCase() == resultData.Shipments[i].Status.toLowerCase() && o.ShipmentStatus.toLowerCase() == resultData.Shipments[i].CurrentStatus.toLowerCase());

            if (-1 !== indexStatus && undefined !== this.category.Reverse[indexStatus]) {
              if (-1 === this.arrayofobj.findIndex(o => o.text == this.category.Reverse[indexStatus].name)) {
                this.arrayofobj.push({
                  text: this.category.Reverse[indexStatus].name,
                  value: this.category.Reverse[indexStatus].name
                });
              }

            } else {
              flag = true;
              if (-1 === this.UnCategorizedArrData.findIndex(o => o.ShippingID == resultData.Shipments[i].ShippingID)) {
                this.UnCategorizedArrData.push(resultData.Shipments[i]);
              }
            }
          }
        }

        if (flag == true) {
          this.arrayofobj.push({
            text: 'Unidentified',
            value: 'Unidentified'
          });
        }

        let OtherShipmentLog = resultData.Shipments;
        let OtherShipmentLogCnt = OtherShipmentLog.length;
        this.OtherShipmentLogCnt = OtherShipmentLogCnt;
        if (OtherShipmentLogCnt > 0) {
          this.OtherShipmentLogArr = [];

          this.OtherShipmentShippingIDCheckedArr.push(this.ShippingID);
          this.OtherShipments.ClientName = "";

          //Start DoughnutChart Logic
          let i;
          for (i = 0; i < OtherShipmentLogCnt; i++) {
            //  OtherShipmentLog[i].ClientName = "";
            OtherShipmentLog[i].ClientName = OtherShipmentLog[i].BusinessAccountName;

            this.OtherShipmentLogArr.push(OtherShipmentLog[i]);

            if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Forward') {
              if (OtherShipmentLog[i].Status === "Delivered") {
                this.OtherShipments.DeliveredCnt++;
              }
              if (OtherShipmentLog[i].Status === "RTO") {
                this.OtherShipments.RTOCnt++;
              }
            } else if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Reverse') {


              if (OtherShipmentLog[i].Status === "DTO" && OtherShipmentLog[i].CurrentStatus === "WHHandover") {
                this.OtherShipments.DTOCnt++;
              }
              if (OtherShipmentLog[i].Status === "Pending" && (OtherShipmentLog[i].CurrentStatus === "Pending" || OtherShipmentLog[i].CurrentStatus === "OutForPickup" || OtherShipmentLog[i].CurrentStatus === "PickupAssinged" || OtherShipmentLog[i].CurrentStatus === "PickupNotDone" || OtherShipmentLog[i].CurrentStatus === "ReinitiatedPickups")) {
                this.OtherShipments.NotPickedCnt++;
              }

              if (OtherShipmentLog[i].Status === "Pending" && (OtherShipmentLog[i].CurrentStatus === "PickupDone" || OtherShipmentLog[i].CurrentStatus === "PickupDoneBySR")) {
                this.OtherShipments.PickDoneCnt++;
              }

              if (OtherShipmentLog[i].Status === "RPCancel" && OtherShipmentLog[i].CurrentStatus === "RPCancel") {
                this.OtherShipments.CancelledCnt++;
              }

              if (OtherShipmentLog[i].Status === "Shipped" && (OtherShipmentLog[i].CurrentStatus === "InScan" || OtherShipmentLog[i].CurrentStatus === "Inscan")) {
                this.OtherShipments.DTOUndeliveredCnt++;
              }
            }

            // get ClientName by ID
            if (OtherShipmentLog[i].ClientID > 0) {
              // this.getClientDetailsById(OtherShipmentLog[i].ClientID, i);
            }

            //console.log( 'OtherShipmentLog data Graph: '+JSON.stringify(OtherShipmentLog[i] ));

          }

          this.OtherShipments.UndeliveredCnt = OtherShipmentLogCnt - (this.OtherShipments.DeliveredCnt + this.OtherShipments.RTOCnt);
          this.showStats();
          this.selectedOptionObj(this.categoryOptionObj);
          //End DoughnutChart Logic


        } else {
          this.OtherShipmentLogArr = [];
        }

      } catch (error) {
        this.isLoading = false;
        let msg = error + " - getAllShipmentsWithoutPhoneNo";
        // console.log("msg==" + msg);
        this.$alertify.error(msg);
      }
    },

    displayPhoneNoPattern(PhoneNo) {
      try {
        let PhoneNoDisplay = null;
        if (PhoneNo) {
          PhoneNoDisplay = new Array(PhoneNo.length - 3).join('X') + PhoneNo.substr(PhoneNo.length - 4, 4);
        }
        return PhoneNoDisplay;
      } catch (error) {
        let msg = error + " Something went wrong in Display Phone No Pattern.";
        this.$alertify.error(msg);
      }
    },


    // GetB2BTrackLogs
    GetB2BTrackLogs() {
      try {
        this.ShipmentTransactionLogSummary = {};
        this.SalesDemo.DeliveryDateTime = null;
        // this.MobileNumberTypeMainDiv = false;
        if (this.ShippingID === '') {
          this.$alertify.error('Please enter Shipping ID.');
          return false;
        }

        // SearchType Handling
        let SearchType = null;

        if (this.SelectTypeOptionObj.value === 'ShippingID') {
          SearchType = "ChildAWB";
        } else if (this.SelectTypeOptionObj.value === 'ParentAWB') {
          SearchType = "ParentAWB";
        } else {
          SearchType = null;
        }

        //  this.isLoading = true;
        let token = 'c423ed60f34c0021016fc65cb53a9ad4';
        let versionNumber = 'v1';
        this.input = ({
          'ShippingID': this.ShippingID,
          'SearchType': SearchType,

        })
        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'GetB2BTrackLogs',
            'data': this.input,
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            this.isLoading = false;
            let resultDataCrm = result.data.data;
            if (resultDataCrm.status) {
              let resultData = result.data.data.data;
              if (resultData.ReturnCode == 100) {
                let ShipmentTransactionLogSummary = resultData.ShipmentDetails;

                this.SalesDemo.DeliveryDateTime = ShipmentTransactionLogSummary.DeliveryDateTime;

                this.ShipmentTransactionLogSummary.lastNDRUserProcess = ShipmentTransactionLogSummary.lastNDRUserProcess;
                this.ShipmentTransactionLogSummary.LastNDRDate = ShipmentTransactionLogSummary.LastNDRDate;
                this.ShipmentTransactionLogSummary.lastCSAWUserProcess = ShipmentTransactionLogSummary.lastCSAWUserProcess;
                this.ShipmentTransactionLogSummary.LastCSAWDate = ShipmentTransactionLogSummary.LastCSAWDate;

                // For Map Logic
                this.deliveryUserID = ShipmentTransactionLogSummary.DeliveryUserID
                //#7472 location not found issue fix 
                // if (this.deliveryUserID > 0) {
                //   //  this.deliveryUserID = 1584;
                //   if ((this.SalesDemo.BusinessFlow === 'Forward' && (this.SalesDemo.ProcessCode === 'P035' || this.SalesDemo.ProcessCode === 'P054')) || (this.SalesDemo.BusinessFlow === 'Reverse' && (this.SalesDemo.ProcessCode === 'P035' || this.SalesDemo.ProcessCode === 'P034'))) {
                //     this.fetchSrUserDetailsData(this.deliveryUserID);
                //     this.fetchSrLocationDetailsData(this.deliveryUserID);
                //   }
                // }

                if (ShipmentTransactionLogSummary.ManifestDataReceived) {
                  this.ShipmentTransactionLogSummary.ManifestDate = ShipmentTransactionLogSummary.ManifestDataReceived;
                  this.ShipmentTransactionLogSummary.DataReceived = "Manifest Data Received via " + this.SalesDemo.SourceType + " " + ShipmentTransactionLogSummary.ManifestDataReceived;
                  //  this.ShipmentTransactionLogSummary.DataReceived = "Manifest Data Received " + ShipmentTransactionLogSummary.ManifestDataReceived;
                } else {
                  this.ShipmentTransactionLogSummary.DataReceived = null;
                  this.ShipmentTransactionLogSummary.ManifestDate = null;
                }

                if (ShipmentTransactionLogSummary.OriginHubInScan) {
                  this.ShipmentTransactionLogSummary.OriginHubData = "Origin InScan " + ShipmentTransactionLogSummary.OriginHubInScan;
                  this.getHubDetailById(this.ShipmentTransactionLogSummary.OriginHubID, "O");
                } else {
                  // this.ShipmentTransactionLogSummary.OriginHubData = null;
                  this.ShipmentTransactionLogSummary.OriginHubData = "Origin InScan Pending ";
                  this.getHubDetailById(this.ShipmentTransactionLogSummary.OriginHubID, "O");
                }


                // IF OriginHubID is equal to FinalDestinationID then hide OriginHubData Div
                if (this.ShipmentTransactionLogSummary.OriginHubID === this.ShipmentTransactionLogSummary.FinalDestinationID) {
                  this.short_short_connecting_line = true;
                  this.short_short_glyphprogress = true;
                  this.ShipmentTransactionLogSummary.currentHubDataLiShow = false;
                  this.ShipmentTransactionLogSummary.DestinationHubDataLiShow = true;
                  this.ShipmentTransactionLogSummary.OriginHubDataLiShow = false;

                } else if (this.ShipmentTransactionLogSummary.OriginHubID === this.ShipmentTransactionLogSummary.CurrentHubID || this.ShipmentTransactionLogSummary.CurrentHubID === this.ShipmentTransactionLogSummary.FinalDestinationID) {
                  // IF CurrentHubID is equal to FinalDestinationID then hide currentHubData Div
                  this.short_short_connecting_line = false;
                  this.short_short_glyphprogress = false;
                  this.short_connecting_line = true;
                  this.short_glyphprogress = true;
                  this.ShipmentTransactionLogSummary.currentHubDataLiShow = false;
                  this.ShipmentTransactionLogSummary.DestinationHubDataLiShow = true;
                  this.ShipmentTransactionLogSummary.OriginHubDataLiShow = true;
                } else {
                  this.short_short_connecting_line = false;
                  this.short_short_glyphprogress = false;
                  this.short_connecting_line = false;
                  this.short_glyphprogress = false;
                  this.ShipmentTransactionLogSummary.currentHubDataLiShow = true;
                  this.ShipmentTransactionLogSummary.DestinationHubDataLiShow = true;
                  this.ShipmentTransactionLogSummary.OriginHubDataLiShow = true;
                }

                // IF OriginHubID is equal to FinalDestinationID then hide OriginHubData Div
                if (this.ShipmentTransactionLogSummary.OriginHubID === this.ShipmentTransactionLogSummary.FinalDestinationID) {
                  this.short_short_connecting_line = true;
                  this.short_short_glyphprogress = true;
                  this.ShipmentTransactionLogSummary.currentHubDataLiShow = false;
                  this.ShipmentTransactionLogSummary.DestinationHubDataLiShow = true;
                  this.ShipmentTransactionLogSummary.OriginHubDataLiShow = false;

                } else if (this.ShipmentTransactionLogSummary.OriginHubID === this.ShipmentTransactionLogSummary.CurrentHubID || this.ShipmentTransactionLogSummary.CurrentHubID === this.ShipmentTransactionLogSummary.FinalDestinationID) {
                  // IF CurrentHubID is equal to FinalDestinationID then hide currentHubData Div
                  this.short_short_connecting_line = false;
                  this.short_short_glyphprogress = false;
                  this.short_connecting_line = true;
                  this.short_glyphprogress = true;
                  this.ShipmentTransactionLogSummary.currentHubDataLiShow = false;
                  this.ShipmentTransactionLogSummary.DestinationHubDataLiShow = true;
                  this.ShipmentTransactionLogSummary.OriginHubDataLiShow = true;
                } else {
                  this.short_short_connecting_line = false;
                  this.short_short_glyphprogress = false;
                  this.short_connecting_line = false;
                  this.short_glyphprogress = false;
                  this.ShipmentTransactionLogSummary.currentHubDataLiShow = true;
                  this.ShipmentTransactionLogSummary.DestinationHubDataLiShow = true;
                  this.ShipmentTransactionLogSummary.OriginHubDataLiShow = true;
                }

                if (ShipmentTransactionLogSummary.CurrentHubInscanDate) {
                  this.ShipmentTransactionLogSummary.currentHubData = "Transit InScan " + ShipmentTransactionLogSummary.CurrentHubInscanDate;
                  this.getHubDetailById(this.ShipmentTransactionLogSummary.CurrentHubID, "C");
                } else {
                  this.ShipmentTransactionLogSummary.currentHubData = "Transit InScan Pending ";
                  this.getHubDetailById(this.ShipmentTransactionLogSummary.CurrentHubID, "C");
                }

                if (ShipmentTransactionLogSummary.DestinationHubInscanDate) {
                  this.ShipmentTransactionLogSummary.DestinationHubData = "Destination InScan " + ShipmentTransactionLogSummary.DestinationHubInscanDate;
                  this.getHubDetailById(this.ShipmentTransactionLogSummary.FinalDestinationID, "D");
                } else {
                  //this.ShipmentTransactionLogSummary.DestinationHubData = null;
                  this.ShipmentTransactionLogSummary.DestinationHubData = "Destination InScan Pending ";
                  this.getHubDetailById(this.ShipmentTransactionLogSummary.FinalDestinationID, "D");
                }


                //old Lgic//   if (ShipmentTransactionLogSummary.DeliveryDateTime) {
                //Lastest Stage Blinking logic
                if (ShipmentTransactionLogSummary.DeliveryDateTime && (this.SalesDemo.Status === 'Delivered' || this.SalesDemo.ShipmentStatus === 'WHHandover')) {
                  this.ShipmentTransactionLogSummary.IsLatestDeliveryDateTime = true;
                } else if (this.SalesDemo.IsLatestOFD) {
                  this.ShipmentTransactionLogSummary.IsLatestOFD = true;
                } else if (ShipmentTransactionLogSummary.DestinationHubInscanDate) {
                  this.ShipmentTransactionLogSummary.IsLatestDestinationHubInscanDate = true;
                } else if (ShipmentTransactionLogSummary.CurrentHubInscanDate && this.ShipmentTransactionLogSummary.OriginHubID != this.ShipmentTransactionLogSummary.CurrentHubID && this.ShipmentTransactionLogSummary.FinalDestinationID != this.ShipmentTransactionLogSummary.CurrentHubID) {
                  this.ShipmentTransactionLogSummary.IsLatestCurrentHubInscanDate = true;
                } else if (ShipmentTransactionLogSummary.OriginHubInScan) {
                  this.ShipmentTransactionLogSummary.IsLatestOriginHubInScan = true;
                } else if (ShipmentTransactionLogSummary.ManifestDataReceived) {
                  this.ShipmentTransactionLogSummary.IsLatestManifestDataReceived = true;
                }
                // To Display hub Name Logic
                setTimeout(() => {
                  this.ShippingID = null;
                  if (SearchType === "ChildAWB") {
                    this.ShippingID = this.SalesDemo.ShippingID;
                  } else {
                    this.ShippingID = this.SalesDemo.ParentAWB;
                  }
                  this.$refs.RefShippingID.focus();
                }, 2000);

              } else {
                let msg = resultData.ReturnMessage;
                this.$alertify.error(msg);
              }
            } else {
              let msg = resultDataCrm.msg;
              this.$alertify.error(msg);
            }
          }, error => {
            this.isLoading = false;
            let msg = error;
            this.$alertify.error(msg);
          })
      } catch (error) {
        let msg = error + " - GetB2BTrackLogs";
        this.$alertify.error(msg);
      }
    },

    // getBagDetailsForCLTCRM
    getBagDetailsForCLTCRM() {
      // Hide all main Div
      this.BagNoObj.TransitStatusModal = false
      this.BagNumberTypeMainDiv = false;
      if (this.ShippingID === '') {
        this.$alertify.error('Please enter Bag Number.');
        return false;
      }

      this.isLoading = true;
      // var token = window.localStorage.getItem('userToken')
      // var versionNumber = window.localStorage.getItem('versionNumber')
      let token = 'c423ed60f34c0021016fc65cb53a9ad4';
      let versionNumber = 'v1';
      this.input = ({
        ShippingID: this.ShippingID
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getBagDetailsForCLTCRM',
          'data': this.input,
          headers: commonFunction.getusertoken(),
        })
        .then(result => {
          this.isLoading = false;

          let resultDataCrm = result.data.data;
          if (resultDataCrm.status) {
            let resultData = result.data.data.data;
            if (resultData.ResultCode === 100) {
              let resultDataFinal = resultData.ResponseData;
              // For Bag Details
              this.BagNoObj.BagDetails = resultDataFinal.BagDetails[0];
              this.BagNoObj.AuditLogArr = [];
              this.BagNoObj.AuditLogArr = resultDataFinal.AuditLog;
              this.BagNumberTypeMainDiv = true;
            } else {
              let msg = resultData.ReturnMessage;
              this.$alertify.error(msg);
            }
          } else {
            let msg = resultDataCrm.msg;
            this.$alertify.error(msg);
          }
        }, error => {}, error => {}, error => {
          var commonVariable = commonFunction.showNetworkError(error);
          this.$alertify.error(commonVariable);
        })
    },

    getClientDetailsById(id, i = -1) {
      this.input = ({
        id: id
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getClientDetailsById',
          'data': this.input,
          headers: commonFunction.getusertoken(),
        })
        .then(result => {
          let resultDataCrm = result.data.data;
          if (resultDataCrm.status) {
            let response = resultDataCrm.data;
            if (response.code === 200) {

              if (i >= 0) {
                this.OtherShipmentLogArr[i].ClientName = response.data[0].CompanyName;
              } else {
                this.SalesDemo.ClientName = response.data[0].CompanyName;
              }

            } else {
              let msg = response.message;
              this.$alertify.error(msg);
            }
          } else {
            let msg = resultDataCrm.msg;
            this.$alertify.error(msg);
          }
        }, error => {
          let msg = error;
          this.$alertify.error(msg);
        })
    },

    getHubDetailById(HubId, HubSource) {
      try {
        const secretKey = constantVariable.enckey;
        const encryptedData = AES.encrypt(HubId.toString(), secretKey).toString();
        let ecHubId = encryptedData.replace(/[=]/g, '_');
        this.input = ({
          id: ecHubId
        })
        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'getHubDetailById',
            'data': this.input,
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            let resultDataCrm = result.data.data;
            if (resultDataCrm.status) {
              let response = resultDataCrm.data;
              let HubNameStr = '';
              let ProcessLocation = '';
              if (response.code === 200) {
                HubNameStr = response.data[0].HubName + "(" + HubId + ")" + " " + response.data[0].cityname + ", " + response.data[0].statename;
                if (HubSource === "O") {
                  this.ShipmentTransactionLogSummary.OriginHubData = this.ShipmentTransactionLogSummary.OriginHubData + " " + HubNameStr;
                }
                if (HubSource === "C") {
                  this.ShipmentTransactionLogSummary.currentHubData = this.ShipmentTransactionLogSummary.currentHubData + " " + HubNameStr;
                  this.OrderDetails.EmailServiceCenter = response.data[0].HubEmailId;
                }
                if (HubSource === "D") {
                  this.ShipmentTransactionLogSummary.DestinationHubData = this.ShipmentTransactionLogSummary.DestinationHubData + " " + HubNameStr;
                } else if (HubSource >= 0) {
                  HubNameStr = response.data[0].HubName;
                  // For ShipmentLog ProcessLocation
                  ProcessLocation = response.data[0].HubName + "(" + HubId + ")" + " " + response.data[0].cityname + ", " + response.data[0].statename;
                  this.ShipmentLog.ShipmentLogBarArr[HubSource].ProcessLocation = ProcessLocation;
                  this.ShipmentLog.ShipmentLogBarArr[HubSource].HubName = HubNameStr;
                  this.ShipmentLog.ShipmentLogBarArr[HubSource].CurrentHubName = HubNameStr;
                }




              } else {
                let msg = response.message;
                this.$alertify.error(msg);
              }

            } else {
              let msg = resultDataCrm.msg;
              this.$alertify.error(msg);
            }
          }, error => {
            let msg = error;
            this.$alertify.error(msg);
          })
      } catch (error) {
        let msg = error + " - getHubDetailById";
        this.$alertify.error(msg);
      }
    },

    // Mobile Number TimeOut
    mpsListingAgainstCrmParentAWB() {
      try {
        this.ticketIDLoader = true;
        this.OtherShipments.showChart = false;
        // let businessFlow = this.ShipmentTransactionLogSummary.BusinessFlow;

        this.OtherShipments.chartData.labels = ["Delivered", "RTO", "Undelivered"];
        this.OtherShipments.chartData.datasets[0].backgroundColor = ["green", "red", "yellow"];
        this.OtherShipments.chartData.datasets[0].data = [0, 0, 0];

        this.OtherShipments.DeliveredCnt = 0;
        this.OtherShipments.RTOCnt = 0;
        this.OtherShipments.UndeliverdCnt = 0;
        this.OtherShipments.DTOCnt = 0;
        this.OtherShipments.NotPickedCnt = 0;
        this.OtherShipments.PickDoneCnt = 0;
        this.OtherShipments.CancelledCnt = 0;
        this.OtherShipments.DTOUndeliveredCnt = 0;
        this.isLoading = true;
        this.OtherShipmentLogArr = [];
        let ParentAWB = this.SalesDemo.ParentAWB;
        // if (this.SelectTypeOptionObj.value === 'MobileNumber') {
        //   businessFlow = "All";
        //   ParentAWB = this.ShippingID;
        //   this.ShippingIDTypeMainDiv = false;
        //   this.MobileNumberTypeMainDiv = false;
        // } else {
        //   ParentAWB = this.CustomerDetails.ParentAWB;
        // }

        if (ParentAWB === '') {
          this.$alertify.error('Please enter Parent AWB.');
          return false;
        }


        this.OtherShipments.isLoading = true;
        let token = 'c423ed60f34c0021016fc65cb53a9ad4';
        let versionNumber = 'v1';
        this.input = ({
          ParentAWB: ParentAWB,
          PageSize: 1000,
          PageNumber: 1,
          PartialStatus: this.SalesDemo.PartialStatus                 //#b2b_partial_rto
        })


        axios({
            'timeout': 40000, // TimeOut Forcefully
            'method': 'POST',
            'url': apiUrl.api_url + 'mpsListingAgainstCrmParentAWB',
            'data': this.input,
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            //  console.log("result "+JSON.stringify(result));
            this.arrayofobj = [];
            this.categoryCatalogue = [];
            this.OtherShipments.isLoading = false;
            this.ticketIDLoader = false;
            let resultDataCrm = result.data.data;
            if (resultDataCrm.status) {
              let resultData = result.data.data.data;
              if (resultData.ReturnCode === 100) {

                let flag = false;
                if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Forward') {
                  for (let i = 0; i < resultData.Shipments.length; i++) {
                    let indexStatus = this.category.Forward.findIndex(o => o.Status.toLowerCase() == resultData.Shipments[i].Status.toLowerCase() && o.ShipmentStatus.toLowerCase() == resultData.Shipments[i].CurrentStatus.toLowerCase());

                    if (-1 !== indexStatus && undefined !== this.category.Forward[indexStatus]) {
                      if (-1 === this.arrayofobj.findIndex(o => o.text == this.category.Forward[indexStatus].name)) {
                        this.arrayofobj.push({
                          text: this.category.Forward[indexStatus].name,
                          value: this.category.Forward[indexStatus].name
                        });
                      }
                    } else {
                      flag = true;

                      if (-1 === this.UnCategorizedArrData.findIndex(o => o.ShippingID == resultData.Shipments[i].ShippingID)) {
                        this.UnCategorizedArrData.push(resultData.Shipments[i]);
                      }

                    }
                  }
                }

                if (flag == true) {
                  this.arrayofobj.push({
                    text: 'Unidentified',
                    value: 'Unidentified'
                  });
                }

                let OtherShipmentLog = resultData.Shipments;
                let OtherShipmentLogCnt = OtherShipmentLog.length;
                this.OtherShipmentLogCnt = OtherShipmentLogCnt;
                if (OtherShipmentLogCnt > 0) {
                  this.OtherShipmentLogArr = [];

                  this.OtherShipmentShippingIDCheckedArr.push(this.ShippingID);
                  this.OtherShipments.ClientName = "";

                  //Start DoughnutChart Logic
                  let i;
                  for (i = 0; i < OtherShipmentLogCnt; i++) {
                    //  OtherShipmentLog[i].ClientName = "";
                    OtherShipmentLog[i].ClientName = OtherShipmentLog[i].BusinessAccountName;

                    this.OtherShipmentLogArr.push(OtherShipmentLog[i]);

                    if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Forward') {
                      if (OtherShipmentLog[i].Status === "Delivered") {
                        this.OtherShipments.DeliveredCnt++;
                      }
                      if (OtherShipmentLog[i].Status === "RTO") {
                        this.OtherShipments.RTOCnt++;
                      }
                    }

                    // get ClientName by ID
                    if (OtherShipmentLog[i].ClientID > 0) {
                      // this.getClientDetailsById(OtherShipmentLog[i].ClientID, i);
                    }

                    //console.log( 'OtherShipmentLog data Graph: '+JSON.stringify(OtherShipmentLog[i] ));

                  }

                  this.OtherShipments.UndeliveredCnt = OtherShipmentLogCnt - (this.OtherShipments.DeliveredCnt + this.OtherShipments.RTOCnt);
                  this.showStats();
                  this.selectedOptionObj(this.categoryOptionObj);
                  //End DoughnutChart Logic
                  if (this.SelectTypeOptionObj.value === 'ShippingID'){

                  }
                  else{
                    this.byDefaultSelectAll();
                  }

                } else {
                  this.OtherShipmentLogArr = [];
                }

              } else {
                // let msg = resultData.ReturnMessage;
                // this.$alertify.error(msg);
                this.getAllShipmentsWithoutPhoneNo(); // if shipment data not available
              }
            } else {
              // let msg = resultDataCrm.msg;
              // this.$alertify.error(msg);
              this.getAllShipmentsWithoutPhoneNo(); // if shipment data not available
            }
          }, error => {

            if (this.SelectTypeOptionObj.value === 'MobileNumber') {
              this.isLoading = false;
            } else {
              this.OtherShipments.isLoading = false;
            }

            //  var commonVariable = commonFunction.showNetworkError(error);
            //   this.$alertify.error(commonVariable);
            this.getAllShipmentsWithoutPhoneNo(); // if shipment data not available
          })
      } catch (error) {
        if (this.SelectTypeOptionObj.value === 'MobileNumber') {
          this.isLoading = false;
        } else {
          this.OtherShipments.isLoading = false;
        }
        let msg = error + " - mpsListingAgainstCrmParentAWB";
        // console.log("msg==" + msg);
        // this.$alertify.error(msg);
        this.getAllShipmentsWithoutPhoneNo(); // if shipment data not available
      }
    },

    //function to handle bydefault select all in trackshipment
    byDefaultSelectAll(e){
     // console.log("In byDefaultSelectAll");
      //console.log("e is :",e);
      this.allSelected=true;
      this.selectAll(e);
      this.ticketShipmentData.length=1;
    },

    getAllShipmentsByPOID() {
      try {

        this.isLoading = true;
        this.poIdShipmentArr = [];
        let poId;
        let businessFlow;
        if (this.SelectTypeOptionObj.value === 'POID') {
          businessFlow = "All";
          poId = this.ShippingID;
          // this.ShippingIDTypeMainDiv = false;
          this.POIDTypeMainDiv = false;
        }

        if (poId === '') {
          this.$alertify.error('Please enter Client Order ID.');
          return false;
        }

        let token = 'c423ed60f34c0021016fc65cb53a9ad4';
        let versionNumber = 'v1';
        this.input = ({
          POID: poId
        })
        axios({
            'timeout': 40000, // TimeOut Forcefully
            'method': 'POST',
            'url': apiUrl.api_url + 'getAllShipmentsByPOID',
            'data': this.input,
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            this.isLoading = false;
            let resultDataCrm = result.data.data;
            if (resultDataCrm.status) {
              let resultData = result.data.data.data;
              if (resultData.ReturnCode === 100) {
                this.poIdShipmentArr = [];
                this.poIdShipmentArr = resultData.Shipments;
                this.POIDTypeMainDiv = true;
              } else {
                let msg = resultData.ReturnMessage;
                this.$alertify.error(msg);
              }
            } else {
              let msg = resultDataCrm.msg;
              this.$alertify.error(msg);
            }
          }, error => {
            this.isLoading = false;
            var commonVariable = commonFunction.showNetworkError(error);
            this.$alertify.error(commonVariable);
          })
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - getAllShipmentsByPOID";
        this.$alertify.error(msg);
      }
    },

    showStats() {
      // this.$alertify.error("this.OtherShipments "+JSON.stringify(this.OtherShipments));
      this.OtherShipments.showChart = true;
      if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Forward') {
        this.OtherShipments.chartData.datasets[0].data = [this.OtherShipments.DeliveredCnt, this.OtherShipments.RTOCnt, this.OtherShipments.UndeliveredCnt];
      } else if (this.ShipmentTransactionLogSummary.BusinessFlow === 'Reverse') {
        this.OtherShipments.chartData.datasets[0].data = [this.OtherShipments.PickDoneCnt, this.OtherShipments.NotPickedCnt, this.OtherShipments.DTOCnt, this.OtherShipments.CancelledCnt, this.OtherShipments.DTOUndeliveredCnt];
      }
    },

    //  showShipmentLogModal From legacy system
    showShipmentLogModal_old() {
      try {
        this.isLoadingCurrentStatusDiv = true;
        this.ShipmentLog.ShipmentLogBarArr = [];
        let token = 'c423ed60f34c0021016fc65cb53a9ad4';
        let versionNumber = 'v1';
        let xbkey = 'xbkey2';
        this.input = ({
          ShippingID: this.ShippingID,
          ManifestDate: this.ShipmentTransactionLogSummary.ManifestDate
        })
        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'GetTrackShipmentLogDetailsLegacy',
            'data': this.input,
            headers: commonFunction.getusertoken(),
          })
          .then(async result => {
            this.isLoadingCurrentStatusDiv = false;
            let resultDataCrm = result.data.data;
            if (resultDataCrm.status) {
              let resultData = result.data.data.data;
              if (resultData.ReturnCode === 100) {
                this.ShipmentLog.ShipmentLogBarArr = resultData.Result;
                this.ShipmentLog.ShipmentLogCnt = this.ShipmentLog.ShipmentLogBarArr.length;
                if (this.ShipmentLog.ShipmentLogCnt && this.ShipmentLog.ShipmentLogCnt > 0) {

                  for (let i = 0; i < this.ShipmentLog.ShipmentLogCnt; i++) {
                    this.ShipmentLog.ShipmentLogBarArr[i].UserName = this.ShipmentLog.ShipmentLogBarArr[i].CreatedBy;
                    this.ShipmentLog.ShipmentLogBarArr[i].UserProcess = this.ShipmentLog.ShipmentLogBarArr[i].Process;
                    this.ShipmentLog.ShipmentLogBarArr[i].Comments = this.ShipmentLog.ShipmentLogBarArr[i].Comment;
                    this.ShipmentLog.ShipmentLogBarArr[i].ProcessLocation = this.ShipmentLog.ShipmentLogBarArr[i].CurrentLocation + " (" + this.ShipmentLog.ShipmentLogBarArr[i].ProcessLocation + ")";
                  }

                } else {
                  let msg = resultData.ReturnMessage;
                  this.$alertify.error(msg);
                }
                // Merge recording data
                if (this.IVRCallRecording.IVRCallRecordingBtn) {
                  // Currently commented
                  // await this.getIVRCallRecordingData();
                } else {
                  // dont merge data
                }


                this.ShipmentLogModal = true
              } else {
                let msg = resultData.ReturnMessage;
                this.$alertify.error(msg);
              }
            } else {
              let msg = resultDataCrm.msg;
              this.$alertify.error(msg);
            }
          }, error => {
            this.isLoadingCurrentStatusDiv = false;
            let msg = error;
            this.$alertify.error(msg);
          })
      } catch (error) {
        this.isLoadingCurrentStatusDiv = false;
        this.ShipmentLogModal = false;
        let msg = error + " - showShipmentLogModal";
        this.$alertify.error(msg);
      }
    },


    //  showShipmentLogModal old from shipment update new framework
    showShipmentLogModal(ShippingID) {
      try {
        this.isLoadingCurrentStatusDiv = true;
        this.ShipmentLog.ShipmentLogBarArr = [];
        let token = 'c423ed60f34c0021016fc65cb53a9ad4';
        let versionNumber = 'v1';
        let xbkey = 'xbkey2';
        this.input = ({
          ShippingID: ShippingID,
        })
        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'GetTrackShipmentLogDetails',
            'data': this.input,
            headers: commonFunction.getusertoken(),
          })
          .then(async result => {
            this.isLoadingCurrentStatusDiv = false;
            let resultDataCrm = result.data.data;
            this.mpsdetails1 = ShippingID
            if (resultDataCrm.status) {
              let resultData = result.data.data.data;
              if (resultData.ReturnCode === 100) {
                this.ShipmentLog.ShipmentLogBarArr = resultData.Result;
                this.ShipmentLog.ShipmentLogCnt = this.ShipmentLog.ShipmentLogBarArr.length;
                for (let i = 0; i < this.ShipmentLog.ShipmentLogCnt; i++) {
                  if (this.ShipmentLog.ShipmentLogBarArr[i].CurrentHubName > 0) {
                    this.getHubDetailById(this.ShipmentLog.ShipmentLogBarArr[i].CurrentHubName, i);
                  }
                }

                // Merge recording data
                if (this.IVRCallRecording.IVRCallRecordingBtn) {
                  // Currently commented
                  // await this.getIVRCallRecordingData();
                } else {
                  // dont merge data
                }


                this.ShipmentLogModal = true
              } else {
                let msg = resultData.ReturnMessage;
                this.$alertify.error(msg);
              }
            } else {
              let msg = resultDataCrm.msg;
              this.$alertify.error(msg);
            }
          }, error => {
            this.isLoadingCurrentStatusDiv = false;
            let msg = error;
            this.$alertify.error(msg);
          })
      } catch (error) {
        this.isLoadingCurrentStatusDiv = false;
        this.ShipmentLogModal = false;
        let msg = error + " - showShipmentLogModal";
        this.$alertify.error(msg);
      }
    },

    //Start For Map Display
    getPosition: function (marker) {
      return {
        lat: parseFloat(marker.lat),
        lng: parseFloat(marker.lng)
      }
    },

    toggleInfo: function (marker, key) {
      this.infoPosition = this.getPosition(marker);
      this.infoContent = marker.full_name;
      if (this.infoCurrentKey == key) {
        this.infoOpened = !this.infoOpened;
      } else {
        this.infoOpened = true;
        this.infoCurrentKey = key;
      }
    },
    //End For Map Display

    ShowRaiseTicketDiv() {
      try {
        this.resetForm();
        this.ticketTaggingDisplay = true;
        this.ticketLabel = 'Raise Ticket';
        this.checkAllSelected = false;
        this.tableShipment = false;
        this.RaiseTicketDiv = true;

        window.scrollTo(0, document.body.scrollHeight);

        this.getSearchtags(this.ShipmentTransactionLogSummary.BusinessFlow);
        this.getTrackingSource();
        this.OtherShipmentShippingIDCheckedArr = [];

        if (this.AllShipmentLogArrData.length > 0) {
          let shipmentIndex = this.AllShipmentLogArrData.findIndex(o => o.ShippingID == this.ShippingID);
          if (this.SearchType == "ParentAWB") {
            this.selectTrackship();
          }
          if (-1 !== shipmentIndex && -1 === this.ticketShipmentData.findIndex(o => o.ShippingID == this.ShippingID)) {
            this.ticketShipmentData.push({
              'index': shipmentIndex,
              'shippingData': {
                'ShippingID': (this.SelectTypeOptionObj.value=='ShippingID')?this.AllShipmentLogArrData[shipmentIndex].ShippingID:this.SalesDemo.ParentAWB, // For passing ParentAWB
                'CurrentHubID': this.AllShipmentLogArrData[shipmentIndex].CurrentHubID,
                "TotalAttemptCount": this.AllShipmentLogArrData[shipmentIndex].TotalAttemptCount,
                "UserProcess": this.AllShipmentLogArrData[shipmentIndex].UserProcess,
                "NotificationType": this.AllShipmentLogArrData[shipmentIndex].NotificationType,
                "NotificationStatus": this.AllShipmentLogArrData[shipmentIndex].NotificationStatus,
                "ClientName": this.AllShipmentLogArrData[shipmentIndex].ClientName,
                'BusinessFlow': this.AllShipmentLogArrData[shipmentIndex].BusinessFlow,
                "Status": this.AllShipmentLogArrData[shipmentIndex].Status,
                "CurrentStatus": this.AllShipmentLogArrData[shipmentIndex].CurrentStatus,
                "CreatedDate": this.AllShipmentLogArrData[shipmentIndex].CreatedDate,
                "OrderType": this.AllShipmentLogArrData[shipmentIndex].OrderType
              }
            });
           let eleRemoved = this.AllShipmentLogArrData.splice(shipmentIndex, 1);
            this.AllShipmentLogArrData.unshift(eleRemoved[0]);
            this.OtherShipmentShippingIDCheckedArr.push(this.ShippingID);
            // Scroll Down everytime functionality
            setTimeout(function () {
              window.scrollTo(0, document.body.scrollHeight);
            }, 1000);

          }
        }
        //byDefalutSelectAll for changing shipment category
        if (this.SelectTypeOptionObj.value === 'ShippingID'){

        }
        else{
          this.byDefaultSelectAll();
        }

      } catch (error) {
        this.RaiseTicketDiv = false;
        let msg = error + " - ShowRaiseTicketDiv";
        this.$alertify.error(msg);
      }

    },

    selectTrackship() {
      this.ticketShipmentData.push({
        'index': 0,
        'shippingData': {
          'ShippingID': this.SalesDemo.ParentAWB, // For passing Parent AWB
          'CurrentHubID': this.AllShipmentLogArrData[0].CurrentHubID,
          "TotalAttemptCount": this.AllShipmentLogArrData[0].TotalAttemptCount,
          "UserProcess": this.AllShipmentLogArrData[0].UserProcess,
          "NotificationType": this.AllShipmentLogArrData[0].NotificationType,
          "NotificationStatus": this.AllShipmentLogArrData[0].NotificationStatus,
          "ClientName": this.AllShipmentLogArrData[0].ClientName,
          'BusinessFlow': this.AllShipmentLogArrData[0].BusinessFlow,
          "Status": this.AllShipmentLogArrData[0].Status,
          "CurrentStatus": this.AllShipmentLogArrData[0].CurrentStatus,
          "CreatedDate": this.AllShipmentLogArrData[0].CreatedDate,
          "OrderType": this.AllShipmentLogArrData[0].OrderType
        }
      });
      this.OtherShipmentShippingIDCheckedArr.push(this.AllShipmentLogArrData[0].ShippingID);
    },

    getDepartmentNameFromId() {
      //this.OrderDetails.srUserData.FirstName = '';
      let token = constantVariable.DEPARTMENT_ID_TOKEN;
      this.input = ({
        'DepartmentID': this.DepartmentID,
      });
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getDepartmentNameFromId',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        if (result.data.data.data.code === 200) {
          this.DepartmentName = result.data.data.data.data.DepartmentName;
        } else {
          let msg = result.data.data.data.error;
          this.$alertify.error(msg);
        }
      }, error => {
        this.isLoading = false;
        var commonVariable = commonFunction.showNetworkError(error);
        this.$alertify.error(commonVariable);
      })
    },

    fetchSrUserDetailsData(userid) {
      //this.OrderDetails.srUserData.FirstName = '';
      let token = 'c423ed60f34c0021016fc65cb53a9ad4';
      const secretKey = constantVariable.enckey;
      const encryptedData = AES.encrypt(userid, secretKey).toString();
      let ecuserid = encryptedData.replace(/[=]/g, '_');
      this.input = ({
        'userid': ecuserid,
      });
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'fetchSrUserDetails',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {

        if (result.data.data.data.code === 200) {
          this.OrderDetails.srUserData = result.data.data.data.userdetails;
          this.displayCurrentLocation = this.OrderDetails.srUserData.FirstName;
        } else {
          let msg = result.data.data.data.error;
          this.$alertify.error(msg);
        }

      }, error => {
        let msg = error;
        this.$alertify.error(msg);
      })
    },

    fetchSrLocationDetailsData(srid) {
      this.OrderDetails.srLocationDetails = {};
      let token = 'c423ed60f34c0021016fc65cb53a9ad4';
      this.input = ({
        'srid': srid,
      });
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'fetchSrLocationDetails',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        if (result.data.data.data.ResultCode === 100) {
          this.OrderDetails.srLocationDetails = result.data.data.data.data;
        } else {
          this.OrderDetails.srLocationDetails.srid = 0;
          let msg = result.data.data.data.ReturnMessage;
          this.$alertify.error(msg);
        }

      }, error => {
        this.OrderDetails.srLocationDetails.srid = 0;
        let msg = error;
        this.$alertify.error(msg);
      })
    },
    openModal() {
      this.Testmodal = true;
    },
    resetForm() {

      var self = this; //you need this because *this* will refer to Object.keys below`

      this.sourceId = '';
      this.selectedSourceObj = {
        value: '',
        text: ''
      };

      this.ticketTypeId = '';
      this.selectedTicketObj = {
        value: '',
        text: ''
      };

      this.reasonId = '';
      this.selectedReasonObj = {
        value: '',
        text: ''
      };

      this.subReasonId = '';
      this.selectedSubReasonObj = {
        value: '',
        text: ''
      };

      this.actionId = '';
      this.selectedActionObj = {
        value: '',
        text: ''
      };

      this.ticketStatusId = '';
      this.selectedTicketStatusObj = {
        value: '',
        text: ''
      };

      this.searchId = '';
      this.selectedSearchObj = {
        value: '',
        text: ''
      };
      this.reAttemptDate = '';
      // === B2B CRM ALT Instruction Section Start === -- reseting value of input paramter
      this.reattemptTimeSlotWithDate='',
      this.pickupAddress= '',
      this.contactNumber='',
      // === B2B CRM ALT Instruction Section End ===
      this.location = '';
      this.address = '';
      this.pincode = '';
      this.orderType = [{
        value: 'cod/prepaid',
        text: 'COD <> Prepaid'
      }];
      this.netPayment = '';
      this.orderTypeId = '';
      this.selectedOrderTypeObj = {
        value: '',
        text: ''
      };
      this.alternateContactNo = '';
      this.mobileNo = '';
      this.comments = '';
      this.ticketShipmentData = [];
      this.ticket = {};
      this.emailAddress = '';

      this.OtherShipmentShippingIDCheckedArr = [];

      for (let i = 0; i < this.AllShipmentLogArrData.length; i++) {

        if (document.getElementById(this.AllShipmentLogArrData[i].ShippingID) != null && document.getElementById(this.AllShipmentLogArrData[i].ShippingID).disabled == true) {
          document.getElementById(this.AllShipmentLogArrData[i].ShippingID).disabled = false;
        }
      }
      this.allSelected = false;
      this.disPayment = false;
      this.disPaymentMethod = false;

      // #changedesti
      //#7472
      this.SalesReturnNoteRTODocDataLink=''
      this.ebnRTODocDataLink=''
      this.validateduploadEbn = false
      this.validateduploadSalesReturnNote = false
      this.disabledFlag = false;
      this.hubIds= ''
      this.kamPocIds= ''
      this.opsPocIds= ''
      this.selectedHubObj= {
        value: '',
        text: ''
      }
      this.selectedKamPocObj= {
        value: '',
        text: ''
      }
      this.selectedOpsPocObj= {
        value: '',    
        text: ''
      }
      this.proofstatus='';
      this.EwaybillNo='';
      this.isEwayBillNumberValid = false;
      this.validateB2BEwayclick=false;
      //#7472
      this.isConsigneeValidated = false;
      Object.assign(this.consignee, {
        id: '',
        consigneegstno: '',
        consigneecompanyname: '',
        consigneeaddress: '',
        consigneemobile: '',
        consigneetelephone: '',
        consigneespoc: '',
        consigneestate: '',
        consigneecity: '',
        consigneehub:  '',
        consigneemail: ''
      });
      this.gstNo='';
      //#7472
            // #changedesti
    },

    closeBModalCommonFunction(string) {
     
      [this.filter, this.Ticketmodal, this.SendSMS.SendSMSModal, this.locationMapModal, this.BagNoObj.BagShipmentDetailsModal, this.BagNoObj.TransitStatusModal, this.ShipmentLogModal, this.Callpatching.CallPatchingModal, this.ticketResultModal, this.MultipleProductInfo.MultipleProductInfoModal, this.TicketLogModal, this.IVRCallRecording.IVRCallRecordingModal, this.UploadRTODocsmodal, this.UploadDestinationDocsmodal, string] = commonFunction.closeBModalCommonFunction(string);
      if (string === 'ticketResultModal') {
        this.pendingCreateTicketContext = null;
      }
      this.salesReturnNoteNo = '';
      this.salesReturnNoteValue = '';
      this.EwaybillNo = '';
            this.SalesReturnNoteRTODocDataLink = '';
      this.ebnRTODocDataLink = '';
      // Test Handling
      // this.$refs.uploadSalesReturnNote.value=null;
      // this.$refs.uploadEbn.value=null;
      if (this.$refs.uploadSalesReturnNote) {
        this.$refs.uploadSalesReturnNote.value = null;
      }
      if (this.$refs.uploadEbn) {
        this.$refs.uploadEbn.value = null;
      }
      
    },

    editTicket(ticket) {
      try {
        this.resetForm();
        if (this.DepartmentID == '1') {
          this.$alertify.error('Ticket already exist and assigned to B2B Client support team ');
          return false;
        }
        if (ticket.ticketstatus == 'Open' && ticket.action == 'RTO') {
          this.ticketLabel = "Closed Ticket";
          // ticket.ticketstatus = 'Open';
          this.RaiseTicketDiv = false;
          this.UploadRTODocsmodal = true;
          // this.UploadDestinationDocsmodal = true;
        } else {
          this.ticketLabel = "Edit Ticket";
          this.Ticketmodal = false;
          this.RaiseTicketDiv = true;
        }

        if(ticket.ticketstatus == 'Open'  && ticket.reasonid==this.CHANGE_DESTINATION  && this.DepartmentID==this.B2BCENTRALOPS){
          this.disabledFlag=true;
        }
        this.ticketTaggingDisplay = false;
        this.tableShipment = true;
        this.source = [];
        this.selectedSourceObj.text = ticket.source;
        this.selectedSourceObj.value = this.sourceId = ticket.sourceid;

        this.ticketType = [];
        this.selectedTicketObj.text = ticket.maintype;
        this.selectedTicketObj.value = this.ticketTypeId = ticket.tickettypeid;
        this.reason = [];
        this.subReason = [];

        let enableSubReason = false;
        if (ticket.businessflow == 'Forward') {
          if (-1 !== this.arrDisplaySubTypes[0].subtypes.findIndex(o => o.id == ticket.subreasonid)) {

            this.getTrackingSubType(this.ticketTypeId, ticket.businessflow, 'Edit', ticket.subreasonid);
            enableSubReason = true;
          }

        } else {

          if (-1 !== this.arrDisplaySubTypes[1].subtypes.findIndex(o => o.id == ticket.subreasonid)) {
            this.getTrackingSubType(this.ticketTypeId, ticket.businessflow, 'Edit', ticket.subreasonid);
            enableSubReason = true;

          }
        }

        this.selectedReasonObj.text = ticket.subtype;
        this.selectedReasonObj.value = this.reasonId = ticket.reasonid;

        if (enableSubReason == true) {
          this.getTrackingType(this.reasonId, ticket.businessflow, 'Edit', ticket.subreasonid);
        }
        this.selectedSubReasonObj.text = ticket.typename;
        this.selectedSubReasonObj.value = this.subReasonId = ticket.subreasonid;
        this.reAttemptDate = ticket.reattemptdate;
        this.address = ticket.address;
        this.pincode = ticket.pincode;
        this.location = ticket.name;
        this.ticketId = ticket.ticketid;
        this.mobileNo = (ticket.mobilenumber != null && ticket.mobilenumber != '') ? ticket.mobilenumber : null;
        this.alternateContactNo = (ticket.alternatecontactnumber != null && ticket.alternatecontactnumber != '') ? ticket.alternatecontactnumber : null;
        this.emailAddress = (ticket.emailaddress != null && ticket.emailaddress != '') ? ticket.emailaddress : null;
        this.orderTypeId = ticket.ordertype;
        this.netPayment = ticket.netpayment;
        this.validated = false;
        this.validateduploadSalesReturnNote = false;
        this.validateduploadEbn = false;

         //dummy
        // #changedesti
        //#7472
        this.ebnRTODocDataLink=ticket.adlinfo.ebnRTODocDataLink;
        this.SalesReturnNoteRTODocDataLink=ticket.adlinfo.SalesReturnNoteRTODocDataLink
        this.hubIds=ticket.adlinfo.hubIds
        console.log(ticket.adlinfo,"ticket.adlinfo===============");
        
        this.selectedHubObj.text=ticket.adlinfo.selectedHubObj
           //#7472
        // Set POC IDs and objects from ticket data
        this.kamPocIds = ticket.kam_poc_email || '';
        this.opsPocIds = ticket.ops_poc_email || '';
           //#7472
        // Set selected POC objects immediately
        if (ticket.kam_poc_email) {
          this.selectedKamPocObj = {
            text: ticket.kam_poc_email,
            value: ticket.kam_poc_name || ticket.kam_poc_email
          };
        }
           //#7472
        if (ticket.ops_poc_email) {
          this.selectedOpsPocObj = {
            text: ticket.ops_poc_email,
            value: ticket.ops_poc_name || ticket.ops_poc_email
          };
        }
           //#7472
        // Fetch POC data for Change destination tickets to populate dropdown options
        if (ticket.typename === 'Change destination as per Ops' && ticket.ops_poc_email && this.ShipmentTransactionLogSummary.CurrentHubID) {          
          this.fetchOpsPocFromCurrentHubId(this.ShipmentTransactionLogSummary.OriginHubID, true);
        }
           //#7472
        if (ticket.typename === 'Change destination as per Client' && ticket.kam_poc_email && this.ShipmentTransactionLogSummary.clientBuisnessAccountid) {
          this.fetchKamPocFromClientId(this.ShipmentTransactionLogSummary.clientBuisnessAccountid, true);
        }
        
        this.EwaybillNo=ticket.adlinfo.EwaybillNo
                // #changedesti
        this.ticket = ticket;

        if (this.subReasonId == 44) {
          var method = {
            value: '',
            text: ''
          };
          if (ticket.ordertype == 'PrePaid') {
            method = {
              value: 2,
              text: 'Prepaid'
            };
            this.selectedMethod(method);
          } else {
            method = {
              value: 1,
              text: 'COD'
            };
            this.selectedMethod(method);
          }
        }
        this.disPayment = true;
        this.disPaymentMethod = true;


        // Scroll Down everytime functionality
        setTimeout(function () {
          window.scrollTo(0, document.body.scrollHeight);
        }, 1000);
        this.getTicketAction(ticket.subreasonid, 'Edit');
      } catch (error) {
        this.Ticketmodal = false;
        let msg = error + " - editTicket";
        this.$alertify.error(msg);
      }
    },

    openUploadRTODocs(ticket) {
      this.isShow = false;
      this.validated = true
      this.ticket = ticket;
      this.ShippingID = ticket.shippingid;
      this.ticket.ticketid = ticket.ticketid

      if (this.ticket.shipmentcurrentstatus == 'Invalid' || this.ticket.shipmentstatus == 'Invalid') {
        this.$alertify.error('Shipment already marked as Invalid. ');
        this.Ticketmodal = false;
        return false;
      }
      //#b2b_partial_rto Bypassing Delivered status scenario for B2B partial RTO 
      // if (this.ticket.shipmentcurrentstatus == 'Delivered' || this.ticket.shipmentstatus == 'Delivered') {
      //   this.$alertify.error('Shipment already marked as Delivered. ');
      //   this.Ticketmodal = false;
      //   return false;
      // }
      if (this.ticket.shipmentcurrentstatus == 'RTOTerminal' || this.ticket.shipmentstatus == 'RTOTerminal') {
        this.$alertify.error('Shipment already marked as RTOTerminal. ');
        this.Ticketmodal = false;
        return false;
      }
      // Re-enable after 5 seconds
      this.timeout = setTimeout(() => {
        this.validated = false
      }, 4000)
      this.UploadRTODocsmodal = true;
      this.SumOfTotalInvoices = this.resultSUMofInvoices();
      this.getRTOTicketsdata = this.getRTOTickets();
    },
    //#7472
    normalizeTicketDetails(ticket) {
      if (!ticket || typeof ticket !== 'object') {
        return ticket || {};
      }
      const normalized = Object.assign({}, ticket);
      if (normalized.subreasonid == null) {
        normalized.subreasonid = normalized.subReasonId != null
          ? normalized.subReasonId
          : (normalized.SubReasonId != null ? normalized.SubReasonId : normalized.subreason);
      }
      if (!normalized.ticketstatus) {
        normalized.ticketstatus = normalized.ticketStatus || normalized.TicketStatus;
      }
      if (!normalized.ticketid) {
        normalized.ticketid = normalized.ticketId || normalized.TicketID;
      }
      if (normalized.reasonid == null) {
        normalized.reasonid = normalized.reasonId != null ? normalized.reasonId : normalized.ReasonId;
      }
      if (!normalized.typename) {
        normalized.typename = normalized.typeName || normalized.TypeName || normalized.subReason || normalized.SubReason;
      }
      return normalized;
    },
    resolveCreateTicketFromResponse(responseData) {
      if (!responseData) {
        return null;
      }
      if (Array.isArray(responseData)) {
        return responseData[0] || null;
      }
      if (responseData.data) {
        return this.resolveCreateTicketFromResponse(responseData.data);
      }
      if (typeof responseData === 'object') {
        return responseData;
      }
      return null;
    },
    captureCreateTicketContext() {
      this.pendingCreateTicketContext = {
        subReasonId: this.subReasonId,
        subReasonText: this.selectedSubReasonObj && this.selectedSubReasonObj.text,
        ticketStatusId: this.ticketStatusId,
        reasonId: this.reasonId,
        actionText: this.selectedActionObj && this.selectedActionObj.text,
      };
    },
    enrichTicketDetailsFromFormState(ticket, preferFormState) {
      const enriched = this.normalizeTicketDetails(ticket);
      const input = this.input || {};
      const context = this.pendingCreateTicketContext || {};
      const shouldPreferForm = preferFormState === true;

      const subReasonId = context.subReasonId || this.subReasonId || input.subReasonId;
      if (subReasonId !== '' && subReasonId != null && (shouldPreferForm || enriched.subreasonid == null)) {
        enriched.subreasonid = Number(subReasonId);
      }

      const typename = context.subReasonText ||
        (this.selectedSubReasonObj && this.selectedSubReasonObj.text) ||
        input.subReason;
      if (typename && (shouldPreferForm || !enriched.typename)) {
        enriched.typename = typename;
      }

      const ticketStatus = context.ticketStatusId || this.ticketStatusId || input.ticketStatusId;
      if (ticketStatus && (shouldPreferForm || !enriched.ticketstatus)) {
        enriched.ticketstatus = ticketStatus;
      }

      const reasonId = context.reasonId || this.reasonId || input.reasonId;
      if (reasonId !== '' && reasonId != null && (shouldPreferForm || enriched.reasonid == null)) {
        enriched.reasonid = Number(reasonId);
      }

      const actionText = context.actionText ||
        (this.selectedActionObj && this.selectedActionObj.text);
      if (actionText && (shouldPreferForm || !enriched.action)) {
        enriched.action = actionText;
      }

      if (!enriched.ticketstatus && this.isSupportDepartmentForDestinationUpload() &&
        this.isChangeDestinationUploadTicket(enriched)) {
        enriched.ticketstatus = 'Open';
      }

      return enriched;
    },
    isChangeDestinationAsPerClientTicket(ticket) {
      if (!ticket) {
        return false;
      }
      const normalizedTicket = this.normalizeTicketDetails(ticket);
      const wrongPincodeSubReasonText = 'Wrong Pincode given by the Client on the Invoice';
      const typenameLower = (normalizedTicket.typename || '').toString().toLowerCase();
      if (Number(normalizedTicket.subreasonid) === this.CHANGE_DESTINATION_AS_PER_CLIENT) {
        return true;
      }
      if (Number(normalizedTicket.subreasonid) === this.WRONG_PINCODE_GIVEN_BY_CLIENT_ON_INVOICE) {
        return true;
      }
      if (typenameLower === 'change destination as per client') {
        return true;
      }
      if (typenameLower === wrongPincodeSubReasonText.toLowerCase()) {
        return true;
      }
      if (
        Number(this.subReasonId) === this.CHANGE_DESTINATION_AS_PER_CLIENT ||
        Number(this.subReasonId) === this.WRONG_PINCODE_GIVEN_BY_CLIENT_ON_INVOICE ||
        (this.selectedSubReasonObj && Number(this.selectedSubReasonObj.value) === this.CHANGE_DESTINATION_AS_PER_CLIENT) ||
        (this.selectedSubReasonObj && Number(this.selectedSubReasonObj.value) === this.WRONG_PINCODE_GIVEN_BY_CLIENT_ON_INVOICE) ||
        (this.selectedSubReasonObj && (this.selectedSubReasonObj.text || '').toLowerCase() === wrongPincodeSubReasonText.toLowerCase()) ||
        (this.pendingCreateTicketContext && Number(this.pendingCreateTicketContext.subReasonId) === this.CHANGE_DESTINATION_AS_PER_CLIENT) ||
        (this.pendingCreateTicketContext && Number(this.pendingCreateTicketContext.subReasonId) === this.WRONG_PINCODE_GIVEN_BY_CLIENT_ON_INVOICE) ||
        (this.pendingCreateTicketContext && (this.pendingCreateTicketContext.subReasonText || '').toLowerCase() === 'change destination as per client') ||
        (this.pendingCreateTicketContext && (this.pendingCreateTicketContext.subReasonText || '').toLowerCase() === wrongPincodeSubReasonText.toLowerCase())
      ) {
        return true;
      }
      return false;
    },
    isChangeDestinationAsPerOpsTicket(ticket) {
      if (!ticket) {
        return false;
      }
      const normalizedTicket = this.normalizeTicketDetails(ticket);
      const opsSubReasonText = 'Change destination as per Ops';
      const typenameLower = (normalizedTicket.typename || '').toString().toLowerCase();
      if (Number(normalizedTicket.subreasonid) === constantVariable.ChangeDestinationAsPerClientOPS) {
        return true;
      }
      if (typenameLower === opsSubReasonText.toLowerCase()) {
        return true;
      }
      if (
        Number(this.subReasonId) === constantVariable.ChangeDestinationAsPerClientOPS ||
        (this.selectedSubReasonObj && Number(this.selectedSubReasonObj.value) === constantVariable.ChangeDestinationAsPerClientOPS) ||
        (this.selectedSubReasonObj && (this.selectedSubReasonObj.text || '').toLowerCase() === opsSubReasonText.toLowerCase()) ||
        (this.pendingCreateTicketContext && Number(this.pendingCreateTicketContext.subReasonId) === constantVariable.ChangeDestinationAsPerClientOPS) ||
        (this.pendingCreateTicketContext && (this.pendingCreateTicketContext.subReasonText || '').toLowerCase() === opsSubReasonText.toLowerCase())
      ) {
        return true;
      }
      return false;
    },
    canShowShipmentTicketUpdateButton(ticket) {
      if (!ticket || ticket.ticketstatus === 'Closed' || ticket.action === 'RTO') {
        return false;
      }
      if (this.isChangeDestinationAsPerClientTicket(ticket)) {
        return this.DepartmentID == this.B2BCLIENTHEAD;
      }
      if (this.isChangeDestinationAsPerOpsTicket(ticket)) {
        return this.DepartmentID == this.B2BOPSHEAD;
      }
      return this.DepartmentID == this.B2BCLIENTHEAD || this.DepartmentID == this.B2BOPSHEAD;
    },
    isChangeDestinationUploadTicket(ticket) {
      return this.isChangeDestinationAsPerClientTicket(ticket) || this.isChangeDestinationAsPerOpsTicket(ticket);
    },
    isSupportDepartmentForDestinationUpload() {
      return this.DepartmentID == this.B2BCLIENTSUPPORT || this.DepartmentID == this.B2BOPSSUPPORT;
    },
    canShowChangeDestinationUploadButton(ticket, ticketStatus) {
      if (!this.isSupportDepartmentForDestinationUpload() || !ticket) {
        return false;
      }
      const normalizedTicket = this.normalizeTicketDetails(ticket);
      let status = (normalizedTicket.ticketstatus || '').toString().trim().toLowerCase();
      if (!status && this.pendingCreateTicketContext && this.pendingCreateTicketContext.ticketStatusId) {
        status = this.pendingCreateTicketContext.ticketStatusId.toString().trim().toLowerCase();
      }
      if (status !== ticketStatus) {
        return false;
      }
      if (Object.keys(normalizedTicket).length === 0) {
        return false;
      }
      if (this.DepartmentID == this.B2BCLIENTSUPPORT) {
        return this.isChangeDestinationAsPerClientTicket(ticket);
      }
      if (this.DepartmentID == this.B2BOPSSUPPORT) {
        return this.isChangeDestinationAsPerOpsTicket(ticket);
      }
      return false;
    },
    isDestinationDocsUploadFlow(ticket) {
      if (this.UploadDestinationDocsmodal) {
        return true;
      }
      const ticketToCheck = ticket || this.ticket || this.ticketdetails;
      return this.isChangeDestinationUploadTicket(ticketToCheck);
    },
    setActiveUploadDocsModal(ticket) {
      if (this.isDestinationDocsUploadFlow(ticket)) {
        this.UploadDestinationDocsmodal = true;
        this.UploadRTODocsmodal = false;
      } else {
        this.UploadRTODocsmodal = true;
        this.UploadDestinationDocsmodal = false;
      }
    },
    isOpenChangeDestClientUploadTicket(ticket) {
      return this.canShowChangeDestinationUploadButton(ticket, 'open');
    },
    isClosedChangeDestClientUploadTicket(ticket) {
      return this.canShowChangeDestinationUploadButton(ticket, 'closed');
    },
    openUploadDestinationDocs(ticket) {
      // console.log("🚀 ~ ticket:", ticket)  
      this.isShow = false;
      this.validated = true
      this.ticket = this.normalizeTicketDetails(ticket);
      this.ShippingID = this.ShippingID;
      this.ticket.ticketid = this.ticket.ticketid ? this.ticket.ticketid : this.ticket.TicketID;
      // console.log("🚀 ~ this.ticket.ticketid:", this.ticket.ticketid)


      if (this.ticket.shipmentcurrentstatus == 'Invalid' || this.ticket.shipmentstatus == 'Invalid') {
        this.$alertify.error('Shipment already marked as Invalid. ');
        this.Ticketmodal = false;
        return false;
      }
      if (this.ticket.shipmentcurrentstatus == 'Delivered' || this.ticket.shipmentstatus == 'Delivered') {
        this.$alertify.error('Shipment already marked as Delivered. ');
        this.Ticketmodal = false;
        return false;
      }
      // if (this.ticket.shipmentcurrentstatus == 'RTOTerminal' || this.ticket.shipmentstatus == 'RTOTerminal') {
      //   this.$alertify.error('Shipment already marked as RTOTerminal. ');
      //   this.Ticketmodal = false;
      //   return false;
      // }
      // Re-enable after 5 seconds
      this.timeout = setTimeout(() => {
        this.validated = false
      }, 4000)
      this.showDestinationDocsViewOnly = false;  
      this.UploadDestinationDocsmodal = true;
       this.SumOfTotalInvoices = this.resultSUMofInvoiceschangedest();
       this.getRTOTicketsdata = this.getDestinatioTickets();
    },


     //#7472 
   async  viewDestinationDocs(ticket, event) {

     event.preventDefault();
      this.isShow = false;
      this.validated = true
      this.ticket = ticket;
      this.ShippingID = this.ShippingID;
      this.ticket.ticketid = ticket.ticketid
      this.isModelLoading = false;
      this.timeout = setTimeout(() => {
        this.validated = false
      }, 4000)
      this.showDestinationDocsViewOnly = true;    // Show table only 
      this.UploadDestinationDocsmodal = true;
      this.SumOfTotalInvoices = await this.resultSUMofInvoiceschangedest(); // handle loading by await
  this.getRTOTicketsdata = await this.getDestinatioTickets(); // handle loading by await
    },
    openTicketModal() {
      this.Ticketmodal = true;
      this.getShipmentTickets(this.ShippingID);
    },

    async getPaginationData(pageNum) {
      try {
        this.pageno = pageNum - 1;     //#common_fixes pageno set for dynamic offset
        await this.getShipmentTickets(this.ShippingID);
      } catch (error) {
        let msg = error + " - getPaginationData";
        this.$alertify.error(msg);
      }
    },

    async OnFilterClick(event) {
      try {
        this.pageno = 0;
        await this.getShipmentTickets(this.ShippingID);
        // this.$refs.paginate.selected = 0;
      } catch (error) {
        let msg = error + " - OnFilterClick";
        this.$alertify.error(msg);
      }
    },

    getShipmentTickets(shipmentId, TickID = 0) {
      try {
        this.isModelLoading = true;
        let projectID = CryptoJS.AES.encrypt('$#@COD&&Mang&*^%$$', "xb-cod-security");
        let accessToken;
          //#common_fixes dynamically handle offset and limit 
          let limit = 10;
          let offset = this.pageno * limit;
        let token = 'edw3r323432472748923';
        // shipmentId = '1231070';
        this.input = ({
          'shipmentid': shipmentId,
          'offset': offset,  //#common_fixes offset to get shipping data from index
          'limit': limit,   //#common_fixes limit to get shipping data to index
          'searchData': this.filter
        });

        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getb2bShipmentTickets', // add for b2b
          'data': this.input,
          headers: commonFunction.getusertoken(),
        }).then(result => {

          if (true == result.data.data.status) {
            if (TickID > 0) {
              var shipTicketsData = result.data.data.data;
              let shipTicketsLength = shipTicketsData.length;
              for (let i = 0; i < shipTicketsLength; i++) {
                if (TickID == shipTicketsData[i].ticketid) {
                  this.shipmentTickets = [];
                  this.shipmentTickets[0] = shipTicketsData[i];
                }
              }
              this.counter++;
            } else {
              this.counter = 0;
              this.shipmentTickets = result.data.data.data;

              if (this.shipmentTickets.length > 0) {
                var totalRows = this.shipmentTickets[0].full_count;
                if (totalRows < 10) {
                  this.pagecount = 1;
                  this.pageno = 0;
                } else {
                  this.pagecount = Math.ceil(totalRows / 10)
                }
              } else {
                this.pagecount = 0;
              }
            }
          }
          this.isModelLoading = false;

        }, error => {
          this.isModelLoading = false;
          let msg = error;
          this.$alertify.error(msg);

        })
      } catch (error) {
        this.isModelLoading = false;
        this.Ticketmodal = false;
        let msg = error + " - getb2bShipmentTickets";
        this.$alertify.error(msg);
      }
    },

    getTrackingSource() {
      let projectID = CryptoJS.AES.encrypt('$#@COD&&Mang&*^%$$', "xb-cod-security");
      let accessToken;

      this.isLoading = true;
      let token = 'edw3r323432472748923';

      this.input = ({
        'departmentid': '1',
        'usertype': 'Agent',
        'businesstype': 'Cargo'
      });

      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getTrackingSource',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        this.isLoading = false;
        this.source = result.data.data.data;
      }, error => {
        let msg = error;
        this.$alertify.error(msg);
      })
    },

    selectedSource(sourceData) {
       this.selectedSourceObj = sourceData;
      this.sourceId = sourceData.value;
      this.getTrackingMainType();
    },

    selectedTicket(ticketData) {
       this.selectedTicketObj = ticketData;
      this.ticketTypeId = ticketData.value.toString();
      this.selectedReasonObj = {};
      this.selectedSubReasonObj = {};
      this.subReason = [];
      this.selectedActionObj = {};

      this.getTrackingSubType(this.ticketTypeId, this.ShipmentTransactionLogSummary.BusinessFlow, 'Add');
    },

    selectedMethod(method) {
      this.selectedMethodObj = method;
      this.methodId = method.value;
      if (this.subReasonId == 44) {
        if (this.methodId == 1) {
          this.orderTypeId = "CashOnDelivery";
        } else {
          this.orderTypeId = "PrePaid";
        }
      }
    },

    selectedHub(hubData) {
      try {
        this.selectedHubObj = hubData;
        this.hubIds = hubData.value.toString();
      } catch (error) {
        let msg = error + " - selectedHub";
        this.$alertify.error(msg);
      }
    },

    // Format a hub id as "HubName(HubID)" using loaded hub lists; returns '' if not found
    formatHubDisplayById(hubId) {
      if (hubId === undefined || hubId === null || hubId === '') return '';
      const idStr = hubId.toString();
      const sources = [this.hubList, this.userHublist];
      for (let i = 0; i < sources.length; i++) {
        const list = sources[i];
        if (Array.isArray(list) && list.length > 0) {
          const match = list.find(h => h && h.value !== undefined && h.value !== null && h.value.toString() === idStr);
          if (match && match.text) return match.text;
        }
      }
      return '';
    },

    // Extract branch name only from strings like:
    // "Transit InScan 01-07-2026 15:49:42 PNQ/WKD(117) PUNE, MAHARASHTRA" -> "PNQ/WKD"
    // "PNQ/WKD(117)" -> "PNQ/WKD"
    extractBranchNameOnly(hubDisplay) {
      if (hubDisplay === undefined || hubDisplay === null || hubDisplay === '') {
        return '';
      }
      var str = hubDisplay.toString().trim();
      var match = str.match(/([A-Za-z0-9/_-]+)\(\d+\)/);
      if (match && match[1]) {
        return match[1];
      }
      return str;
    },

    selectedReason(reasonData) {
      let ShippingIDEle;
      if (reasonData.text == 'Shipment Invalid' && !(this.SalesDemo.ShipmentStatus == 'Pending' || this.SalesDemo.ShipmentStatus == 'PickupNotDone')) {
        this.$alertify.error('Shipmentstatus is not in Pending OR PickupNotDone.');
        return false;
      }
      if ('Raise Ticket' == this.ticketLabel) {
        if (reasonData.text == "Change Address") {

          if (this.ticketShipmentData.length === 0) {
            this.$alertify.error('Please select shipment.');
            return false;
          }
          if (this.ticketShipmentData.length > 1) {
            this.$alertify.error('Please select only one shipment to modify address.');
            return false;
          }

          if (this.ShippingID != this.ticketShipmentData[0].shippingData.ShippingID) {
            this.$alertify.error('Kindly Change Destination Address at Parent AWB level');
            return false;
          }
          let shippingDataIndex = this.AllShipmentLogArrData.findIndex(o => o.ShippingID === this.ShippingID);

          if (-1 !== shippingDataIndex) {
            this.OtherShipmentShippingIDCheckedArr = [];
            this.OtherShipmentShippingIDCheckedArr.push(this.ShippingID);
            // this.allSelected = false;

            this.ticketShipmentData = [];
            this.ticketShipmentData.push({
              'index': shippingDataIndex,
              'shippingData': {
                "ShippingID": this.AllShipmentLogArrData[shippingDataIndex].ShippingID,
                'CurrentHubID': this.AllShipmentLogArrData[shippingDataIndex].CurrentHubID,
                "TotalAttemptCount": this.AllShipmentLogArrData[shippingDataIndex].TotalAttemptCount,
                "UserProcess": this.AllShipmentLogArrData[shippingDataIndex].UserProcess,
                "NotificationType": this.AllShipmentLogArrData[shippingDataIndex].NotificationType,
                "NotificationStatus": this.AllShipmentLogArrData[shippingDataIndex].NotificationStatus,
                "ClientName": this.AllShipmentLogArrData[shippingDataIndex].ClientName,
                'BusinessFlow': this.AllShipmentLogArrData[shippingDataIndex].BusinessFlow,
                "Status": this.AllShipmentLogArrData[shippingDataIndex].Status,
                "CurrentStatus": this.AllShipmentLogArrData[shippingDataIndex].CurrentStatus,
                "CreatedDate": this.AllShipmentLogArrData[shippingDataIndex].CreatedDate,
                "OrderType": this.AllShipmentLogArrData[shippingDataIndex].OrderType
              }
            });
          }
          for (ShippingIDEle in this.AllShipmentLogArrData) {

            if (this.ShippingID !== this.AllShipmentLogArrData[ShippingIDEle].ShippingID) {
              document.getElementById(this.AllShipmentLogArrData[ShippingIDEle].ShippingID).disabled = true;
            }
          }
          // this.allSelected = false;
          this.checkAllSelected = true;
          if (this.allSelected) {
            this.allSelected = true;
          } else {
            this.allSelected = false;
          }

        } else {

          for (ShippingIDEle in this.AllShipmentLogArrData) {

            if (this.ShippingID !== this.AllShipmentLogArrData[ShippingIDEle].ShippingID) {
              document.getElementById(this.AllShipmentLogArrData[ShippingIDEle].ShippingID).disabled = false;

            }
          }
          // this.allSelected = false;
          this.checkAllSelected = false;
          if (this.allSelected) {
            this.allSelected = true;
          } else {
            this.allSelected = false;
          }
        }
      }
      this.selectedReasonObj = reasonData;
      this.reasonId = reasonData.value.toString();
      this.selectedSubReasonObj = {};
      this.selectedActionObj = {};
      this.selectedTicketStatusObj = {};
      this.ticketStatusId = '';

      if ('Raise Ticket' == this.ticketLabel) {
        this.getTrackingType(this.reasonId, this.ShipmentTransactionLogSummary.BusinessFlow, 'Add', null);
      } else {
        if (this.ShipmentTransactionLogSummary.BusinessFlows == 'Forward' && this.ticket.subreasonid === constantVariable.URGENT_DELIVERY) {
          this.getTrackingType(this.reasonId, this.ShipmentTransactionLogSummary.BusinessFlow, 'Edit', this.ticket.subreasonid);
        } else {
          // this.getTrackingType(this.reasonId, this.ShipmentTransactionLogSummary.BusinessFlow, 'Add', null );
          this.getTrackingType(this.reasonId, this.ShipmentTransactionLogSummary.BusinessFlow, 'Edit', this.ticket.subreasonid);
        }

      }
    },

    selectedSubReason(subReasonData) {
    try {

        let ShippingIDEle;
        this.reAttemptDate = '';

        if ('Raise Ticket' == this.ticketLabel) {

          if (subReasonData.text == "Change payment mode / amount" || subReasonData.text == "Change Reattempt Date" ||
            subReasonData.text == "" || subReasonData.text == "Update Alternate Contact No" || subReasonData.text == "Update Email Address") {

            if (this.ticketShipmentData.length === 0) {
              this.$alertify.error('Please select shipment.');
              return false;
            }
            if (this.ticketShipmentData.length > 1) {
              this.$alertify.error('Please select only one shipment to ' + subReasonData.text);
              return false;
            }

            let shippingDataIndex = this.AllShipmentLogArrData.findIndex(o => o.ShippingID === this.ticketShipmentData[0].shippingData.ShippingID);

            for (ShippingIDEle in this.AllShipmentLogArrData) {

              if (this.ticketShipmentData[0].shippingData.ShippingID !== this.AllShipmentLogArrData[ShippingIDEle].ShippingID) {
                document.getElementById(this.AllShipmentLogArrData[ShippingIDEle].ShippingID).disabled = true;
              }
            }
            // this.allSelected = false;
            this.checkAllSelected = true;
            if (this.allSelected) {
              this.allSelected = true;
            } else {
              this.allSelected = false;
            }

          } else {

            if (this.selectedReasonObj.text != "Change Address") {

              for (ShippingIDEle in this.AllShipmentLogArrData) {

                if (this.ShippingID !== this.AllShipmentLogArrData[ShippingIDEle].ShippingID) {
                  document.getElementById(this.AllShipmentLogArrData[ShippingIDEle].ShippingID).disabled = false;
                }
              }
              // this.allSelected = false;
              this.checkAllSelected = false;
              if (this.allSelected) {
                this.allSelected = true;
              } else {
                this.allSelected = false;
              }
            }
          }
        }

        this.selectedSubReasonObj = subReasonData;

        this.subReasonId = subReasonData.value.toString();
        this.selectedActionObj = {};
        this.selectedTicketStatusObj = {};
        this.ticketStatusId = '';
        this.escalation = subReasonData.isescalation;


        // Call fetch OpsPoc only for 'Change destination as per Ops'
        if (this.selectedSubReasonObj && this.selectedSubReasonObj.text === 'Change destination as per Ops' && 
            this.ShipmentTransactionLogSummary.CurrentHubID) {              
          this.fetchOpsPocFromCurrentHubId(this.ShipmentTransactionLogSummary.OriginHubID);
        }
       // Call fetch KamPoc only for 'Change destination as per Client'
        if (this.selectedSubReasonObj && this.selectedSubReasonObj.text === 'Change destination as per Client' && 
            this.ShipmentTransactionLogSummary.ClientID) {
          this.fetchKamPocFromClientId(this.ShipmentTransactionLogSummary.ClientID);
        }
        // #serviceable_other_branch : populate Destination Branch dropdown with full hub master list
        if (this.isServiceableFromOtherBranchSubReasonSelected()) {
          this.resetServiceableFromOtherBranchHubSelection();
          if (this.isServiceableFromOtherBranchPincode) {
            this.fetchHubData();
          }
        }
        if ('Raise Ticket' == this.ticketLabel) {
          this.getTicketAction(this.subReasonId, 'Add');
        } else {
          this.getTicketAction(this.subReasonId, 'Edit');
        }

        if (this.subReasonId == 44) {
          var method = {
            value: '',
            text: ''
          };
          if (this.OrderDetails.OrderType == 'Prepaid') {
            method = {
              value: 2,
              text: 'Prepaid'
            };
            this.selectedMethod(method);
          } else {
            method = {
              value: 1,
              text: 'COD'
            };
            this.selectedMethod(method);
          }
        }

      } catch (error) {
        let msg = error + " - selectedSubReason";
        this.$alertify.error(msg);
      }
    },

    selectedAction(actionData) {
       try {
        if ('Raise Ticket' == this.ticketLabel) {
          if (this.selectedReasonObj.text == "Change Address" || this.selectedSubReasonObj.text == "Change payment mode / amount" || this.selectedSubReasonObj.text == "Change Reattempt Date" ||
            this.selectedSubReasonObj.text == "" || this.selectedSubReasonObj.text == "Update Alternate Contact No" || this.selectedSubReasonObj.text == "Update Email Address") {

            if (this.ticketShipmentData.length === 0) {
              this.$alertify.error('Please select shipment.');
              return false;
            }

            if (this.ticketShipmentData.length > 1) {
              this.$alertify.error('Please select only one shipment to ' + this.selectedSubReasonObj.text);
              return false;
            }

            if (this.ShippingID != this.ticketShipmentData[0].shippingData.ShippingID) {
              this.$alertify.error('Kindly ' + this.selectedSubReasonObj.text + ' at Parent AWB level. ');
              return false;
            }
            let shippingDataIndex = this.AllShipmentLogArrData.findIndex(o => o.ShippingID === this.ShippingID);

            if (-1 !== shippingDataIndex) {
              this.OtherShipmentShippingIDCheckedArr = [];
              this.OtherShipmentShippingIDCheckedArr.push(this.ShippingID);
              // this.allSelected = false;
             this.ticketShipmentData = [];
              this.ticketShipmentData.push({
                'index': shippingDataIndex,
                'shippingData': {
                  'ShippingID': this.AllShipmentLogArrData[shippingDataIndex].ShippingID,
                  'CurrentHubID': this.AllShipmentLogArrData[shippingDataIndex].CurrentHubID,
                  "TotalAttemptCount": this.AllShipmentLogArrData[shippingDataIndex].TotalAttemptCount,
                  "UserProcess": this.AllShipmentLogArrData[shippingDataIndex].UserProcess,
                  "NotificationType": this.AllShipmentLogArrData[shippingDataIndex].NotificationType,
                  "NotificationStatus": this.AllShipmentLogArrData[shippingDataIndex].NotificationStatus,
                  "ClientName": this.AllShipmentLogArrData[shippingDataIndex].ClientName,
                  'BusinessFlow': this.AllShipmentLogArrData[shippingDataIndex].BusinessFlow,
                  "Status": this.AllShipmentLogArrData[shippingDataIndex].Status,
                  "CurrentStatus": this.AllShipmentLogArrData[shippingDataIndex].CurrentStatus,
                  "CreatedDate": this.AllShipmentLogArrData[shippingDataIndex].CreatedDate,
                  "OrderType": this.AllShipmentLogArrData[shippingDataIndex].OrderType
                }
              });
            }
            for (let ShippingIDEle in this.AllShipmentLogArrData) {

              if (this.ShippingID !== this.AllShipmentLogArrData[ShippingIDEle].ShippingID) {
                document.getElementById(this.AllShipmentLogArrData[ShippingIDEle].ShippingID).disabled = true;
              }
            }
            // this.allSelected = false;
            this.checkAllSelected = true;
            if (this.allSelected) {
              this.allSelected = true;
            } else {
              this.allSelected = false;
            }

          } else {
         for (let ShippingIDEle in this.AllShipmentLogArrData) {

              if (this.ShippingID !== this.AllShipmentLogArrData[ShippingIDEle].ShippingID) {
                 document.getElementById(this.AllShipmentLogArrData[ShippingIDEle].ShippingID).disabled = false;

              }
            }
            // this.allSelected = false;
            this.checkAllSelected = false;
            if (this.allSelected) {
              this.allSelected = true;
            } else {
              this.allSelected = false;
            }
          }
        }
        if (this.selectedSubReasonObj.text !== 'Urgent delivery' && this.selectedSubReasonObj.text !== 'Urgent pickup' && this.selectedSubReasonObj.text !== 'RTO Reattempt' && this.selectedSubReasonObj.text !== 'Fake update' && this.selectedSubReasonObj.text !== 'DTO Reattempt' &&
          this.selectedSubReasonObj.value !== constantVariable.DELAY_IN_PICKUP_SUB_REASON && this.selectedSubReasonObj.value !== constantVariable.FAKE_NPR &&
          this.selectedSubReasonObj.value !== constantVariable.DENIED_PICKUP && this.selectedSubReasonObj.value !== constantVariable.FAKE_NDR && this.selectedSubReasonObj.value !== constantVariable.REFUSED_DOORSTEP_DELIVERY && this.selectedSubReasonObj.text !== 'Delay in service') {

          if (this.selectedSubReasonObj.text == 'Change Reattempt Date') {
            if (this.SalesDemo.ReattemptDate != null) {
              this.oldReAttemptDate = commonFunction.changeDateFormat(this.SalesDemo.ReattemptDate);
            }
            if (this.SalesDemo.ReattemptDate != null) {
              this.reAttemptDate = commonFunction.formatDateString(this.SalesDemo.ReattemptDate);
            }
            this.startDate = new Date();
            let dateDisabled3 = new Date();
            dateDisabled3.setDate(dateDisabled3.getDate() + 6);
            this.endDate = dateDisabled3;
          } else if (this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Change delivery address as per Client' || this.selectedSubReasonObj.text == 'Change Pickup address' || this.selectedSubReasonObj.text == 'Change misroute pincode' || this.selectedSubReasonObj.text == 'Change DTO address') {

            this.emailAddress = (this.CustomerDetails.EmailID != null && this.CustomerDetails.EmailID != '' && this.CustomerDetails.EmailID != 'undefined') ? this.CustomerDetails.EmailID : '';

          } else {
            this.endDate = null;
            if (this.selectedSubReasonObj.text == 'Future delivery' || this.selectedSubReasonObj.text == 'Future Pickup' || this.selectedSubReasonObj.text == 'Pickup without QC' || this.selectedSubReasonObj.text == 'Exceptional pickup' || this.selectedSubReasonObj.text == 'Self collect' || this.selectedSubReasonObj.text == 'PDD Crossed') {
              let tomorrow = new Date();
              if (this.startDate.getHours() < 20) {
                tomorrow.setDate(tomorrow.getDate() + 1);
                this.startDate = tomorrow;
              } else {
                tomorrow.setDate(tomorrow.getDate() + 2);
                this.startDate = tomorrow;
              }
              let dateDisabled = new Date();
              dateDisabled.setDate(dateDisabled.getDate() + 7);
              this.endDate = dateDisabled;
            }
          }
        } else {
          this.startDate = new Date();
          let dateDisabled2 = new Date();
          dateDisabled2.setDate(dateDisabled2.getDate() + 6);
          this.endDate = dateDisabled2;
        } //selectedMethod
         if ('Raise Ticket' == this.ticketLabel) {
          if (this.ticketShipmentData.length > 0 && this.ticketShipmentData[0].shippingData.OrderType && this.ticketShipmentData[0].shippingData.OrderType !== null && this.ticketShipmentData[0].shippingData.OrderType !== undefined) {
            var method = {
              value: '',
              text: ''
            };
            if (this.ticketShipmentData[0].shippingData.OrderType.toLowerCase() == 'cod') {
              // this.orderTypeId = "PrePaid";
                this.orderTypeId = "CashOnDelivery";
              method = {
                value: 1,
                text: 'COD'
              };
              this.selectedMethod(method);
            }
            if (this.ticketShipmentData[0].shippingData.OrderType.toLowerCase() == 'prepaid') {
              // this.orderTypeId = "CashOnDelivery";
              this.orderTypeId = "PrePaid";
              method = {
                value: 2,
                text: 'Prepaid'
              };
              this.selectedMethod(method);
            }
          }
        }

        //  console.log("this.orderTypeId "+this.orderTypeId);
        // this.ticketLabel = "Edit Ticket"
        if (this.ticketLabel == 'Edit Ticket') {
          this.disPayment = true;
        }
        this.selectedActionObj = actionData;
        this.actionId = actionData.value.toString();
        this.getTicketActionStatus(actionData.value);

      } catch (error) {
        let msg = error + " - selectedAction fun";
        this.$alertify.error(msg);
      }
    },

    updateSelectedAction(actionData) {

      try {
        if (this.selectedSubReasonObj.text !== 'Urgent delivery' && this.selectedSubReasonObj.text !== 'Urgent pickup' && this.selectedSubReasonObj.text !== 'RTO Reattempt' && this.selectedSubReasonObj.text !== 'Fake update' && this.selectedSubReasonObj.text !== 'DTO Reattempt' && this.selectedSubReasonObj.text !== 'Change Reattempt Date' &&
          this.selectedSubReasonObj.value !== constantVariable.DELAY_IN_PICKUP_SUB_REASON && this.selectedSubReasonObj.value !== constantVariable.FAKE_NPR &&
          this.selectedSubReasonObj.value !== constantVariable.DENIED_PICKUP && this.selectedSubReasonObj.value !== constantVariable.FAKE_NDR && this.selectedSubReasonObj.value !== constantVariable.REFUSED_DOORSTEP_DELIVERY && this.selectedSubReasonObj.text !== 'Delay in service') {

          this.endDate = null;
          if (this.selectedSubReasonObj.text == 'Future delivery' || this.selectedSubReasonObj.text == 'Future Pickup' || this.selectedSubReasonObj.text == 'Pickup without QC' || this.selectedSubReasonObj.text == 'Exceptional pickup' || this.selectedSubReasonObj.text == 'Self collect' || this.selectedSubReasonObj.text == 'PDD Crossed' ||
            this.selectedSubReasonObj.value == constantVariable.DELAY_IN_PICKUP_SUB_REASON || this.selectedSubReasonObj.value == constantVariable.FAKE_NPR ||
            this.selectedSubReasonObj.value == constantVariable.DENIED_PICKUP || this.selectedSubReasonObj.value == constantVariable.FAKE_NDR || this.selectedSubReasonObj.value == constantVariable.REFUSED_DOORSTEP_DELIVERY) {

            let tomorrow = new Date();
            if (this.startDate.getHours() < 20) {
              tomorrow.setDate(tomorrow.getDate() + 1);
              this.startDate = tomorrow;
            } else {
              tomorrow.setDate(tomorrow.getDate() + 2);
              this.startDate = tomorrow;
            }
            let dateDisabled = new Date();
            dateDisabled.setDate(dateDisabled.getDate() + 7);
            this.endDate = dateDisabled;
          }

        } else {
          this.startDate = new Date();
          let dateDisabled2 = new Date();
          dateDisabled2.setDate(dateDisabled2.getDate() + 6);
          this.endDate = dateDisabled2;
        }
        this.selectedActionObj = actionData;
        this.actionId = actionData.value.toString();
        this.tableShipment = true;
        this.getTicketActionStatus(actionData.value);
        this.disPayment = true;

      } catch (error) {
        this.isLoading = false;
        let msg = error + " - selectedAction";
        this.$alertify.error(msg);
      }
    },

    selectedTicketStatus(ticketStatusData) {

      this.selectedTicketStatusObj = ticketStatusData;
      this.ticketStatusId = ticketStatusData.value;
    },

    selectedSearchTag(SelectedTagData) {

      this.selectedSearchObj = SelectedTagData;
      this.searchId = SelectedTagData.value;
      this.getSearchResult(SelectedTagData.id, SelectedTagData.type, this.ShipmentTransactionLogSummary.BusinessFlow);

      // Call fetch OpsPoc when search tag is 'Change destination as per Ops'
      if (SelectedTagData.text === 'Change destination as per Ops' && this.ShipmentTransactionLogSummary.CurrentHubID) {        
        this.fetchOpsPocFromCurrentHubId(this.ShipmentTransactionLogSummary.OriginHubID);
      }
      // Call fetch OpsPoc when search tag is 'Change destination as per client'
      if (SelectedTagData.text === 'Change destination as per Client' && this.ShipmentTransactionLogSummary.ClientID) {
        this.fetchKamPocFromClientId(this.ShipmentTransactionLogSummary.ClientID);
      }
      // if(SelectedTagData.text === constantVariable.SERVICEABLE_FROM_OTHER_BRANCH_SUBREASON){
      //   // #serviceable_other_branch : populate Destination Branch dropdown from Branch Master
      //   this.fetchHubData();
      //   this.hubIds = '';
      //   this.selectedHubObj = { value: '', text: '' };
      // }
    },

    getTrackingMainType() {

      let accessToken;

      this.isLoading = true;
      let token = 'edw3r323432472748923';

      this.input = ({
        'departmentid': '1',
        'page': this.page
      });

      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getTrackingMainType',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        this.isLoading = false;
        this.ticketType = result.data.data.data;

      }, error => {
        let msg = error;
        this.$alertify.error(msg);
      })
    },

    getTrackingSubType(mainTypeId, businessFlow, type, subReasonId) {

      this.isLoading = true;
      let token = 'edw3r323432472748923';
      let category = this.categoryOptionObj.text;
      const secretKey = constantVariable.enckey;
      const encryptedData = AES.encrypt(this.DepartmentID.toString(), secretKey).toString();
      let ecDepartmentID = encryptedData.replace(/[=]/g, '_');
      this.input = ({
        'departmentid': ecDepartmentID,
        'maintypeid': mainTypeId,
        'businessFlow': businessFlow,
        'page': this.page,
        'category': (type == 'Add') ? category : '',
        'type': type,
        'subReasonId': subReasonId,
        "isLatestOfd": this.SalesDemo.IsLatestOFD,
        "notificationType": this.SalesDemo.NotificationType,
        'notificationStatus': this.SalesDemo.NotificationStatus
      });

      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getTrackingSubType',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        this.isLoading = false;
        this.reason = result.data.data.data;
        if (this.reason) {

        } else {
          let msg = constantVariable.UNAUTORISED_USER_MSG;
          this.$alertify.error(msg);
        }
      }, error => {
        this.isLoading = false;
        let msg = error;
        this.$alertify.error(msg);
      })
    },

    getTrackingType(subTypeId, businessFlow, type, subReasonId) {
      let accessToken;

      this.isLoading = true;
      let token = 'edw3r323432472748923';
      let category = this.categoryOptionObj.text;

      this.input = ({
        'departmentid': this.DepartmentID,
        'subtypeid': subTypeId,
        'businessFlow': businessFlow,
        'page': this.page,
        'category': (type == 'Add') ? category : '',
        'type': type,
        'subReasonId': subReasonId,
        "notificationType": this.SalesDemo.NotificationType,
        'notificationStatus': this.SalesDemo.NotificationStatus,
        'status': this.SalesDemo.Status
      });

      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getTrackingType',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        this.isLoading = false;
        this.subReason = result.data.data.data;

        if (this.subReason) {
          // #serviceable_other_branch : show this sub-reason only when ShipmentDetails.IsServiceableFromOtherBranch is true
          if (!this.isServiceableFromOtherBranchPincode) {
            this.subReason = this.subReason.filter(function (subReasonItem) {
              return Number(subReasonItem.value) !== constantVariable.SERVICEABLE_FROM_OTHER_BRANCH_SUBREASON_ID &&
                subReasonItem.text !== constantVariable.SERVICEABLE_FROM_OTHER_BRANCH_SUBREASON;
            });
          }
          if (this.selectedTicketObj.text == 'Request' && this.selectedReasonObj.text == 'Change Address') {

            if ((this.SalesDemo.ClientID != constantVariable.ICICI_BANK_LTD && this.SalesDemo.ClientID != constantVariable.RBL_BANK) || this.SalesDemo.BusinessType.toLowerCase() == 'ecom') {

              var indexRedirectBank = this.subReason.findIndex(o => o.text == 'Redirect to Bank');
              if (-1 !== indexRedirectBank) {
                this.subReason.splice(indexRedirectBank, 1);
              }
              var indexSecondaryBank = this.subReason.findIndex(o => o.text == 'Redirect to secondary address');
              if (-1 !== indexSecondaryBank) {
                this.subReason.splice(indexSecondaryBank, 1);
              }

              var indexPrimaryBank = this.subReason.findIndex(o => o.text == 'Redirect to primary address');

              if (-1 !== indexSecondaryBank) {
                this.subReason.splice(indexPrimaryBank, 1);
              }

            } else {
              var indexDeliveryAddress = this.subReason.findIndex(o => o.text == 'Change delivery address as per Client');
              if (-1 !== indexRedirectBank) {
                this.subReason.splice(indexDeliveryAddress, 1);
              }
            }

          } else {

            if ((this.SalesDemo.NotificationStatus === null) || (this.SalesDemo.NotificationStatus != 'Reattempt' &&
                this.SalesDemo.NotificationStatus != 'Escalation' && this.SalesDemo.NotificationStatus != 'SuperEscalation')) {
              var indexReattemptDate = this.subReason.findIndex(o => o.text == 'Change Reattempt Date');
              if (-1 !== indexReattemptDate) {
                this.subReason.splice(indexReattemptDate, 1);
              }
            }
          }
        } else {
          let msg = constantVariable.UNAUTORISED_USER_MSG;
          this.$alertify.error(msg);
        }
      }, error => {
        let msg = error;
        this.$alertify.error(msg);
      })
    },

    getTicketAction(subReasonId, status) {
      let accessToken;
    
      this.isLoading = true;
      let token = 'edw3r323432472748923';

      this.input = ({
        subReasonId: subReasonId,
        status: status,
        'page': this.page,
        departmentId: this.DepartmentID,
        role: this.Role.rolename
      });
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getTicketAction',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {

        this.isLoading = false;
        // === B2B CRM ALT Instruction Section Start === -- reseting value of input paramter
        this.reattemptTimeSlotWithDate='',
        this.pickupAddress= '',
        this.contactNumber='',
        // === B2B CRM ALT Instruction Section End ===
        this.action = result.data.data.data;
        if (this.action) {

          let flag = false;
          let rvpflag = false;

          var indexCsTeam = this.action.findIndex(o => o.text == 'Assigned to Client Support');

          if (-1 !== indexCsTeam) {
            if (this.SalesDemo.BusinessFlow == 'Forward') {
              this.action[indexCsTeam].text = 'Assigned to Fwd Client Support Team';
            } else {
              this.action[indexCsTeam].text = 'Assigned to Rvp Client Support Team';
            }
          }

          if (this.subDepartmentList) {
            for (var i = 0; i < this.subDepartmentList.length; i++) {
              if (this.SalesDemo.BusinessFlow == 'Forward' && status == 'Add' && -1 !== indexCsTeam && this.action[indexCsTeam] != undefined && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team') {
                if (this.subDepartmentList[i].value === constantVariable.FWD_ClIENT_SUPPORT) {
                  flag = true;
                  break;
                }
              }
              if (this.SalesDemo.BusinessFlow == 'Forward' && status == 'Edit') {
                if (this.subDepartmentList[i].value === constantVariable.FWD_ClIENT_SUPPORT) {
                  flag = true;
                  break;
                }
              }
            }

            // Reverse flow
            // for (var i = 0; i < this.subDepartmentList.length; i++) {

            //   if (this.SalesDemo.BusinessFlow == 'Reverse' && status == 'Add' && -1 !== indexCsTeam && this.action[indexCsTeam] != undefined && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team') {
            //     if (this.subDepartmentList[i].value === constantVariable.RVP_ClIENT_SUPPORT) {
            //       rvpflag = true;
            //       break;
            //     }
            //   }

            //   if (this.SalesDemo.BusinessFlow == 'Reverse' && status == 'Edit') {
            //     if (this.subDepartmentList[i].value === constantVariable.RVP_ClIENT_SUPPORT) {
            //       rvpflag = true;
            //       break;
            //     }
            //   }
            // }



          }

          if ('Admin' !== this.userRole && this.selectedSubReasonObj.text == 'Change Reattempt Date') {
            // console.log('flag : ' + flag);
            if (flag == false) {
              let indexOpsTeam = this.action.findIndex(o => o.text == 'Arranged - Assigned to Ops Team');
              // console.log('indexOpsTeam : ' + indexOpsTeam);
              if (-1 !== indexOpsTeam) {
                //this.action.splice(indexOpsTeam, 1);
              } else {
                this.action.push('Assigned to Fwd Client Support Team');
              }
            } else {
              let indexFwdCsTeam = this.action.findIndex(o => o.text == 'Assigned to Fwd Client Support Team');
              if (-1 !== indexFwdCsTeam) {
                this.action.splice(indexFwdCsTeam, 1);
              }
            }
          }
          if ('Admin' !== this.userRole && flag == false) {
            var indexRTONotify = this.action.findIndex(o => o.text == 'RTO');
            if (-1 !== indexRTONotify) {
              if (this.SalesDemo.BusinessFlow == 'Forward' && status == 'Add' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team') {
                this.action.splice(indexRTONotify, 1);
              }
              if (this.SalesDemo.BusinessFlow == 'Forward' && flag == false && status == 'Edit') {
                this.action.splice(indexRTONotify, 1);
              }
              if (this.SalesDemo.BusinessFlow == 'Reverse') {
                this.action.splice(indexRTONotify, 1);
              }
            }
          }

          if ('Admin' !== this.userRole) {
            var indexStatusChanged = this.action.findIndex(o => o.text == 'Status Changed');

            if (-1 !== indexStatusChanged) {
              if (this.SalesDemo.BusinessFlow == 'Forward' && status == 'Add' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team' && flag == false) {
                this.action.splice(indexStatusChanged, 1);
              }
              if (this.SalesDemo.BusinessFlow == 'Forward' && flag == false && status == 'Edit') {
                this.action.splice(indexStatusChanged, 1);
              }

              if (this.SalesDemo.BusinessFlow == 'Reverse' && status == 'Add' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team' && rvpflag == false) {
                this.action.splice(indexStatusChanged, 1);
              }
              if (this.SalesDemo.BusinessFlow == 'Reverse' && rvpflag == false && status == 'Edit') {
                this.action.splice(indexStatusChanged, 1);
              }
            }
          }


          if ('Admin' !== this.userRole) {

            //Remove Address updated tagging for non admin user.
            var indexAddressUpdated = this.action.findIndex(o => o.text == 'Address Updated');
            if (-1 !== indexAddressUpdated) {
              if (this.SalesDemo.BusinessFlow == 'Forward' && status == 'Add' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team' && flag == false) {
                this.action.splice(indexAddressUpdated, 1);
              }
              if (this.SalesDemo.BusinessFlow == 'Forward' && flag == false && status == 'Edit') {
                this.action.splice(indexAddressUpdated, 1);
              }

              if (this.SalesDemo.BusinessFlow == 'Reverse' && status == 'Add' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team' && rvpflag == false) {
                this.action.splice(indexAddressUpdated, 1);
              }
              if (this.SalesDemo.BusinessFlow == 'Reverse' && rvpflag == false && status == 'Edit') {
                this.action.splice(indexAddressUpdated, 1);
              }
            }
          }


          if ('Admin' !== this.userRole) {
            var indexContactUpdated = this.action.findIndex(o => o.text == 'Contact details updated');
            if (-1 !== indexContactUpdated) {
              if (this.SalesDemo.BusinessFlow == 'Forward' && status == 'Add' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team' && flag == false) {
                this.action.splice(indexContactUpdated, 1);
              }
              if (this.SalesDemo.BusinessFlow == 'Forward' && flag == false && status == 'Edit') {
                this.action.splice(indexContactUpdated, 1);
              }

              if (this.SalesDemo.BusinessFlow == 'Reverse' && status == 'Add' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team' && rvpflag == false) {
                this.action.splice(indexContactUpdated, 1);
              }
              if (this.SalesDemo.BusinessFlow == 'Reverse' && rvpflag == false && status == 'Edit') {
                this.action.splice(indexContactUpdated, 1);
              }
            }
          }

          if ('Admin' !== this.userRole) {
            var indexPickupCancelled = this.action.findIndex(o => o.text == 'Pickup Cancelled');

            if (-1 !== indexPickupCancelled) {

              if (this.SalesDemo.BusinessFlow == 'Reverse' && status == 'Add' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team' && rvpflag == false) {
                this.action.splice(indexPickupCancelled, 1);
              }
              if (this.SalesDemo.BusinessFlow == 'Reverse' && -1 !== indexCsTeam && rvpflag == false && status == 'Edit') {
                this.action.splice(indexPickupCancelled, 1);
              }
              if (this.SalesDemo.BusinessFlow == 'Forward') {
                this.action.splice(indexPickupCancelled, 1);
              }

            }
          }

          if (this.selectedSubReasonObj.text == 'Change RTO address' || this.selectedSubReasonObj.text == 'Change DTO address') {

            this.location = this.RTODetails.CustomerName;
            if ('edit' == status) {
              this.address = this.RTODetails.Address;
              this.pincode = this.RTODetails.PinCode;
            }
          }

          if (this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Change delivery address as per Client' || this.selectedSubReasonObj.text == 'Change Pickup address' || this.selectedSubReasonObj.text == 'Redirect to Bank') {
            this.location = this.CustomerDetails.CustomerName;
            if ('edit' == status) {
              this.address = this.CustomerDetails.Address;
              this.pincode = this.CustomerDetails.Pincode;
            }
          }
           //#7472 autopulate action and status
          if (this.DepartmentID == this.B2BCLIENTHEAD || this.DepartmentID == this.B2BOPSHEAD){
            
            this.selectedActionObj = {
              text: this.action[0].text,
              value: this.action[0].value
            };
            this.actionId = this.selectedActionObj.value.toString();
             this.selectedTicketStatusObj =  {
              text: "Closed"
             }
             this.ticketStatusId = "Closed";
            
          } else if (this.action.length === 1) {
            // Auto-select Resolution/Action when only one option is available
            this.selectedActionObj = {
              text: this.action[0].text,
              value: this.action[0].value
            };
            this.actionId = this.selectedActionObj.value.toString();
            this.getTicketActionStatus(this.selectedActionObj.value);
          }

          /*  //Special code : restriction - Assign to SLPV
           var indexAssigntoSLPV = this.action.findIndex(o => o.text == 'Assign to SLPV');

           if(-1 !== indexAssigntoSLPV){
             if(this.SalesDemo.BusinessFlow == 'Forward' && this.DepartmentID !== 6 && this.DepartmentID == 7){
               this.action.splice(indexAssigntoSLPV, 1);
               }
               if(this.SalesDemo.BusinessFlow == 'Reverse' && this.DepartmentID !== 7 && this.DepartmentID == 6){
                 this.action.splice(indexAssigntoSLPV, 1);
               }
               if(this.DepartmentID == 12){
                 this.action.splice(indexAssigntoSLPV, 1);
               }
             } */

        } else {
          let msg = constantVariable.UNAUTORISED_USER_MSG;
          this.$alertify.error(msg);
        }

      }, error => {
        let msg = error;
        this.$alertify.error(msg);
      })
    },

    getTicketActionStatus(actionId) {
      // console.log(actionId,">>>>>>>>>>>>")
      let accessToken;

      this.isLoading = true;
      let token = 'edw3r323432472748923';
      status = (true == this.tableShipment) ? 'Edit' : 'Add';

      this.reAttemptDate = (status == 'Edit' && this.ticket.reattemptdate != null) ? this.ticket.reattemptdate : '';
      this.input = ({
        actionId: actionId,
        status: status
      });

      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getTicketActionStatus',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        this.isLoading = false;
        if (result.data.data.status == true) {
          let arrStatus = [];
          this.ticketStatus = [];
          arrStatus = result.data.data.data[0].ticketstatus.toString().split(",");

          for (let i = 0; i < arrStatus.length; i++) {
            this.ticketStatus.push({
              'value': arrStatus[i],
              'text': arrStatus[i]
            });
          }

          if (this.ticket.clientid !== null && this.ticket.ticketstatus == 'Closed') {
            this.selectedTicketStatusObj = this.ticketStatus[1];
            this.ticketStatusId = this.selectedTicketStatusObj.value;

          } else {
            this.selectedTicketStatusObj = this.ticketStatus[0];
            this.ticketStatusId = this.selectedTicketStatusObj.value;
          }
        }

      }, error => {

        let msg = error;
        this.$alertify.error(msg);
      })
    },
    RTOticketcloseandUpdate(data) {
      try {
        // this.isModelLoading = true;
        this.UploadRTODocsmodal = false;
        let accessToken;

        let token = 'edw3r323432472748923';
        this.input = {
          "parentawb": this.ShippingID,
          "ticketid": this.ticket.ticketid,
          "sourceid": data.sourceid,
          "actionid": data.actionid,
          "userid": this.userid,
          "reasonid": data.reasonid,
          "hub": data.hub,
          "shipmentcreateddate": data.shipmentcreateddate,
          "shipmentcurrentstatus": data.shipmentcurrentstatus,
          "shipmentstatus": data.shipmentstatus,
          "subreasonid": data.subreasonid,
          "tickettypeid": data.tickettypeid,
          "businessflow": data.businessflow,
          "attempts": data.attempts,
          "comments": "RTO Docs Uploaded and Ticket Closed."
        };
        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'RTOticketcloseandUpdate',
          headers: commonFunction.getusertoken(),
          'data': this.input

        }).then(result => {
          var resultTickets = result.data.data;
          if (resultTickets.status == true) {


            /*Start IP Tracking */
            let userTrackerObj = {};
            userTrackerObj.subReason = this.input.comments + " " + this.input.subreasonid;
            userTrackerObj.shippingIds = this.ShippingID;
            userTrackerObj.userid = this.userid;
            userTrackerObj.username = this.username;
            userTrackerObj.olduserid = this.OldDeliveryUserOrUserId;
            userTrackerObj.projectname = apiUrl.project_name;
            userTrackerObj.trackurl = this.$route.path;
            userTrackerObj.eventTrack = "B2BTicket " + userTrackerObj.subReason;
            authFunction.userTrackerB2BTicket(userTrackerObj);
            /*End IP Tracking */


            this.$alertify.success(result.data.data.msg);
            this.openTicketModal();
            this.createRTODocDataSQS();
          } else {
            this.$alertify.error(result.data.data.msg);
          }
          this.isModelLoading = false;
        }, error => {
          this.isModelLoading = false;
          let msg = error;
          this.$alertify.error(msg);
        })
      } catch (error) {
        this.isModelLoading = false;
        this.UploadRTODocsmodal = false;
        let msg = error + " - RTOticketcloseandUpdate";
        this.$alertify.error(msg);
      }
    },

    getTicketActionStatus_CLOSED(actionId) {
      let accessToken;
      this.isLoading = true;
      let token = 'edw3r323432472748923';
      status = 'Closed';
      this.input = ({
        actionId: 4,
        status: status
      });
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getTicketActionStatus_CLOSED',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        this.isLoading = false;
        if (result.data.data.status == true) {
          let arrStatus = [];
          this.ticketStatus = [];
          arrStatus = result.data.data.data[0].ticketstatus.toString().split(",");
          for (let i = 0; i < arrStatus.length; i++) {
            this.ticketStatus.push({
              'value': arrStatus[i],
              'text': arrStatus[i]
            });
          }
          if (this.ticket.clientid !== null && this.ticket.ticketstatus == 'Closed') {
            this.selectedTicketStatusObj = this.ticketStatus[1];
            this.ticketStatusId = this.selectedTicketStatusObj.value;
          } else {
            this.selectedTicketStatusObj = this.ticketStatus[0];
            this.ticketStatusId = this.selectedTicketStatusObj.value;
          }
        }
      }, error => {
        let msg = error;
        this.$alertify.error(msg);
      })
    },

    getSearchtags(businessFlow) {
      let accessToken;

      this.isLoading = true;
      let token = 'edw3r323432472748923';
      const secretKey = constantVariable.enckey;
      const encryptedData = AES.encrypt(this.DepartmentID.toString(), secretKey).toString();
      let ecDepartmentID = encryptedData.replace(/[=]/g, '_');
      this.input = ({
        "departmentid": ecDepartmentID,
        'businessFlow': businessFlow,
        "page": this.page,
        "category": this.categoryOptionObj.text,
        "isLatestOfd": this.SalesDemo.IsLatestOFD
      });

      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getSearchOption',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        this.isLoading = false;
        this.searchOptions = result.data.data.data;


        Object.entries(this.searchOptions).forEach(entry => {

          entry[1].value = entry[1].id;
          entry[1].text = entry[1].name;

        });

      }, error => {
        let msg = error;
        this.$alertify.error(msg);
      })
    },

    getSearchResult(id, type, businessFlow) {
      let accessToken;
      this.isLoading = true;
      let token = 'edw3r323432472748923';

      this.input = ({
        "id": id,
        "type": type,
        "businessFlow": businessFlow,
        "page": this.page,
        "category": this.categoryOptionObj.text,
        "departmentId": this.DepartmentID,
        "role": this.Role.rolename
      });

      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getSearchResult',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        this.isLoading = false;
        let flag = false;
        let rvpflag = false;
         // === B2B CRM ALT Instruction Section Start === -- Added conition source dropdown will autoselect consignor only in case alternate instruction pickup
        if(id === constantVariable.Alternate_Instruction_Pickup){
        this.selectedSourceObj = this.source.find(o => o.value === constantVariable.Source_Consigner);
        }else{
        this.selectedSourceObj = this.source.find(o => o.text == 'Consignee');
        }
        // === B2B CRM ALT Instruction Section End ===
        this.sourceId = (this.selectedSourceObj.value != '') ? 1 : '';
        if (undefined !== result.data.data.data.main_data) {
          this.ticketType = result.data.data.data.main_data;
          this.selectedTicketObj = this.ticketType.find(o => o.selected == 1);
          this.ticketTypeId = this.selectedTicketObj.value;
        }

        if (undefined !== result.data.data.data.sub_data) {
          this.reason = result.data.data.data.sub_data;
          this.selectedReasonObj = this.reason.find(o => o.selected == 1);
        }
        if (undefined !== result.data.data.data.type_data) {
          this.subReason = result.data.data.data.type_data;
          this.selectedSubReasonObj = this.subReason.find(o => o.selected == 1);
          this.escalation = (undefined != this.selectedSubReasonObj) ? this.selectedSubReasonObj.isescalation : 0;

          if (this.selectedTicketObj.text == 'Request' && this.selectedReasonObj.text == 'Change Address' && this.page == 'trackshipment') {

            if ((this.SalesDemo.ClientID != constantVariable.ICICI_BANK_LTD && this.SalesDemo.ClientID != constantVariable.RBL_BANK) || this.SalesDemo.BusinessType.toLowerCase() == 'ecom') {

              var indexRedirectBank = this.subReason.findIndex(o => o.text == 'Redirect to Bank');
              if (-1 !== indexRedirectBank) {
                this.subReason.splice(indexRedirectBank, 1);
              }
              var indexSecondaryBank = this.subReason.findIndex(o => o.text == 'Redirect to secondary address');
              if (-1 !== indexSecondaryBank) {
                this.subReason.splice(indexSecondaryBank, 1);
              }
              var indexPrimaryBank = this.subReason.findIndex(o => o.text == 'Redirect to primary address');

              if (-1 !== indexSecondaryBank) {
                this.subReason.splice(indexPrimaryBank, 1);
              }
            } else {
              var indexDeliveryAddress = this.subReason.findIndex(o => o.text == 'Change delivery address as per Client');

              if (-1 !== indexRedirectBank) {
                this.subReason.splice(indexDeliveryAddress, 1);
              }
            }
          } else {

            if ((this.SalesDemo.NotificationStatus === null) || (this.SalesDemo.NotificationStatus != 'Reattempt' &&
                this.SalesDemo.NotificationStatus != 'Escalation' && this.SalesDemo.NotificationStatus != 'SuperEscalation')) {

              var indexReattemptDate = this.subReason.findIndex(o => o.text == 'Change Reattempt Date');
              if (-1 !== indexReattemptDate) {
                this.subReason.splice(indexReattemptDate, 1);
              }
            }
          }
        }
        if (undefined !== result.data.data.data.action_data) {

          this.action = result.data.data.data.action_data;
          var indexCsTeam = this.action.findIndex(o => o.text == 'Assigned to Client Support ');

          if (-1 !== indexCsTeam) {
            if (businessFlow == 'Forward') {
              this.action[indexCsTeam].text = 'Assigned to Fwd Client Support Team';
            } else {
              this.action[indexCsTeam].text = 'Assigned to Rvp Client Support Team';
            }
          }
          if (this.subDepartmentList) {
            for (var i = 0; i < this.subDepartmentList.length; i++) {
              if (businessFlow == 'Forward' && -1 !== indexCsTeam && this.action[indexCsTeam] != undefined && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team') {
                if (this.subDepartmentList[i].value === constantVariable.FWD_ClIENT_SUPPORT) {
                  flag = true;
                  break;
                }
              }
            }
            for (var i = 0; i < this.subDepartmentList.length; i++) {

              if (businessFlow == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam] != undefined && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team') {
                if (this.subDepartmentList[i].value === constantVariable.RVP_ClIENT_SUPPORT) {
                  rvpflag = true;
                  break;
                }
              }
            }
          }

          if ('Admin' !== this.userRole && this.selectedSubReasonObj.text == 'Change Reattempt Date') {
            if (flag == false) {
              let indexOpsTeam = this.action.findIndex(o => o.text == 'Arranged - Assigned to Ops Team');
              if (-1 !== indexOpsTeam) {
                this.action.splice(indexOpsTeam, 1);
              } else {
                this.action.push('Assigned to Fwd Client Support Team');
              }
            } else {
              let indexFwdCsTeam = this.action.findIndex(o => o.text == 'Assigned to Fwd Client Support Team');
              if (-1 !== indexFwdCsTeam) {
                this.action.splice(indexFwdCsTeam, 1);
              }
            }
          }

          if ('Admin' !== this.userRole && flag == false) {
            var indexRTONotify = this.action.findIndex(o => o.text == 'RTO');
            if (-1 !== indexRTONotify) {
              if (businessFlow == 'Forward' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team') {
                this.action.splice(indexRTONotify, 1);
              }

            }
          }

          if ('Admin' !== this.userRole) {
            var indexStatusChanged = this.action.findIndex(o => o.text == 'Status Changed');

            if (-1 !== indexStatusChanged) {
              if (businessFlow == 'Forward' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team' && flag == false) {
                this.action.splice(indexStatusChanged, 1);
              }

              if (businessFlow == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team' && rvpflag == false) {
                this.action.splice(indexStatusChanged, 1);
              }
            }
          }

          if ('Admin' !== this.userRole) {

            var indexAddressUpdated = this.action.findIndex(o => o.text == 'Address Updated');
            if (-1 !== indexAddressUpdated) {
              if (businessFlow == 'Forward' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team' && flag == false) {
                this.action.splice(indexAddressUpdated, 1);
              }

              if (businessFlow == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team' && rvpflag == false) {
                this.action.splice(indexAddressUpdated, 1);
              }
            }

            var indexContactUpdated = this.action.findIndex(o => o.text == 'Contact details updated');
            if (-1 !== indexContactUpdated) {
              if (businessFlow == 'Forward' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team' && flag == false) {
                this.action.splice(indexContactUpdated, 1);
              }

              if (businessFlow == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team' && rvpflag == false) {
                this.action.splice(indexContactUpdated, 1);
              }
            }
          }

          if ('Admin' !== this.userRole) {
            var indexPickupCancelled = this.action.findIndex(o => o.text == 'Pickup Cancelled');

            if (-1 !== indexPickupCancelled) {

              if (businessFlow == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team' && rvpflag == false) {
                this.action.splice(indexPickupCancelled, 1);
              }

            }
          }
          // Auto-select Resolution/Action when Search Tagging returns only one option
          if (this.action && this.action.length === 1) {
            this.selectedActionObj = {
              text: this.action[0].text,
              value: this.action[0].value
            };
            this.actionId = this.selectedActionObj.value.toString();
            this.getTicketActionStatus(this.selectedActionObj.value);
          } else {
            this.selectedActionObj = {};
            this.actionId = '';
          }
        }

        if (undefined !== this.selectedReasonObj) {
          this.reasonId = this.selectedReasonObj.value;
        } else {
          this.reasonId = '';
          this.selectedReasonObj = {};
        }
        if (undefined !== this.selectedSubReasonObj) {
          this.subReasonId = this.selectedSubReasonObj.value;

          if (this.selectedSubReasonObj.text == 'Change RTO address' || this.selectedSubReasonObj.text == 'Change DTO address') {

            this.location = this.RTODetails.CustomerName;
            // this.address = this.RTODetails.Address;
            // this.pincode = this.RTODetails.PinCode;

          }

          if (this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Change delivery address as per Client' || this.selectedSubReasonObj.text == 'Change Pickup address' || this.selectedSubReasonObj.text == 'Redirect to Bank') {

            this.location = this.CustomerDetails.CustomerName;
            // this.address = this.CustomerDetails.Address;
            // this.pincode = this.CustomerDetails.Pincode;
          }
        } else {
          this.subReasonId = '';
          this.selectedSubReasonObj = {};
        }
        this.ticketStatus = [],
          this.ticketStatusId = '',
          this.selectedTicketStatusObj = {};

      }, error => {
        let msg = error;
        this.$alertify.error(msg);
      })
    },

    saveTicketDataClick(e) {
      // console.log(this.ShipmentStatus, this.selectedSearchObj, this.AllShipmentLogArrData,">>>>>>>>>>>>>>>")
      this.isModelLoading = true;
      // this.UploadRTODocsmodal = true;
      this.validatedSave = true
      // Re-enable after 5 seconds
      this.timeout = setTimeout(() => {
        this.validatedSave = false
      }, 2000)

      // Apply validation only for Change Destination
              if (
                this.selectedSubReasonObj.text === 'Change destination as per Client' ||
                this.selectedSubReasonObj.text === 'Change destination as per Ops'
              
            ) {
              const terminalStatuses = ['Invalid','invalid','Delivered', 'delivered', 'dto', 'DTO', 'lost','LOST', 'std', 'STD', 'RTOTerminal','Terminal','terminal', 'UCG-Terminal'];

              const shipments = this.AllShipmentLogArrData.flat();

              // Condition 1: Shipment should be InScan
              if (this.ShipmentStatus !== 'InScan') {
                this.$alertify.error(
                  'Destination change is allowed only when the shipment is in InScan status.'
                );
                return;
              }

              // Ignore terminal shipments
              const activeShipments = shipments.filter(
                s => !terminalStatuses.includes(s.Status)
              );

              // Check all active shipments are at the same hub
              var firstHub = activeShipments.length
              ? activeShipments[0].CurrentHubID
              : '';

              const allSameHub = activeShipments.every(
                s => s.CurrentHubID === firstHub
              );

              if (!allSameHub) {
                this.$alertify.error(
                  'Destination change is allowed only when all active MPS shipments are at the same location or the remaining shipments are in terminal status.'
                );
                return;
              }
            }

      this.saveTicketData(e);
    },

    saveTicketData(e) {
      try {
        // console.log(this.selectedReasonObj.value, this.DepartmentID, this.ticket,">>>>>>>>>>>>>>>>>>>>>")
        // === B2B CRM ALT Instruction Section Start === -- Added if condition for B2B create for only parent awb (in case net payment for child mps) -- Added condition valiadte reason, sub reason, ticket tyepe, source, resolution & comment
       // if (this.SelectTypeOptionObj.value === 'ParentAWB' || this.SelectTypeOptionObj.value === 'ShippingID'){
        // b2b_restrict_rto_client
        if (this.SelectTypeOptionObj.value === 'ParentAWB' || 
          (this.SelectTypeOptionObj.value === 'ShippingID' && this.action[0].value === constantVariable.Amount_Updated )){
        if (this.sourceId === '') {
          this.$alertify.error('Please select source.');
          return false;
        }

        if (this.ticketTypeId === '') {
          this.$alertify.error('Please select tiket type.');
          return false;
        }

        if (this.reasonId === '') {
          this.$alertify.error('Please select reason.');
          return false;
        }

        if (this.subReasonId === '') {
          this.$alertify.error('Please select subreason.');
          return false;
        }
        // #serviceable_other_branch : Destination Branch is mandatory for sub-reason 304 when raised by Ops Support
        if (
          this.DepartmentID === this.B2BOPSSUPPORT &&
          this.isServiceableFromOtherBranchSubReasonSelected() &&
          this.isServiceableFromOtherBranchPincode &&
          (this.hubIds === '' || this.hubIds === null || this.hubIds === undefined)
        ) {
          this.$alertify.error('Please select Destination Branch.');
          return false;
        }
        if (this.actionId === '') {
          this.$alertify.error('Please select action.');
          return false;
        }
        if (this.comments === '') {
          this.$alertify.error('Please enter comments.');
          return false;
        }
        // b2b_restrict_rto_client
        if(this.action[0].value ===  constantVariable.Amount_Updated){          
          if(this.SelectTypeOptionObj.value === 'ParentAWB'){
            this.$alertify.error(`Please Update Amount against Child MPS`);
            return false;
          }
          if(this.SalesDemo.Status==='LOST'){
            this.$alertify.error(`Update Amount can not be marked for LOST status.`);
            return false;
          }
          
        }
        // Added condition for creating Alternate Instruction Ticket
        if (
          this.selectedReasonObj.value == constantVariable.Alternate_Instruction_Pickup &&
          (this.SalesDemo.Status !== 'Pending' || this.SalesDemo.ShipmentStatus === 'PickupDone')
        ) {
          this.$alertify.error("Alternate Instruction - Pickup can be marked only for 'Pickup Pending' status shipments.");
          return false;
        }

        if (
          this.selectedReasonObj.value === constantVariable.Alternate_Instruction_Delivery &&
          (this.ShipmentTransactionLogSummary.FinalDestinationID != this.ShipmentTransactionLogSummary.CurrentHubID || 
            this.SalesDemo.Status == 'Pending')
        ) {
          this.$alertify.error("Alternate Instruction - Delivery can be marked after shipment status is RAD.");
          return false;
        }

         // b2b_restrict_rto_client
         //RTO Process restriction for retail client types (FBP, PRCC, PRCW, Paid)
        const clientType = this.SalesDemo.ClientType ? this.SalesDemo.ClientType.trim().toLowerCase() : null;
        if (constantVariable.B2B_RESTRICT_RTO_CLIENT_TYPES.includes(clientType)) {
          if (
            this.selectedReasonObj.text === 'Cancellation Request' &&
            this.action[0].value === constantVariable.RTO &&
            this.selectedTicketStatusObj.value === 'Open'
          ) {
            this.$alertify.alert('', 'RTO is not allowed for Retail/Prepaid clients. Kindly mark the shipment delivered and rebook the return AWB against the same client code.', function () {
            });
           return false;
          }
        }

        // // === B2B CRM ALT Instruction Section End === 
        if (this.action[0].value == constantVariable.RTO && (this.SalesDemo.ShipmentStatus == 'Pending' || this.SalesDemo.ShipmentStatus == 'OutForPickup' || this.SalesDemo.ShipmentStatus == 'PickupNotDone')) {
          this.$alertify.error('RTO can not be marked For Pending,Out for pick up,Pick up not done .');
          return false;
        }
        if (this.SalesDemo.Status == 'RTO') {
          // RTO Cancellation Process   #rto_cancellation_7588
          if (
            this.SalesDemo.Status == 'RTO' 
            && this.selectedReasonObj.value != constantVariable.RTO_CANCELLATION_REQUEST
            && this.selectedActionObj.value !=  constantVariable.RTO_CANCEL
            && this.input.ticketStatusId == 'Open'
          ) {
            this.$alertify.error('Shipment already marked as RTO.');
            return false;
          }
        }
        if (this.action[0].text == 'Shipment Invalid' && !(this.SalesDemo.ShipmentStatus == 'Pending' || this.SalesDemo.ShipmentStatus == 'PickupNotDone')) {
          this.$alertify.error('Shipmentstatus is not in Pending OR PickupNotDone.');
          return false;
        }
    
         //#b2b_partial_rto start
        if (this.SalesDemo.ShipmentStatus === 'Delivered') {
          const isRTO = this.action[0].value === constantVariable.RTO;
          const isPartialDelivered = this.SalesDemo.PartialStatus === 'PartialDelivery';
          
          if (!(isRTO && isPartialDelivered)) {
            this.$alertify.error('Shipment already marked as Delivered.');
            return false;
          }
        }
         //#b2b_partial_rto end
        if (this.SalesDemo.ShipmentStatus == 'Invalid') {
          this.$alertify.error('Shipment already marked as Invalid.');
          return false;
        }
        if (this.SalesDemo.ShipmentStatus == 'RTOTerminal') {
          this.$alertify.error('Shipment already marked as RTOTerminal.');
          return false;
        }
        // this.UploadRTODocsmodal = true;
        this.ticketResultMsg = '';
        if (this.tableShipment === false && this.ticketShipmentData.length == 0) {
          this.$alertify.error('Please select shipments for creating ticket.');
          return false;
        }
        if (this.ticketShipmentData.length > 1) {
          this.$alertify.error('Please select only one shipment.');
          return false;
        }

        var userToken = window.localStorage.getItem('userToken');
        let token = 'edw3r323432472748923';
        var myStr = userToken.replace(/"/g, '');
        // if (this.UploadRTODocsmodal = true) {
        //   this.actionId = constantVariable.RTO_NOTIFIED ;
        // } 
        if (this.sourceId === '') {
          this.$alertify.error('Please select source.');
          return false;
        }

        // === B2B CRM ALT Instruction Section Start === -- Added validation for input parameter
        if (
          (this.selectedSubReasonObj.value == constantVariable.Alternate_Instruction_Pickup ||
           this.selectedSubReasonObj.value == constantVariable.Pickup_Details_Updates) &&
          this.selectedActionObj.value == constantVariable.Address_Updated &&
          (!this.pickupAddress || this.pickupAddress.trim().length < 3 || this.pickupAddress.trim().length > 200)
        ) {
          this.$alertify.error('Please enter a valid pick up address. It should not exceed 200 characters.');
          return false;
        }
        
        if (
          (this.selectedReasonObj.value == constantVariable.Alternate_Instruction_Pickup ||
           this.selectedReasonObj.value == constantVariable.Alternate_Instruction_Delivery) &&
          (this.selectedSubReasonObj.value == constantVariable.Reattempt_Time_Slot_Pickup ||
           this.selectedSubReasonObj.value == constantVariable.Reattempt_Time_Slot_Delivery ||  this.selectedSubReasonObj.value == constantVariable.Hold_Pickup) &&
          (this.selectedActionObj.value == constantVariable.Attempt_Pickup ||
           this.selectedActionObj.value == constantVariable.Attempt_Delivery) &&
          !this.reattemptTimeSlotWithDate
        ) {
         this.$alertify.error(`Please enter ${this.dynamicTimeSlotLabel}.`);
          return false;
        }
        if (
          this.selectedReasonObj.value == constantVariable.Alternate_Instruction_Delivery &&
          this.selectedSubReasonObj.value == constantVariable.Contact_Updated &&
          this.selectedActionObj.value == constantVariable.Updated_Contact &&
          (!this.contactNumber || !/^\d{10}$/.test(this.contactNumber))
        ) {
          this.$alertify.error('Valid 10-digit Contact Number is required.');
          return false;
        }
        // === B2B CRM ALT Instruction Section End ===

        //Comment for B2B MPS: Amount update
        if(this.action[0].text==='Amount Updated' && this.SelectTypeOptionObj.value === 'ShippingID'){
          this.comments=(this.OrderDetails.CollectibleAmount)?(`OLD MPS Value : `+" "+this.OrderDetails.CollectibleAmount+" "+this.comments):this.comments;
        }
        // else if(!commonFunction.checkcommentvalidation(this.comments)){
        //   this.$alertify.error("Please enter valid comment.");
        //   return false
        //   }
        
        this.fakeNdrStatus = 0;
        if ((this.ShipmentTransactionLogSummary.BusinessFlow == 'Forward' && this.selectedReasonObj.text == 'SR related' && this.selectedSubReasonObj.text == 'Fake update') ||
          (this.selectedReasonObj.text == 'Cancellation Request' && this.selectedSubReasonObj.text == 'Fake update') || this.selectedSubReasonObj.text == "ReAttempt") {
          this.fakeNdrStatus = 1;
        }

        let attempDate = (this.reAttemptDate != null && this.reAttemptDate != '') ? this.reAttemptDate : '';

        if (attempDate.length != 10 && attempDate !== '') {
          attempDate = moment(String(attempDate)).format('YYYY-MM-DD');
        }
        let address = (this.address != '') ? this.address : '';
        let pincode = (this.pincode != '') ? this.pincode : '';
        let comments = (this.comments != '') ? this.comments : '';
        let orderTypeId = (this.orderTypeId != '') ? this.orderTypeId : '';
        let netPayment = (this.netPayment != '') ? this.netPayment : '';
        let location = (this.location != '') ? this.location : '';
        let oldReAttemptDate = (this.oldReAttemptDate != '') ? this.oldReAttemptDate : '';
        let alternateContactNo = (this.alternateContactNo != '') ? this.alternateContactNo : '';
        let emailAddress = (this.emailAddress != '') ? this.emailAddress : '';
        let mobileNo = (this.mobileNo != '') ? this.mobileNo : '';
        let hubIds = (this.hubIds != '') ? this.hubIds : '';
        let kamPocIds = (this.kamPocIds != '') ? this.kamPocIds : '';
        let opsPocIds = (this.opsPocIds != '') ? this.opsPocIds : '';

        //let ServiceName = (this.SalesDemo.ServiceType != null && this.SalesDemo.ServiceType != '') ? this.SalesDemo.ServiceType : '';
        let ServiceName = '';

        if (netPayment == '' && this.action[0].text==='Amount Updated') {
          this.$alertify.error('Please enter net amount.');
          return false;
        }
        //#7472 Allowing change destination for specific status
       if( (this.selectedReasonObj.value === constantVariable.ChangeDestination) && (this.selectedSubReasonObj.value === constantVariable.ChangeDestinationAsPerClient || this.selectedSubReasonObj.value === constantVariable.ChangeDestinationAsPerClientOPS)){            
            // Prevent destination change if shipment is marked as RTO   #block_desti
            if(this.SalesDemo.Status === "RTO"){
              this.$alertify.error('Destination change not allowed for RTO shipments.');
            return false;
            }
            if(this.SalesDemo.UserProcess.toLowerCase() == "out for delivery"){
              this.$alertify.error('Destination change not allowed for OFD shipments.');
             return false;
             }             
             if(this.SalesDemo.ShipmentStatus === "OutForPickup"){
              this.$alertify.error('Destination change not allowed for Out For Pickup shipments.');
             return false;
             }
             if(this.SalesDemo.ShipmentStatus === "PickupNotDone"){
              this.$alertify.error('Destination change not allowed for Pickup Not Done shipments.');
             return false;
             }
             if(this.SalesDemo.ShipmentStatus === "Pending"){
              this.$alertify.error('Destination change not allowed for Pending shipments.');
             return false;
             }
             if(this.SalesDemo.ShipmentStatus === "PickupDone"){
              this.$alertify.error('Destination change not allowed for PickupDone shipments.');
             return false;
             }
             if (this.SalesDemo.ShipmentStatus &&
              this.SalesDemo.ShipmentStatus.toLowerCase() === 'bagin') {
              this.$alertify.error('Please remove the shipment from bag and try for destination change.');
              return false;
             }
             
        }
        if (this.selectedSubReasonObj.text == 'Change destination as per Client') {
          if (this.SelectTypeOptionObj.value === 'ShippingID') {
            this.$alertify.error('Destination change is allowed only at AWB level. Please select an individual AWB to proceed.');
            return false;
          }
          // if (address === '') {
          //   this.$alertify.error('Please enter address details.');
          //   return false;
          // }
          if (pincode == '') {
            this.$alertify.error('Please enter pincode.');
            return false;
          }
          // if (this.hubIds === '') {
          //   this.$alertify.error('Please select Hub id.');
          //   return false;
          // }
          if (this.kamPocIds === '') {
            this.$alertify.error('Please select KAM POC id.');
            return false;
          }
         }
         if (this.selectedSubReasonObj.text === 'Change destination as per Ops'){
          if (this.SelectTypeOptionObj.value === 'ShippingID') {
            this.$alertify.error('Destination change is allowed only at AWB level. Please select an individual AWB to proceed.');
            return false;
          }
          if(this.opsPocIds === '')  {
            this.$alertify.error('Please select OPS POC id.');
            return false;
          }
        }

        if ((this.selectedSubReasonObj.text == 'Change RTO address' || this.selectedSubReasonObj.text == 'Change DTO address' ||
            this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Change delivery address as per Client' || this.selectedSubReasonObj.text == 'Change Pickup address' ||
            this.selectedSubReasonObj.text == 'Redirect to Bank') &&
          (this.selectedActionObj.text == 'Address Updated' || this.selectedActionObj.value == constantVariable.ASSIGNED_CS_TEAM)
        ) {
          if (address === '') {
            this.$alertify.error('Please enter address details.');
            return false;
          }
        }

        if ((this.selectedSubReasonObj.text == 'Change RTO address' || this.selectedSubReasonObj.text == 'Change DTO address' ||
            this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Change delivery address as per Client' || this.selectedSubReasonObj.text == 'Change Pickup address' ||
            this.selectedSubReasonObj.text == 'Change misroute pincode' || this.selectedSubReasonObj.text == 'Redirect to Bank' ||
            this.selectedSubReasonObj.value == constantVariable.CHANGE_PINCODE || this.selectedSubReasonObj.value == constantVariable.CHANGE_RTO_PINCODE ||
            this.selectedSubReasonObj.value == constantVariable.CHANGE_DTO_PINCODE) &&
          (this.selectedActionObj.text == 'Address Updated' || this.selectedActionObj.value == constantVariable.ASSIGNED_CS_TEAM)) {

          if (pincode == '') {
            this.$alertify.error('Please enter pincode.');
            return false;
          }
        }
        if (this.selectedSubReasonObj.text == 'Change payment mode / amount' && (this.selectedActionObj.text == constantVariable.ASSIGNED_CS_TEAM ||
            this.selectedActionObj.text == constantVariable.STATUS_CHANGED || this.selectedActionObj.value == constantVariable.PAYMENT_DETAILS_CHANGE_REQUESTED)) {

          if (netPayment == '' && orderTypeId == 'CashOnDelivery') {
            this.$alertify.error('Please enter net amount.');
            return false;
          }
        }

        if ((this.selectedSubReasonObj.text == 'Future delivery' || this.selectedSubReasonObj.text == 'Urgent delivery' ||
            this.selectedSubReasonObj.text == 'Self collect' || this.selectedSubReasonObj.value == constantVariable.DELAY_IN_PICKUP_SUB_REASON ||
            this.selectedSubReasonObj.text == "Change Reattempt Date" || this.selectedSubReasonObj.text == "ReAttempt" ||
            this.selectedSubReasonObj.value == constantVariable.FAKE_NPR || this.selectedSubReasonObj.value == constantVariable.FAKE_PICKUP ||
            this.selectedSubReasonObj.value == constantVariable.DENIED_PICKUP || this.selectedSubReasonObj.value == constantVariable.FAKE_NDR ||
            this.selectedSubReasonObj.value == constantVariable.REFUSED_DOORSTEP_DELIVERY) && (this.selectedActionObj.text == 'Arranged - Assigned to Ops Team' || this.selectedActionObj.value == constantVariable.ATTEMPT_DELIVERY)) {

          if (attempDate == '') {
            this.$alertify.error('Please enter reattempt date.');
            return false;
          }

          if (this.SalesDemo.TotalAttemptCount == '0' || this.SalesDemo.TotalAttemptCount == '') {
            this.$alertify.error('Shipment not attempted even once so Reattempt or Future delivery not acceptable');
            return false;
          }
        }


        if ((this.selectedReasonObj.text == 'Non Behavioral' && this.selectedSubReasonObj.text == 'Delay in service' && this.selectedActionObj.text == 'Arranged - Assigned to Ops Team') ||
          (this.selectedReasonObj.text == 'SR related' && this.selectedSubReasonObj.text == 'Fake update' && this.selectedActionObj.text == 'Arranged - Assigned to Ops Team')) {

          if (attempDate == '') {
            this.$alertify.error('Please enter reattempt date.');
            return false;
          }
          // You need to add validation here only

        }
        if (this.selectedReasonObj.text == 'Arrange pickup') {

          if ((this.selectedSubReasonObj.text == 'Future pickup' || this.selectedSubReasonObj.text == 'Urgent pickup' ||
              this.selectedSubReasonObj.text == 'Pickup without QC' || this.selectedSubReasonObj.text == 'Exceptional pickup') &&
            this.selectedActionObj.text == 'Arranged - Assigned to Ops Team') {

            if (attempDate == '') {
              this.$alertify.error('Please enter reattempt date.');
              return false;
            }
          }
        }
        if (this.selectedReasonObj.text == 'Update Contact Details' && this.selectedSubReasonObj.text == 'Update Alternate Contact No' &&
          (this.selectedActionObj.text == 'Contact details updated' || this.selectedActionObj.value == constantVariable.ASSIGNED_CS_TEAM)) {

          if (alternateContactNo == '') {
            this.$alertify.error('Please enter alternate contact number.');
            return false;
          }
        }
        if (this.ticketTaggingDisplay == false && mobileNo == '' && (this.selectedSubReasonObj.text == 'Change RTO address' || this.selectedSubReasonObj.text == 'Change DTO address' ||
            this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Change delivery address as per Client' || this.selectedSubReasonObj.text == 'Change Pickup address' ||
            this.selectedSubReasonObj.text == 'Redirect to Bank') && (this.selectedActionObj.text == 'Address Updated' || this.selectedActionObj.value == constantVariable.ASSIGNED_CS_TEAM)) {

          if (mobileNo == '') {
            this.$alertify.error('Please enter primary contact number.');
            return false;
          }
        }
        if (this.selectedReasonObj.text == 'Update Contact Details' && this.selectedSubReasonObj.text == 'Update Email Address' &&
          (this.selectedActionObj.text == 'Contact details updated' || this.selectedActionObj.value == constantVariable.ASSIGNED_CS_TEAM)) {

          if (emailAddress == '') {
            this.$alertify.error('Please enter email address.');
            return false;
          }
          if (emailAddress != '') {
            if (this.ValidateEmail(emailAddress) == false) {
              this.$alertify.error('Please enter valid email address.');
              return false;
            }
          }
        }
        let businessFlow;
        if ((this.selectedSubReasonObj.text == 'Change RTO address' || this.selectedSubReasonObj.value == constantVariable.CHANGE_RTO_PINCODE) && (this.SalesDemo.BusinessType.toLowerCase() == 'ecomm' || this.SalesDemo.BusinessType.toLowerCase() == 'bfsi')) {
          ServiceName = 'RTO';
          businessFlow = 'Reverse';
        }

        if (this.selectedSubReasonObj.text == 'Change DTO address' || this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Change delivery address as per Client' || this.selectedSubReasonObj.text == 'Redirect to Bank' ||
          this.selectedSubReasonObj.value == constantVariable.CHANGE_DTO_PINCODE || this.selectedSubReasonObj.value == constantVariable.CHANGE_DELIVERY_PINCODE &&
          (this.SalesDemo.BusinessType.toLowerCase() == 'ecomm' || this.SalesDemo.BusinessType.toLowerCase() == 'bfsi')) {
          ServiceName = 'Delivery';
        }
        if ((this.selectedSubReasonObj.text == 'Change DTO address' || this.selectedSubReasonObj.value == constantVariable.CHANGE_DTO_PINCODE) && (this.SalesDemo.BusinessType.toLowerCase() == 'ecomm' || this.SalesDemo.BusinessType.toLowerCase() == 'bfsi')) {
          businessFlow = 'Reverse';
        }
        if ((this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Change delivery address as per Client' || this.selectedSubReasonObj.text == 'Redirect to Bank' ||
            (this.selectedSubReasonObj.value == constantVariable.CHANGE_DELIVERY_PINCODE && this.SalesDemo.BusinessFlow.toLowerCase() == 'forward')) &&
          (this.SalesDemo.BusinessType.toLowerCase() == 'ecomm' || this.SalesDemo.BusinessType.toLowerCase() == 'bfsi')) {
          businessFlow = 'Forward';
        }

        if ((this.selectedSubReasonObj.text == 'Change Pickup address' || this.selectedSubReasonObj.text == 'Change misroute pincode' ||
            (this.selectedSubReasonObj.value == constantVariable.CHANGE_PICKUP_PINCODE && this.SalesDemo.BusinessFlow.toLowerCase() == 'reverse')) &&
          (this.SalesDemo.BusinessType.toLowerCase() == 'ecomm' || this.SalesDemo.BusinessType.toLowerCase() == 'bfsi')) {
          ServiceName = 'Pickup';
          businessFlow = 'Reverse';
        }

        if (this.comments === '') {
          this.$alertify.error('Please enter comments.');
          return false;
        }
        this.input = ({
          sourceId: this.sourceId.toString(),
          ticketTypeId: this.ticketTypeId.toString(),
          reasonId: this.reasonId.toString(),
          subReasonId: this.subReasonId.toString(),
          action: this.actionId.toString(),
          ticketStatusId: this.ticketStatusId.toString(),
          userId: this.userid.toString(),
          username: this.username,
          flag: this.tableShipment.toString(),
          shippingData: this.ticketShipmentData,
          deptid: this.DepartmentID.toString(),
          businessunit: this.SalesDemo.BusinessType,
          businessflow: this.SalesDemo.BusinessFlow,
          pincodebusinessflow: businessFlow,
          businessservice: ServiceName,
          routemode: "surface",
          IsFakeNDRStatus: this.fakeNdrStatus,
          userType: this.userTypeForTicket,
          escalation: this.escalation,
          subReason: this.selectedSubReasonObj.text,
          clientID: this.SalesDemo.ClientID,
        });

        if (attempDate !== '' && attempDate != null) {
          this.input.reAttemptDate = attempDate;
        }
        if (address !== '' && address !== null) {
          this.input.address = address;
        }

        if (pincode !== '' && pincode != null) {
          this.input.pincode = pincode;
        }
        if (location !== '' && location != null) {
          this.input.location = location;
        }
        if (comments !== '' && comments != null) {
  // === B2B CRM ALT Instruction Section Start === -- Added condition to add reason and sub reason in the comment for new taggings
           if (
             this.reasonId == constantVariable.Alternate_Instruction_Pickup ||
             this.reasonId == constantVariable.Alternate_Instruction_Delivery
           ) {
           let reattemptDateTimeAndSlot = this.reattemptTimeSlotWithDate
             ? commonFunction.formatDateToCustom(this.reattemptTimeSlotWithDate)
             : '';
           if (
             (this.subReasonId == constantVariable.Hold_Pickup ||
             this.subReasonId == constantVariable.Reattempt_Time_Slot_Pickup) &&
             (this.selectedActionObj.value !== constantVariable.Resolution_Information_Given)
           ) {
             this.input.comments = `${this.selectedReasonObj.text} - ${this.selectedSubReasonObj.text} - Updated pickup slot date from ${this.SalesDemo.PickupTimeSlotWithDate} to ${reattemptDateTimeAndSlot} - ${comments}`;
           } else if (this.subReasonId == constantVariable.Reattempt_Time_Slot_Delivery &&
             this.selectedActionObj.value !== constantVariable.Resolution_Information_Given) {
             this.input.comments = `${this.selectedReasonObj.text} - ${this.selectedSubReasonObj.text} - Updated drop slot date from ${this.SalesDemo.ReattemptDate} to ${reattemptDateTimeAndSlot} - ${comments}`;
           } else {
             this.input.comments = `${this.selectedReasonObj.text} - ${this.selectedSubReasonObj.text} - ${comments}`;
           } 
          }else if(this.reasonId == constantVariable.ChangeDestination){
            if(this.subReasonId == constantVariable.ChangeDestinationAsPerClient || this.subReasonId == constantVariable.ChangeDestinationAsPerClientOPS){
              this.input.comments = `${this.selectedSubReasonObj.text} - ${comments}`;
            }
          }
          else{
          this.input.comments = comments;
          }
  // === B2B CRM ALT Instruction Section End ===
        }
        if (this.tableShipment.toString() == 'true') {
          this.input.ticketId = this.ticketId.toString();
          this.input.ticketData = this.ticket;
        }
        if (this.tableShipment === true || this.ticketShipmentData.length == 1) {

          this.input.isLatestOfd = this.SalesDemo.IsLatestOFD;

          if (this.SalesDemo.UserProcess !== '' && this.SalesDemo.UserProcess != null) {
            this.input.userProcess = this.SalesDemo.UserProcess;
          }
          if (this.SalesDemo.NotificationType !== '' && this.SalesDemo.NotificationType != null) {
            this.input.notificationType = this.SalesDemo.NotificationType;
          }
          if (this.SalesDemo.NotificationStatus !== '' && this.SalesDemo.NotificationStatus != null) {
            this.input.notificationStatus = this.SalesDemo.NotificationStatus;
          }
        }

        if (orderTypeId !== '' && orderTypeId !== null) {
          this.input.orderTypeId = orderTypeId;
        }
        if (netPayment !== '' && netPayment !== null) {
          this.input.netPayment = netPayment;
        }
        if (oldReAttemptDate !== '' && oldReAttemptDate !== null) {
          this.input.oldReAttemptDate = oldReAttemptDate;
        }

        if (alternateContactNo != '' && alternateContactNo != null) {
          this.input.alternateContactNo = alternateContactNo;
        }
        if (emailAddress != '' && emailAddress != null) {
          this.input.emailAddress = emailAddress;
        }
        if (mobileNo != '' && mobileNo !== null) {
          this.input.mobileNo = mobileNo;
        }
        if (hubIds !== '' && hubIds !== null) {
          this.input.hubIds = hubIds;
        }
        if (kamPocIds !== '' && kamPocIds !== null) {
          this.input.kamPocIds = this.selectedKamPocObj.text;  // email
          this.input.kamPocName = this.selectedKamPocObj.value; // name
        }
        if (opsPocIds !== '' && opsPocIds !== null) {
          this.input.opsPocIds = this.selectedOpsPocObj.text;  // email
          this.input.opsPocName = this.selectedOpsPocObj.value; // name
        }
        // === B2B CRM ALT Instruction Section Start === -- Added validation condition for input paramters
        if (this.reattemptTimeSlotWithDate !== '' && this.reattemptTimeSlotWithDate !== null) {
          if( this.selectedSubReasonObj.value == constantVariable.Hold_Pickup){
            this.input.pickupHoldTillDate = this.reattemptTimeSlotWithDate;
          }else{
          this.input.reattemptTimeSlotWithDate = this.reattemptTimeSlotWithDate;
          }
        }
        
        if (this.pickupAddress !== '' && this.pickupAddress !== null) {
          this.input.pickupAddress = this.pickupAddress;
        }
        
        if (this.contactNumber !== '' && this.contactNumber !== null) {
          this.input.contactNumber = this.contactNumber;
        }
        // === B2B CRM ALT Instruction Section End ===

        // #changedesti rollback
        // if(this.selectedReasonObj.value == this.CHANGE_DESTINATION){
        //   if(this.selectedHubObj && this.selectedHubObj.text){
        //     this.input.selectedHubObj=this.selectedHubObj.text;
        //   }

        //   if(this.SalesReturnNoteRTODocDataLink==''){
        //     this.$alertify.error('Please Upload Invoice.');
        //     return false;
        //   }
        //   else{
        //     this.input.SalesReturnNoteRTODocDataLink= this.SalesReturnNoteRTODocDataLink
        //   }
        //   if(this.EwaybillNo!='' || this.ebnRTODocDataLink!=''){
        //     if(this.EwaybillNo==''){
        //       this.$alertify.error('Please enter valid E-Way Bill Number');
        //       return false;
        //     } else if(this.disabledFlag===false && this.EwaybillNo!='' && this.validateB2BEwayclick===false){
        //       this.$alertify.error("Please click on 'validate' before submitting");
        //       return false;
        //     }
        //     else if(this.isEwayBillNumberValid===false && this.disabledFlag===false){
        //       this.$alertify.error('E-Way Bill Number is not valid');
        //       return false;
        //     } else if(this.ebnRTODocDataLink==''){
        //       this.$alertify.error('Please Upload E-Way Bill');
        //       return false;
        //     }else{
        //       this.input.ebnRTODocDataLink= this.ebnRTODocDataLink;
        //       this.input.EwaybillNo=this.EwaybillNo;
        //     }
        //   }
        //   //dummy values
        //   //this.input.ebnRTODocDataLink= 'https://s3-stagecltcrm-backend.xbees.in/ChangeDestination/94192382600802/1255PPP0898_Delivery_sign_1%20%2822%29.jpg';
        //   //this.input.SalesReturnNoteRTODocDataLink= 'https://s3-stagecltcrm-backend.xbees.in/ChangeDestination/94192382600802/1255PPP0898_Delivery_sign_1%20%2810%29.jpg'

        //   if(this.disabledFlag==true){
        //       if(this.proofstatus==''){
        //         this.$alertify.error('Please mark document as Valid/Invalid');
        //         return false;
        //       }
        //       else{
        //         this.input.proofstatus=this.proofstatus;
        //       }
        //   }
        // }

        // console.log("🚀 ~ selectedSubReasonObj:", this.selectedSubReasonObj, this.isServiceableFromOtherBranchPincode)
        if (this.isServiceableFromOtherBranchSubReasonSelected() && this.isServiceableFromOtherBranchPincode) {
              // pincode stays the consignee's existing (serviceable) pincode
              this.input.pincode  = this.CustomerDetails.PinCode;
              this.input.address  = this.CustomerDetails.Address;
              this.input.location = this.CustomerDetails.CustomerName;
              // full consignee block
              this.input.consigneeDetails = {
                name:    this.CustomerDetails.CustomerName,
                address: this.CustomerDetails.Address,
                city:    this.CustomerDetails.City,
                state:   this.CustomerDetails.State,
                pincode: this.CustomerDetails.PinCode,
                phone:   this.CustomerDetails.PhoneNo,
                email:   this.CustomerDetails.EmailID
              };
            }

        //#changedesti  -----------NOT REQUIRED
        //#7472 approval and reject status save
        if (
          this.isApprovalFlow &&
          this.ticketLabel === 'Edit Ticket' &&
          this.input.ticketStatusId !== 'Open' &&
          Number(this.selectedReasonObj.value) === this.CHANGE_DESTINATION
        ) {
          if (!this.disabledFlag) {
            this.$alertify.error('Please Approve or Reject Change destination details.');
            return false;
          }
          if (!this.proofstatus) {
            this.$alertify.error('Please Approve or Reject Change destination details.');
            return false;
          }

          this.input.proofstatus = this.proofstatus;
          this.input.action = String(this.DESTINATION_UPDATED);
          this.actionId = this.input.action;
          this.input.ticketStatusId = 'Closed';

          const adlinfo = (this.ticket && this.ticket.adlinfo) ? this.ticket.adlinfo : {};
          const approvalPincode = this.pincode || (this.ticket && this.ticket.pincode) || '';
          const approvalHubIds = this.hubIds || adlinfo.hubIds || '';
          const approvalSelectedHubObj =
            (this.selectedHubObj && this.selectedHubObj.text) ||
            adlinfo.selectedHubObj ||
            '';

          if (approvalPincode) {
            this.input.pincode = approvalPincode;
          }
          if (approvalHubIds) {
            this.input.hubIds = approvalHubIds;
          }
          if (approvalSelectedHubObj) {
            this.input.selectedHubObj = approvalSelectedHubObj;
          }

          const consigneeDetails = adlinfo.consigneeDetails
            ? Object.assign({}, adlinfo.consigneeDetails)
            : null;
          if (consigneeDetails) {
            this.input.consigneeDetails = consigneeDetails;
          }

          if (this.ticket) {
            this.input.ticketData = Object.assign({}, this.ticket, {
              pincode: approvalPincode || this.ticket.pincode,
              adlinfo: Object.assign({}, adlinfo, {
                hubIds: approvalHubIds || adlinfo.hubIds,
                selectedHubObj: approvalSelectedHubObj || adlinfo.selectedHubObj,
                consigneeDetails: consigneeDetails || adlinfo.consigneeDetails,
              }),
            });
          }
        } else if (
          this.DepartmentID === this.B2BCLIENTHEAD &&
          this.input.ticketStatusId !== 'Open' &&
          this.selectedReasonObj.value === this.CHANGE_DESTINATION &&
          this.selectedSubReasonObj.text === 'Change destination as per Client'
        ) {
          this.$alertify.error('You are unathorized user to create ticket.');
          return false;
        }
        //#7472
        if(this.selectedReasonObj.value == this.CHANGE_DESTINATION && (this.selectedSubReasonObj.text === 'Change destination as per Ops' || this.selectedSubReasonObj.text == 'Change destination as per Client') ){
          if(this.selectedHubObj && this.selectedHubObj.text){
                this.input.selectedHubObj=this.selectedHubObj.text;
              }
  
        }
        //#7472
        if (
          this.selectedReasonObj.value === this.CHANGE_DESTINATION &&
          (
            this.selectedSubReasonObj.text === 'Change destination as per Ops' ||
            this.selectedSubReasonObj.text === 'Change destination as per Client'
          ) && (this.DepartmentID == constantVariable.B2BCLIENTSUPPORT || this.DepartmentID == constantVariable.B2BOPSSUPPORT)  
        ) {
          if (!this.isConsigneeValidated) {
            this.$alertify.error('Please validate pincode and select consignee details.');
            return false;
          }
        
          // OBJECT is sent
            this.input.consigneeDetails = Object.assign({}, this.consignee);
        }
        console.log("this.ticketLabel", this.ticketLabel, this.selectedReasonObj.value, this.input.proofstatus);
        this.captureCreateTicketContext();

        axios({

            method: 'POST',
            'url': apiUrl.api_url + 'createB2BTicket',
            'data': this.input,
            'min': 1,
            'idle': 10000,
            'acquire': 10000,
            'evict': 60000,
            'handleDisconnects': true,
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            this.isLoading = false;
            if (result.data.data.status == true) {

              /*Start IP Tracking */
              let userTrackerObj = {};
              userTrackerObj.subReason = this.selectedSubReasonObj.text;
              userTrackerObj.shippingIds = this.ShippingID;
              userTrackerObj.userid = this.userid;
              userTrackerObj.username = this.username;
              userTrackerObj.olduserid = this.OldDeliveryUserOrUserId;
              userTrackerObj.projectname = apiUrl.project_name;
              userTrackerObj.trackurl = this.$route.path;
              userTrackerObj.eventTrack = "B2BTicket " + userTrackerObj.subReason;
              authFunction.userTrackerB2BTicket(userTrackerObj);
              /*End IP Tracking */
              this.B2BTrackShipment();
              this.ticket = this.resolveCreateTicketFromResponse(result.data.data.data);
              this.ticketdetails = this.enrichTicketDetailsFromFormState(this.ticket, true);
              this.ticketResultMsg = result.data.data.msg;
              console.log("this.ticketLabel----------------------", this.ticketLabel);  
              // Approval-flow redirect must run before resetForm/ShowRaiseTicketDiv,
              // which clear proofstatus, ticketLabel, and selected reason fields.
              const redirectedToDashboard = this.redirectToDashboardRequestPopupIfApproval();

              // this.selectedSearchObj.value=this.ticket.SubReasonId;
              // console.log(this.ticket, this.selectedSearchObj.text, this.DepartmentID, "this.ticket--------------------");
              if (!redirectedToDashboard) {
                this.ticketResultModal = true;
              }

              if (!redirectedToDashboard && this.tableShipment.toString() == 'false') {
                // console.log("🚀 ~ this.ticketResultModal:", this.ticketResultModal)
                this.resetForm();
                
                this.ticket =  result.data.data.data;
                this.f = this.ticket;
                            // console.log("🚀 ~ ticket:----------------", this.ticket)
                this.selectedSearchObj.value=this.ticket.subReasonId;
                this.ticketTaggingDisplay = true;
              } else if (!redirectedToDashboard) {
                this.ShowRaiseTicketDiv();
                this.ticketTaggingDisplay = true;
              }
              
            } else {
              this.ticketResultMsg = result.data.data.msg;
              if (result.data.data.data != '') {
                this.ticket = this.resolveCreateTicketFromResponse(result.data.data.data);
                this.ticketdetails = this.enrichTicketDetailsFromFormState(this.ticket, true);
              }
              // if(this.ticket[0].ticketstatus == 'Open' && this.ticket[0].action == 'RTO') {
              //   let ticket = this.ticket[0] ;
              //   this.ticket = ticket;
              // }
              this.ticketResultModal = true;
            }
          }, error => {
            this.$alertify.error(error);
            console.error(error);
          })
        // === B2B CRM ALT Instruction Section Start === -- Added if condition for B2B create for only parent awb Error handling (in case net payment for child mps)
        }else{
          let msg = constantVariable.UNAUTORISED_USER_MSG;
          this.$alertify.error(msg);
        }
        // === B2B CRM ALT Instruction Section End ===
      } catch (error) {

        let msg = error + " - saveTicketData";
        this.$alertify.error(msg);
      }
    },

    ValidateEmail(inputtext) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(inputtext)) {
        return true;
      }
      return false;
    },
    // checkPin CodeServiceable
    checkPinCodeServiceable() {
      let ServiceName = '';
      let businessFlow = '';
      let pincode = (this.pincode != null && this.pincode != '') ? this.pincode.trim() : '';
      if (pincode == '') {
        this.$alertify.error('Please enter pincode.');
        return false;
      }

      if (this.selectedSubReasonObj.text == 'Change RTO address' && (this.SalesDemo.BusinessType == 'Ecomm' || this.SalesDemo.BusinessType == 'BFSI')) {
        ServiceName = 'RTO';
        businessFlow = 'Reverse';
      }

      if (this.selectedSubReasonObj.text == 'Change DTO address' || this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Change delivery address as per Client' || this.selectedSubReasonObj.text == 'Redirect to Bank' && (this.SalesDemo.BusinessType == 'Ecomm' || this.SalesDemo.BusinessType == 'BFSI')) {
        ServiceName = 'Delivery';
      }
      if (this.selectedSubReasonObj.text == 'Change DTO address' && (this.SalesDemo.BusinessType == 'Ecomm' || this.SalesDemo.BusinessType == 'BFSI')) {
        businessFlow = 'Reverse';
      }
      if ((this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Change delivery address as per Client' || this.selectedSubReasonObj.text == 'Redirect to Bank') && (this.SalesDemo.BusinessType == 'Ecomm' || this.SalesDemo.BusinessType == 'BFSI')) {
        businessFlow = 'Forward';
      }

      if ((this.selectedSubReasonObj.text == 'Change Pickup address' || this.selectedSubReasonObj.text == 'Change misroute pincode') && (this.SalesDemo.BusinessType == 'Ecomm' ||
          this.SalesDemo.BusinessType == 'BFSI')) {
        ServiceName = 'Pickup';
        businessFlow = 'Reverse';
      }

      this.isLoading = true;

      this.input = ({
        "businessunit": this.SalesDemo.BusinessType,
        "businessflow": businessFlow,
        "businessservice": ServiceName, //"Delivery",
        "pincode": this.pincode,
        "routemode": "surface",
      })

      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'checkPinCodeServiceable',
          'data': this.input,
          headers: commonFunction.getusertoken(),
        })
        .then(result => {
          this.isLoading = false;

          let resultDataCrm = result.data.data;

          if (resultDataCrm.status == true) {
            this.$alertify.success(resultDataCrm.msg);
          } else {
            this.$alertify.error(resultDataCrm.msg);
          }

        }, error => {
          this.isLoading = false;
          this.$alertify.error(error);
        })
    },

    getShippingIdDetailsByTicketId() {
      var TickID = this.ShippingID;
      this.input = ({
        "TicketID": this.ShippingID
      })
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getShippingIdDetailsByTicketId',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        var resultShip = result.data.data;
        if (resultShip.status == true) {
          this.ShippingID = resultShip.data.shippingid;
          this.getShipmentTickets(this.ShippingID, TickID);
          this.Ticketmodal = true;
          let dataObj = {
            "value": "ShippingID",
            "text": "Shipping ID"
          };
          this.selectTypeOption(dataObj);
          this.B2BTrackShipment();
        } else {
          let msg = resultShip.msg;
          this.$alertify.error(msg);
        }
      }, error => {
        this.isLoading = false;
        var commonVariable = commonFunction.showNetworkError(error);
        this.$alertify.error(commonVariable);
      })
    },

    getb2bTicketHistory(ticket) {
      this.ticketIDLog = ticket.ticketid
      this.input = ({
        "ticketid": this.ticketIDLog
      })
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getb2bTicketHistory',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        var resultTickets = result.data.data;
        if (resultTickets.status == true) {
          this.resultTicket = result.data.data.data;
          this.TicketLogModal = true;
        } else {
          let msg = this.resultTicket.msg;
          this.$alertify.error(msg);
        }
      }, error => {
        this.isLoading = false;
        var commonVariable = commonFunction.showNetworkError(error);
        this.$alertify.error(commonVariable);
      })
    },

    accessRestrictor() {
      var desider = 0;
      var n = window.location.href.search('#');
      var link = window.location.href.substr(n + 1);
      var linkToo = window.location.href.substr(n + 2);
      for (let i = 0; i < this.permissiondata.length; i++) {
        if (link == this.permissiondata[i].url) {
          desider++;
        }
      }
      if (desider == 0) {
        this.$router.push('/b2b/dashboard');
        this.$alertify.error("Access Denied for " + linkToo + " Module.");
      }
    },

    saveBulkEditShipment() {
      try {

        let token = 'edw3r323432472748923';

        if (this.ticketTypeId === '') {
          this.$alertify.error('Please select Tiket Type.');
          return false;
        }

        if (this.reasonId === '') {
          this.$alertify.error('Please select Reason.');
          return false;
        }

        if (this.subReasonId === '') {
          this.$alertify.error('Please select Sub Reason.');
          return false;
        }

        if (this.actionId === '') {
          this.$alertify.error('Please select Action.');
          return false;
        }

        let attempDate = (this.newReAttemptDate != null && this.newReAttemptDate != '') ? this.newReAttemptDate : '';

        if (attempDate.length != 10 && attempDate !== '') {
          attempDate = moment(String(attempDate)).format('YYYY-MM-DD');
        }

        if (this.ticketExistedData.length == 1 && (this.selectedReasonObj.text == 'Arrange delivery' || this.selectedReasonObj.text == 'Arrange pickup') && this.selectedActionObj.text == 'Arranged - Assigned to Ops Team') {

          if (attempDate == '') {
            this.$alertify.error('Please enter reattempt date.');
            return false;
          }
        }

        if (this.ticketExistedData.length == 1 && ((this.selectedReasonObj.text == 'Non Behavioral' && this.selectedSubReasonObj.text == 'Delay in service') ||
            (this.selectedReasonObj.text == 'SR related' && this.selectedSubReasonObj.text == 'Fake update')) && this.selectedActionObj.text == 'Arranged - Assigned to Ops Team') {

          if (attempDate == '') {
            this.$alertify.error('Please enter reattempt date.');
            return false;
          }
        }

        if (this.selectedReasonObj.text == 'Complaint' && this.selectedSubReasonObj.text == 'Fake update') {
          this.fakeNdrStatus = 1;
        }

        this.input = ({
          ticketIds: this.ticketIDS.toString(),
          ticketData: this.ticketExistedData,
          sourceId: this.sourceId.toString(),
          ticketTypeId: this.ticketTypeId.toString(),
          reasonId: this.reasonId.toString(),
          subReasonId: this.subReasonId.toString(),
          action: this.actionId.toString(),
          ticketStatusId: this.ticketStatusId.toString(),
          reAttemptDate: attempDate,
          deptid: this.DepartmentID.toString(),
          userId: this.userid,
          username: this.username,
          filename: this.excelFileUploadPath,
          comments: this.comments,
          userType: this.userTypeForTicket,
          IsFakeNDRStatus: this.fakeNdrStatus,
          businessflow: this.ticketExistedData[0].shippingData.businessflow,
          escalation: this.escalation,
          editHoldTicket: this.editHoldTicket
        });

        this.isModelLoading = true;

        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'createBulkEditTickets',
            'data': JSON.stringify(this.input),
            'min': 1,
            'idle': 10000,
            'acquire': 10000,
            'evict': 60000,
            'handleDisconnects': true,
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            this.isModelLoading = false;
            this.ticketResultMsg = '';
            this.ticketResultMsg = result.data.data.msg;
            if (this.tableShipment.toString() == 'false') {
              this.resetForm();
              this.ticketTaggingDisplay = true;
            } else {
              this.ShowRaiseTicketDiv();
              this.ticketTaggingDisplay = true;
            }
            this.ticketResultModal = true;
            this.allSelected = false;
            this.ticket = [];
            this.ticketIDS = [];
            this.ticketExistedData = []
            this.selectAllRecord = false;
            this.listExisitngTicketModal = false;
            this.updateExistingBulkTicket = false;
            this.showBulkTicketDiv = false;

            if (result.data.data.status == true) {
              this.B2BTrackShipment();
            }

          }, error => {
            this.isLoading = false;
          })
        return false;
      } catch (error) {
        this.isLoading = false;
        let msg = error + " - saveBulkShipment";
        this.$alertify.error(msg);
      }

    },

    showProductType() {
      this.modalshowProductType = true
    },
    closeModalshowProductType() {
      this.modalshowProductType = false
    },

    // Fetch hub name and hub id from Masters API
    fetchHubData() {
      let inputPayload = {};
      let hubDataList = [];
      let tempArr = [];

      axios({
        method: 'POST',
        url: apiUrl.api_url + 'getAllHubServiceCenters',
        data: inputPayload,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        if (result.data.data.data.code == 200) {
          hubDataList = result.data.data.data.data;
          hubDataList.forEach(element => {
            if (element.HubName) {
              tempArr.push({
                value: element.HubID,
                text: element.HubName + '(' + element.HubID + ')',
              });
            }
          });
          this.hubList = tempArr;
        }
      }, error => {
        this.isLoading = false;
        var commonVariable = commonFunction.showNetworkError(error);
        this.$alertify.error(commonVariable);
      });
    },

    isServiceableFromOtherBranchSubReasonSelected() {
      var subReason = this.selectedSubReasonObj;
      var searchTag = this.selectedSearchObj;
      var subReasonId = subReason && subReason.value != null ? Number(subReason.value) : null;
      var searchSubReasonId = searchTag && searchTag.value != null ? Number(searchTag.value) : null;

      return subReasonId === constantVariable.SERVICEABLE_FROM_OTHER_BRANCH_SUBREASON_ID ||
        searchSubReasonId === constantVariable.SERVICEABLE_FROM_OTHER_BRANCH_SUBREASON_ID ||
        (subReason && subReason.text === constantVariable.SERVICEABLE_FROM_OTHER_BRANCH_SUBREASON) ||
        (searchTag && searchTag.text === constantVariable.SERVICEABLE_FROM_OTHER_BRANCH_SUBREASON);
    },

    resetServiceableFromOtherBranchHubSelection() {
      this.hubIds = '';
      this.selectedHubObj = { value: '', text: '' };
    },

    // Fetch hub name and hub id from Masters API
    fetchHubDataFromPincode: function (e) {
      this.selectedHubObj= {
        value: '',
        text: ''
      }
      let hubDataList = []
      let tempArr = [];
      let routemode = this.SalesDemo.routeMode?this.SalesDemo.routeMode.toLowerCase():'surface';
      this.inputPayload = ({
        "businessunit": (routemode=='air')?this.SalesDemo.BusinessType+routemode:this.SalesDemo.BusinessType,  // Cargo
        "businessflow": this.SalesDemo.BusinessFlow,
        "businessservice": this.SalesDemo.ShipType,
        "clientbuisnessaccountid":this.SalesDemo.ClientBusinessAccountID,
        "pincode": this.pincode,
        "rate": 0,
        "weight": 0,
        "deliverytype": this.SalesDemo.deliveryType?this.SalesDemo.deliveryType:'AS',
        "ordertype": this.OrderDetails.OrderType,
        "servicetype": this.SalesDemo.ServiceType,
        "routemode": routemode
      })
      // console.log("this.inputPayload  is :",this.inputPayload );
    

      axios({
        method: 'POST',
        'url': apiUrl.api_url + "getAllHubServiceCentersFromPincode",
        'data': this.inputPayload,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        if (result.data.data.data.code == 200) {
          //#7472
          const responseData = result.data.data.data.data;

          hubDataList.push(result.data.data.data.data);
          hubDataList.forEach(element => {
            if (element.HubName) {
              tempArr.push({
                'value': element.HubID,
                'text': element.HubName + "(" + element.HubID + ")",
              })
            }
          });
          this.hubList = tempArr;
          //#7472
          if (
            this.selectedReasonObj.value === constantVariable.ChangeDestination &&
            (
              this.selectedSubReasonObj.value === constantVariable.ChangeDestinationAsPerClient ||
              this.selectedSubReasonObj.value === constantVariable.ChangeDestinationAsPerClientOPS
            )
          ) {
               //#7472
            this.isPincodeServiceable = true;
            this.hubIds=responseData.HubID.toString() || '';
            this.consignee.consigneestate = responseData.StateName || '';
            this.consignee.consigneecity  = responseData.CityName || '';
            this.consignee.consigneehub   = responseData.HubName || '';
            this.selectedHubObj = {
              value: responseData.HubID,
              text: responseData.HubName + '(' + responseData.HubID + ')'
            };
          }
        
        } else if (result.data.data.data.code == 204) {

          if (
            this.selectedReasonObj.value === constantVariable.ChangeDestination &&
            (
              this.selectedSubReasonObj.value === constantVariable.ChangeDestinationAsPerClient ||
              this.selectedSubReasonObj.value === constantVariable.ChangeDestinationAsPerClientOPS
            )
          ) {
              //#7472
          this.isPincodeServiceable = false;
          }

          this.$alertify.error(result.data.data.data.message);
        }
      }, error => {
        this.isLoading = false;
        var commonVariable = commonFunction.showNetworkError(error);
        this.$alertify.error(commonVariable);
      })
    },
    async fileview(index) {
      var link = document.createElement('a');
      link.href = index;
      link.setAttribute('target', '_blank');
      window.open(index, '_blank');
      link.remove();
      return true;
    },

    async handleFileUploadSalesReturnNote(event) {
      try {
        let uploadFile = event.target.files;
        this.podimagearray = []
        let formData = new FormData();
        for (let key in uploadFile) {
          if (key >= 0) {
            console.log("key is greater than key 0");
            if (uploadFile[key].type != "image/jpeg" && uploadFile[key].type != "image/jpg" && uploadFile[key].type != "application/pdf") {
              this.$alertify.error("Please upload only valid file format(.jpg, .jpeg, .pdf)");
              this.$refs.uploadSalesReturnNote.value = null;
              return false;
            }
          }
          if (uploadFile[key].size > (1024 * 1024 * 5)) {
            console.log("more than 5MB : ",uploadFile[key].size);
            this.$alertify.error(`${uploadFile[key].name} size is greater than 5MB`, "", "error");
            this.$refs.uploadSalesReturnNote.value = null;
            return false;
          } else {
            console.log("Less than 5MB : ",uploadFile[key].size);
            formData.append("file", uploadFile[key]);
          }
        }
        formData.append("shippingid", this.ShippingID);
        // chanagedesti
        if(this.selectedReasonObj.value == this.CHANGE_DESTINATION){
            //No ticketid in case of this subreason
            formData.append("keyDir",'ChangeDestination');
        }else{
          formData.append("ticketid", this.ticket.ticketid);
        }
        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'UploadS3Image',
            'data': formData,
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
          console.log("result UploadS3Image ",result.data.data);

            this.SalesReturnNoteuploadData = result;
            if (result.data.data.status == true) {
              console.log("result data getting here ");
              this.$alertify.success(result.data.data.data.response);
              //this.$alertify.success(result.data.data.msg);
              this.SalesReturnNoteRTODocDataLink = result.data.data.data.data;
              // Key Handling
              this.SalesReturnNoteRTODocDataKey = (result.data.data.data.info && result.data.data.data.info.Key) ? result.data.data.data.info.Key : '';
              // console.log("handleFileUpload this.SalesReturnNoteRTODocDataLink ************ ", this.SalesReturnNoteRTODocDataLink);
              // changedesti

              //#7472 change desti
              this.setActiveUploadDocsModal(this.ticket);
              this.isLoading = false;
              this.isModelLoading = false;
            }
            else
            {
              console.log("File Not Uploaded");
              this.$alertify.error("File Not Uploaded");
              this.isLoading = false;
              this.isModelLoading = false;
            }
          }, error => {
            console.log("error UploadS3Image", error);
            this.isLoading = false
            this.isModelLoading = false;
            this.$alertify.error(error);
            console.error(error);
          })

      } catch (error) {
        console.log("Catched Error", error);
        this.isLoading = false
        this.isModelLoading = false;
      }
    },


    async handleFileUploadEBN(event) {
      try {
        let uploadFile = event.target.files;
        // console.log("event.target.files::::::::::::::::::::::", uploadFile );
        this.podimagearray = []
        let formData = new FormData();
        for (let key in uploadFile) {
          if (key >= 0) {
            if (uploadFile[key].type != "image/jpeg" && uploadFile[key].type != "image/jpg" && uploadFile[key].type != "application/pdf") {
              this.$alertify.error("Please upload only valid file format(.jpg, .jpeg, .pdf)");
              this.$refs.uploadEbn.value = null;
              return false;
            }
          }
          if (uploadFile[key].size > (1024 * 1024 * 5)) {
            this.$alertify.error(`${uploadFile[key].name} size is greater than 5MB`, "", "error");
            this.$refs.uploadEbn.value = null;
            return false;
          } else {
            formData.append("file", uploadFile[key]);
          }
        }
        formData.append("shippingid", this.ShippingID);
        
        // #changedesti
        if(this.selectedReasonObj.value == this.CHANGE_DESTINATION){
          //No ticketid in case of this subreason
          formData.append("keyDir",'ChangeDestination');
      }else{
        formData.append("ticketid", this.ticket.ticketid);
      }
              // #changedesti

        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'UploadS3Image',
            'data': formData,
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            if (result.data.data.status == true) {
              this.$alertify.success(result.data.data.data.response);
              this.ebnRTODocDataLink = result.data.data.data.data
              this.ebnRTODocDataKey = (result.data.data.data.info && result.data.data.data.info.Key) ? result.data.data.data.info.Key : null;
             //#7472 change desti
             this.setActiveUploadDocsModal(this.ticket);
                            // #changedesti

              this.isLoading = false;
              this.isModelLoading = false;
            }
          }, error => {
            this.isModelLoading = false;
            this.$alertify.error(error);
            console.error(error);
          })

      } catch (error) {
        this.isModelLoading = false;
        console.log("Error", error);
        this.isLoading = false
      }
    },

    onSubmit: function (event) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          console.log(this.ticket,"result============onsumit");
          //#7472 change destination
          if (this.isDestinationDocsUploadFlow()) {
            this.uploadDocsons3changedest(event);
          } else {
          this.uploadDocsons3(event);
          }
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },

    getRTOTickets(data) {
      try {
        this.isModelLoading = true;
        let accessToken;
        let token = 'edw3r323432472748923';
        this.input = {
          "parentawb": this.ShippingID,
          "ticketid": this.ticket.ticketid
        };
        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getRTOTickets',
          headers: commonFunction.getusertoken(),
          'data': this.input

        }).then(result => {
          this.isModelLoading = true;
          var resultTickets = result.data.data;
          if (resultTickets.status == true) {
            this.RTOresultTicket = result.data.data.data;
          } else {
            let msg = this.resultTicket.msg;
            this.$alertify.error(msg);
          }
          this.isModelLoading = false;
        }, error => {
          this.isModelLoading = false;
          let msg = error;
          this.$alertify.error(msg);
        })
      } catch (error) {
        this.isModelLoading = false;
        this.UploadRTODocsmodal = false;
        // this.UploadDestinationDocsmodal = false;
        let msg = error + " - getRTOTickets";
        this.$alertify.error(msg);
      }
    },

    resultSUMofInvoices(data) {
      try {
        this.isModelLoading = true;
        let token = 'edw3r323432472748923';
        this.input = {
          "parentawb": this.ShippingID,
          "ticketid": this.ticket.ticketid
        };
        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'resultSUM',
          headers: commonFunction.getusertoken(),
          'data': this.input

        }).then(result => {
          this.isModelLoading = true;
          this.UploadRTODocsmodal = true;
          //total number of invoices uploaded
          this.resultTotalSum = result.data.data.declaredvalue;
          this.isModelLoading = false;
        }, error => {
          this.isModelLoading = false;
          let msg = error;
          this.$alertify.error(msg);
        })
      } catch (error) {
        this.isModelLoading = false;
        this.UploadRTODocsmodal = false;
        let msg = error + " - resultSUMofInvoices";
        this.$alertify.error(msg);
      }
    },

      //#7472
      getDestinatioTickets() {
        this.isModelLoading = true;
        let accessToken;
        let token = 'edw3r323432472748923';
        this.input = {
          "parentawb": this.ShippingID,
          "ticketid": this.ticket.ticketid
        };
      //  RETURN AXIOS (THIS IS THE FIX)
      return axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getDestinatioTickets',
          headers: commonFunction.getusertoken(),
          'data': this.input
      })
      .then(result => {
        this.isModelLoading = false;
    
        const resultTickets = result.data.data;
    
        if (resultTickets && resultTickets.status === true) {
          this.RTOresultTicket = result.data.data.data || [];
          return this.RTOresultTicket; // return data
        } else {
          let msg = this.resultTicket.msg;
          this.$alertify.error(msg);
        }
          this.isModelLoading = false;
      })
      .catch(error => {
        this.UploadDestinationDocsmodal = false;
        // this.UploadDestinationDocsmodal = false;
        let msg = error + " - getDestinatioTickets";
        this.$alertify.error(msg);
      });
    },

    isInvoiceSumMatched() {
      const uploadedSum = Number(this.resultTotalSum);
      const totalInvoiceValue = Number(this.OrderDetails && this.OrderDetails.TotalInvoiceValue);
      if (!Number.isFinite(uploadedSum) || !Number.isFinite(totalInvoiceValue)) {
        return false;
      }
      return (
        uploadedSum === totalInvoiceValue ||
        parseFloat(uploadedSum.toFixed(2)) === parseFloat(totalInvoiceValue.toFixed(2)) ||
        parseFloat(uploadedSum.toFixed(0)) === parseFloat(totalInvoiceValue.toFixed(0)) ||
        parseInt(uploadedSum, 10) === parseInt(totalInvoiceValue, 10)
      );
    },
   //#7472
    resultSUMofInvoiceschangedest(data) {
      try {
        this.isModelLoading = true;
        this.input = {
          "parentawb": this.ShippingID,
          "ticketid": this.ticket.ticketid
        };
        return axios({
          method: 'POST',
          'url': apiUrl.api_url + 'resultSUMchangedest',
          headers: commonFunction.getusertoken(),
          'data': this.input

        }).then(result => {
          this.resultTotalSum = Number(result.data.data.declaredvalue) || 0;
          this.isModelLoading = false;
          return this.resultTotalSum;
        }, error => {
          this.isModelLoading = false;
          let msg = error;
          this.$alertify.error(msg);
          return Promise.reject(error);
        })
      } catch (error) {
        this.isModelLoading = false;
        this.UploadRTODocsmodal = false;
         this.UploadDestinationDocsmodal = false;
        let msg = error + " - resultSUMofInvoiceschangedest";
        this.$alertify.error(msg);
        return Promise.reject(error);
      }
    },
    async saveandclose(ticket, index) {

// Error msg 
if (
  (this.resultTotalSum == this.OrderDetails.TotalInvoiceValue) ||
  (parseFloat(this.resultTotalSum.toFixed(2)) == parseFloat(this.OrderDetails.TotalInvoiceValue.toFixed(2))) ||
  (parseFloat(this.resultTotalSum.toFixed(0)) == parseFloat(this.OrderDetails.TotalInvoiceValue.toFixed(0))) ||
  (parseInt(this.resultTotalSum) == parseInt(this.OrderDetails.TotalInvoiceValue)) ||
  (this.SalesDemo.PartialStatus === 'PartialDelivery') || (this.SalesDemo.PartialStatus === 'PartialRTO')       //#b2b_partial_rto allow to upload docs 
){
  await this.editTicket(ticket);
  await this.getTicketActionStatus_CLOSED(ticket);
  this.confirmMessage = `Are you sure want to close this ticket ?`
  this.$alertify.confirmWithTitle('Ticket status :', this.confirmMessage, () => this.RTOticketcloseandUpdate(ticket),
    () => this.$alertify.error("cancel"));

}
else
{
  
  this.$alertify.error('Total Invoices Value and Sum of Uploaded Invoices Value does not match.');
  return false;
}

   },
   //#7472
   async saveandclosechangeDesti(ticket, index) {
    try {
      await this.resultSUMofInvoiceschangedest();
      await this.getDestinatioTickets();

      if (!this.isInvoiceSumMatched()) {
        this.$alertify.error('Total Invoices Value and Sum of Uploaded Invoices Value does not match.');
        return false;
      }

      const normalizedTicket = this.normalizeTicketDetails(ticket);
      this.confirmMessage = `Are you sure want to submit destination document ?`;
      this.$alertify.confirmWithTitle('Ticket status :', this.confirmMessage, () => {
        this.closeBModalCommonFunction('UploadDestinationDocsmodal');
        this.$alertify.success('Documents uploaded successfully');
        this.sendemailonclosechangedesti(normalizedTicket);
      },
        () => this.$alertify.error("cancel"));
    } catch (error) {
      let msg = error + " - saveandclosechangeDesti";
      this.$alertify.error(msg);
      return false;
    }
   },
      ///#7472
       async sendemailonclosechangedesti(ticket){
          try {
            this.closeBModalCommonFunction('UploadDestinationDocsmodal');
          
            axios({
              method: 'POST',
              'url': apiUrl.api_url + 'sendemailchangedesti',
              headers: commonFunction.getusertoken(),
              'data': ticket
    
            }).then(result => {
              var resultTickets = result.data.data;
              if (resultTickets.status == true) {
    
    
                /*Start IP Tracking */
                let userTrackerObj = {};
                userTrackerObj.subReason = this.input.comments + " " + this.input.subreasonid;
                userTrackerObj.shippingIds = this.ShippingID;
                userTrackerObj.userid = this.userid;
                userTrackerObj.username = this.username;
                userTrackerObj.olduserid = this.OldDeliveryUserOrUserId;
                userTrackerObj.projectname = apiUrl.project_name;
                userTrackerObj.trackurl = this.$route.path;
                userTrackerObj.eventTrack = "B2BTicket " + userTrackerObj.subReason;
                authFunction.userTrackerB2BTicket(userTrackerObj);
                /*End IP Tracking */
    
    
                this.$alertify.success(result.data.data.msg);
                this.openTicketModal();
                this.createRTODocDataSQS();
              } else {
                this.$alertify.error(result.data.data.msg);
              }
              this.isModelLoading = false;
            }, error => {
              this.isModelLoading = false;
              let msg = error;
              this.$alertify.error(msg);
            })
          } catch (error) {
            this.isModelLoading = false;
            this.UploadRTODocsmodal = false;
            let msg = error + " - sendemailonclosechangedesti";
            this.$alertify.error(msg);
          }
        
       },

    async salesReturnNoteValueFun(salesReturnNoteValue) {
      this.salesReturnNoteValue = salesReturnNoteValue
      //#ebn_enhancement check isexmpted on amount change 
      if (this.salesReturnNoteValue >= 50000 ) {   //#ebn_enhancement hide show upload Eway file field 
        let result = await this.isEWayBillExistAgainstParentAWB(); 
        let isEbnExempted = result && result.data && result.data.data && result.data.data.data && result.data.data.data.isEbnExempted
          ? result.data.data.data.isEbnExempted
          : '';   //#ebn_enhancement isEbnExempted paramter set 
          if( isEbnExempted !== 'Yes'){
            this.isShow = true
          }
         else{
            this.isShow = false
         }
      } else if (this.salesReturnNoteValue < 50000 && this.isDestinationDocsUploadFlow()) { //#7472
        this.isShow = false;
      }
      else {
            this.isShow = false
      }
    },

    async getsalesReturnlink(ticketd) {
      this.getsaleslink = ticketd.salesreturns3url;
      window.open(ticketd.salesreturns3url, '_self').focus();
    },

    async viewSalesLink(ticketd) {
      try {
        this.finalS3urlExt = null;
        if (ticketd.salesreturns3url != null) {
          this.previewImageData = ticketd
          if (ticketd.salesreturns3url) {
            let finalS3url = ticketd.salesreturns3url;
            let finalS3urlExt = finalS3url.substring(finalS3url.lastIndexOf('.') + 1, finalS3url.length);
            finalS3urlExt = (finalS3urlExt) ? finalS3urlExt.toLowerCase() : null;
            this.finalS3urlExt = finalS3urlExt;
            if (finalS3urlExt == "pdf") {
              let pdfUrl = 'https://docs.google.com/gview?url=' + ticketd.salesreturns3url + '&embedded=true'; //#7472
              this.displayImageInBox = pdfUrl;
            } else {
              this.displayImageInBox = ticketd.salesreturns3url
            }
          } else {
            this.displayImageInBox = ticketd.salesreturns3url
          }


          this.previewImageModel = true
          this.isLoading = false
          this.titleNameLink = "Sales Return Note"
          this.titleNameLinkchangedest = "Invoice Doc"  //#7472


        } else {
          this.$alertify.error("Data not found")
          this.previewImageModel = false
          this.isLoading = false
        }
      } catch (error) {}
    },
    async getlink(ticketd) {
      this.getebnlink = ticketd.ebns3url;
      window.open(ticketd.ebns3url, '_self').focus();
    },


     //#changedesti
     //#7472
     validateDocumentProof(id,event){
      event.preventDefault();

      const allowed = [
        this.kamPocIds,
        this.opsPocIds,
        ...constantVariable.B2B_ALTERNATE_KAM_HEAD_EMAIL,
        ...constantVariable.B2B_ALTERNATE_OPS_HEAD_EMAIL
      ]
      .flat()
      .map(v => (v || '').toString().trim().toLowerCase());
        // console.log(allowed, "allowed==================");
      if (!allowed.includes((this.email || '').trim().toLowerCase())) {
        this.$alertify.error('You are not authorised user.');
        return;
      }

      if (this.comments === '') {
        this.$alertify.error('Please enter comments.');
        return false;
      }
    
      this.disabledFlag = true;
    
      const errorcb = () => {
        this.proofstatus = '';
        this.$alertify.error('Please mark document as Valid/Invalid');
      };
    
      // CALL API FIRST
      this.getDestinatioTickets().then((tickets) => {
        this.isModelLoading = false;
    
        console.log(tickets, "AFTER API");
    
        //  CHECK DOCUMENTS
        if (this.DepartmentID !== this.B2BOPSHEAD) {
          if (!Array.isArray(tickets) || tickets.length === 0) {
            this.$alertify.error('Destination Documents are not uploaded yet.');
            return;
          }
        }
    
        // =========================
        //  APPROVE
        // =========================
        if (id === 'valid') {
    
          if (this.DepartmentID === this.B2BOPSHEAD) {
            this.proofstatus = 'Approved';
            console.log(this.proofstatus, "this.proofstatus===============");
    
            this.$alertify.success("Ticket approved successfully.");
            this.saveTicketDataClick(); //  SAVE
    
          } else {
    
            this.$alertify.confirmWithTitle(
              'Alert',
              'Are you sure the documents are valid?',
              () => {
                this.proofstatus = 'Approved';
                // this.$alertify.success("Document approved.");
                this.saveTicketDataClick(); //  SAVE
              },
              errorcb
            );
          }
        }
    
        // =========================
        // REJECT
        // =========================
        if (id === 'invalid') {
    
          if (this.DepartmentID === this.B2BOPSHEAD) {
            this.proofstatus = 'Rejected';
            this.$alertify.error("Ticket rejected.");
            this.saveTicketDataClick(); // SAVE
    
          } else {
    
            this.$alertify.confirmWithTitle(
              'Alert',
              'Are you sure the documents are invalid?',
              () => {
                this.proofstatus = 'Rejected';
                // this.$alertify.error("Document rejected.");
                this.saveTicketDataClick(); // SAVE
              },
              errorcb
            );
          }
        }
    
      });
    },

     //#changedesti
     async viewImageB2B(ChangeDestiDoc, titleNameLinkB2B) {
      try {
        this.isLoading = true;
        this.ChangeDestiDoc=ChangeDestiDoc;
        let url = '';
        if(ChangeDestiDoc == '' || ChangeDestiDoc==null || ChangeDestiDoc==undefined){
          this.$alertify.error(`${titleNameLinkB2B} is not present`);
          this.isLoading = false;
            return false;
        }
        let finalS3urlExt = ChangeDestiDoc.substring(ChangeDestiDoc.lastIndexOf('.') + 1).toLowerCase();
        this.finalS3urlExt = finalS3urlExt;
        // Determine if the document is a PDF
        if (finalS3urlExt === "pdf") {
          url = `https://docs.google.com/gview?url=${ChangeDestiDoc}&embedded=true`;
        } else {
          // For other file types (e.g., images), use the direct URL
          url = ChangeDestiDoc;
        }
        this.displayImageInBox = url;
        this.titleNameLink = titleNameLinkB2B;
        this.previewImageModelChangeDesti = true;
        this.isLoading = false;
      } catch (error) {
        console.error("Error in viewImageB2B:", error);
        this.isLoading = false;
        this.previewImageModelChangeDesti = false;
        this.$alertify.error("viewImageB2B error -"+error)
      }
    },

     //#changedesti

    // After a successful ticket update triggered from the Approve/Reject flow on a
    // Change Destination ticket, redirect to the dashboard and re-open the corresponding
    // Request sub-reason ticket list popup ("Change destination as per Client" / "as per Ops").
    redirectToDashboardRequestPopupIfApproval() {
      try {
        const selectedReasonId = this.selectedReasonObj && Number(this.selectedReasonObj.value);
        const isApprovalSave =
          this.ticketLabel === 'Edit Ticket' &&
          selectedReasonId === this.CHANGE_DESTINATION &&
          (this.proofstatus === 'Approved' || this.proofstatus === 'Rejected');

        if (!isApprovalSave) {
          return false;
        }

        let subReasonIdForPopup = '';
        const subText = this.selectedSubReasonObj && this.selectedSubReasonObj.text;
        const subReasonValue = this.selectedSubReasonObj && Number(this.selectedSubReasonObj.value);

        if (subText === 'Change destination as per Client' || subReasonValue === constantVariable.ChangeDestinationAsPerClient) {
          subReasonIdForPopup = constantVariable.ChangeDestinationAsPerClient;
        } else if (subText === 'Change destination as per Ops' || subReasonValue === constantVariable.ChangeDestinationAsPerClientOPS) {
          subReasonIdForPopup = constantVariable.ChangeDestinationAsPerClientOPS;
        } else if (Number(this.subReasonId) === constantVariable.ChangeDestinationAsPerClient) {
          subReasonIdForPopup = constantVariable.ChangeDestinationAsPerClient;
        } else if (Number(this.subReasonId) === constantVariable.ChangeDestinationAsPerClientOPS) {
          subReasonIdForPopup = constantVariable.ChangeDestinationAsPerClientOPS;
        }

        if (!subReasonIdForPopup) {
          return false;
        }

        this.Ticketmodal = false;
        this.ticketResultModal = false;
        this.isLoading = false;
        this.proofstatus = '';

        try {
          window.sessionStorage.setItem('b2bDashboardOpenRequest', JSON.stringify({
            subReasonId: String(subReasonIdForPopup),
            type: 'Request'
          }));
        } catch (e) { /* ignore storage failures */ }

        this.$router.push('/b2b/dashboard').catch(() => {});
        return true;
      } catch (error) {
        console.error('redirectToDashboardRequestPopupIfApproval error:', error);
        return false;
      }
    },

    async viewEBNLink(ticketd) {
      // console.log("viewebnLink ticketd", ticketd);
      try {
        if (ticketd.ebns3url != null || ticketd.ebns3url != 'NA') {
          this.previewImageData = ticketd

          //Start PDF Preview
          this.finalS3urlExt = null;
          let finalS3url = ticketd.ebns3url;
          let finalS3urlExt = finalS3url.substring(finalS3url.lastIndexOf('.') + 1, finalS3url.length);
          finalS3urlExt = (finalS3urlExt) ? finalS3urlExt.toLowerCase() : null;
          this.finalS3urlExt = finalS3urlExt;
          if (finalS3urlExt == "pdf") {
            let pdfUrl = 'https://docs.google.com/gview?url=' + ticketd.ebns3url + '&embedded=true'; //#7472
            this.displayImageInBox = pdfUrl;
          } else {
            this.displayImageInBox = ticketd.ebns3url
          }
          //End PDF Preview

          this.previewImageModel = true
          this.isLoading = false
          this.titleNameLink = "Eway Bill "
        } else {
          this.$alertify.error("Data not found")
          this.previewImageModel = false
          this.isLoading = false
        }
      } catch (error) {}
    },
    resetRTOuploadDoc() {
        //#7472
      console.log("this.rfee", this.$refs);
      //#7472
      this.setActiveUploadDocsModal(this.ticket);
      this.salesReturnNoteNo = '';
      this.salesReturnNoteValue = '';
      this.EwaybillNo = '';
      this.SalesReturnNoteRTODocDataLink = '';
      this.ebnRTODocDataLink = '';
      this.isShow = false;
      //#b2b_partial_rto enhancement reset partial status on reset doc
      this.salesReturnKey++;

      if (this.$refs.uploadSalesReturnNote)
        this.$refs.uploadSalesReturnNote.value = null;

      if (this.$refs.uploadEbn)
        this.$refs.uploadEbn.value = null;

      if (this.$refs.salesReturnNoteValue)
        this.$refs.salesReturnNoteValue.value = null;

      if (this.$refs.EwaybillNo)
        this.$refs.EwaybillNo.value = null;

    },

    deleteUploadClick(data, idname) {
      // #changedesti
      //#7472
      this.setActiveUploadDocsModal(this.ticket);
            // #changedesti

       if (idname === 'uploadSalesReturnNote') {
        this.$refs.uploadSalesReturnNote.value = null;
        this.validateduploadSalesReturnNote = true
        // Re-enable after 5 seconds
        this.timeout = setTimeout(() => {
          this.validateduploadSalesReturnNote = false
        }, 5000)
        this.SalesReturnNoteRTODocDataLink = ''
      } else if (idname === 'uploadEbn') {
        this.$refs.uploadEbn.value = null;
        this.validateduploadEbn = true
        // Re-enable after 5 seconds
        this.timeout = setTimeout(() => {
          this.validateduploadEbn = false
        }, 5000)
        this.ebnRTODocDataLink = '';
      }
      this.deleteUploadedFile(data, idname);
    },

    deleteUploadedFile(data, idname) {
      try {
        var inputPayload = {
          "parentawb": this.ShippingID,
          "ticketid": this.ticket.ticketid,
          "Key": data
        };
        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'deleteUploadDataOnS3',
            'data': inputPayload,
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            this.isLoading = false;
            this.isModelLoading = false;

            // console.log("result.data.data.data.response", result.data.data.data.response);

            if (result.data.status == true) {
              this.deletertodocdata = result.data.data.data
              this.$alertify.success(result.data.data.data.response);
            } else {
              this.deletertodocdata = "No Data Found";
              this.$alertify.error(result.data.data.data.response)
            }

              // #7472
              this.setActiveUploadDocsModal(this.ticket);
              // #changedesti
            

          }, error => {
            this.$alertify.error(error);
            this.isModelLoading = false;
                          // #7472
            this.setActiveUploadDocsModal(this.ticket);
                        // #changedesti

            console.error(error);
          })
      } catch (error) {
        this.isLoading = false
        this.isModelLoading = false;

        let msg = error + " - deleteUploadedFile";
        console.log(msg);
        this.$alertify.error(msg);
      }
    },

    deleteRowActionClick(ticketRTOdoc) {
      this.isModelLoading = true;
      this.UploadRTODocsmodal = true;
      this.validated = true
      // Re-enable after 5 seconds
      this.timeout = setTimeout(() => {
        this.validated = false
      }, 5000)
      this.deleteRowAction(ticketRTOdoc);
    },

    deleteRowAction(ticketRTOdoc) {
      this.isModelLoading = true;
      try {
        var inputPayload = {
          "id": ticketRTOdoc.id,
          "parentawb": ticketRTOdoc.parentawb,
          "ticketid": ticketRTOdoc.ticketid,
          "declaredvalue": ticketRTOdoc.declaredvalue,
          "invoicenumber": ticketRTOdoc.invoicenumber,
          "ebnnumber": ticketRTOdoc.ebnnumber,
          "ebns3url": ticketRTOdoc.ebns3url,
          "salesreturns3url": ticketRTOdoc.salesreturns3url
        };
        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'deleteDataFrmDb',
            'data': inputPayload,
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            this.isLoading = false;
            this.UploadRTODocsmodal = true;
            this.isModelLoading = true;
            if (result.data.status == true) {
              this.$alertify.success(result.data.message);
              this.SumOfTotalInvoices = this.resultSUMofInvoices();
              this.getRTOTicketsdata = this.getRTOTickets();
            } else {
              this.deleteRtoData = "No Data Found";
              this.$alertify.error(result.data.message)
            }
            this.isModelLoading = false;
          }, error => {
            this.$alertify.error(error);
            this.isModelLoading = false;
            this.UploadRTODocsmodal = true;
            console.error(error);
          })
      } catch (error) {
        this.isLoading = false
        this.isModelLoading = false;

        let msg = error + " - deleteRowAction";
        console.log(msg);
        this.$alertify.error(msg);
      }
    },

    //#7472
    deleteRowActionClickchangedest(ticketRTOdoc) {
      this.isModelLoading = true;
      this.UploadDestinationDocsmodal = true;
      this.validated = true
      // Re-enable after 5 seconds
      this.timeout = setTimeout(() => {
        this.validated = false
      }, 5000)

      this.deleteRowActionChangedest(ticketRTOdoc);
    },
//#7472
    deleteRowActionChangedest(ticketRTOdoc) {
      this.isModelLoading = true;
      try {
        var inputPayload = {
          "id": ticketRTOdoc.id,
          "parentawb": ticketRTOdoc.parentawb,
          "ticketid": ticketRTOdoc.ticketid,
          "declaredvalue": ticketRTOdoc.declaredvalue,
          "invoicenumber": ticketRTOdoc.invoicenumber,
          "ebnnumber": ticketRTOdoc.ebnnumber,
          "ebns3url": ticketRTOdoc.ebns3url,
          "salesreturns3url": ticketRTOdoc.salesreturns3url
        };
        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'deleteDataFrmDbchangedest',
            'data': inputPayload,
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            this.isLoading = false;
            this.UploadDestinationDocsmodal = true;
            this.isModelLoading = true;
            if (result.data.status == true) {
              this.$alertify.success(result.data.message);
              this.SumOfTotalInvoices = this.resultSUMofInvoiceschangedest();
              this.getRTOTicketsdata = this.getDestinatioTickets();
            } else {
              this.deleteRtoData = "No Data Found";
              this.$alertify.error(result.data.message)
            }
            this.isModelLoading = false;
          }, error => {
            this.$alertify.error(error);
            this.isModelLoading = false;
            this.UploadDestinationDocsmodal = true;
            console.error(error);
          })
      } catch (error) {
        this.isLoading = false
        this.isModelLoading = false;

        let msg = error + " - deleteRowActionChangedest";
        console.log(msg);
        this.$alertify.error(msg);
      }
    },

   //#7472
    async uploadDocsons3changedest(data) {
      try {


        //Start isEWayBillExistAgainstParentAWB
        if (!this.EwaybillNo && this.isEbnMandatory) {
          let result = await this.isEWayBillExistAgainstParentAWB();
          console.log(result);
          
          if (result) {
            this.isModelLoading = false;
            let resultDataCrm = result.data.data;
            let msg = (resultDataCrm.msg) ? resultDataCrm.msg : "Error in isEWayBillExistAgainstParentAWB API.";
            if (resultDataCrm.status) {
              //let resultData = result.data.data.data;
              this.$alertify.error(msg);
              return false;
            } else {
             // this.$alertify.error(msg);
              //return true;
            }
          } else {
           this.isModelLoading = false;
           this.$alertify.error("Error in isEWayBillExistAgainstParentAWB API.");
           return false;
          }

        }
        // End isEWayBillExistAgainstParentAWB


        // Start Validtion
        //#7472 change condition
        if (
          this.EwaybillNo ||
          (
            Number(this.salesReturnNoteValue) < 50000 &&
            this.ebnRTODocDataLink !== '' &&
            this.isShow
          ) ||
          (
            Number(this.salesReturnNoteValue) >= 50000 &&
            this.isShow &&
            this.isEbnMandatory
          )
        ){
          let result = await this.checkEwayBillNumberValid();          
          if (result) {
            this.isModelLoading = false;
            let resultDataCrm = result.data.data;
            if (resultDataCrm.status) {
              let resultData = result.data.data.data;
              if (resultData.statusCode && resultData.statusCode === 200 && resultData.isValid) {
                this.isEwayBillNumberValid = true;
              } else {
                this.isEwayBillNumberValid = false;
                let msg = resultDataCrm.msg;
                this.$alertify.error(msg);
                return false;
              }
            } else {
              let msg = resultDataCrm.msg;
              this.$alertify.error(msg);
              this.isEwayBillNumberValid = false;
              return false;
            }

          } else {
            this.isEwayBillNumberValid = false;
            return false;
          }
          // End validation E - Way Bill Number

        }
        //dummy values
        // this.ebnRTODocDataLink= 'https://s3-stagecltcrm-backend.xbees.in/ChangeDestination/94192382600802/1255PPP0898_Delivery_sign_1%20%2822%29.jpg';
        //  this.SalesReturnNoteRTODocDataLink= 'https://s3-stagecltcrm-backend.xbees.in/ChangeDestination/94192382600802/1255PPP0898_Delivery_sign_1%20%2810%29.jpg'
         
         this.ticket = this.normalizeTicketDetails(Object.assign({}, this.ticketdetails));
         console.log("uploadDocsons3------",this.ticket, this.ticketdetails);
        var inputPayload = {
          "salesReturnNoteNo": this.salesReturnNoteNo,
          "salesReturnNoteValue": this.salesReturnNoteValue,
          "EwaybillNo": this.EwaybillNo,
          "parentawb": this.ShippingID,
          "ticketid": this.ticket.ticketid,
          "uploadEbn": this.ebnRTODocDataLink != '' ? this.ebnRTODocDataLink : 'NA',
          "ebnexpirydate": this.ebnExpiryDate, //#5278_b2b_expirydate ebn validity date 
        };
        console.log(inputPayload,"uploadDocsons3----");
        
        if (this.SalesReturnNoteRTODocDataLink != '') {
          inputPayload.uploadSalesReturnNote = this.SalesReturnNoteRTODocDataLink;
        } else {
          this.$alertify.error("File not uploaded on s3 bucket");
          return;
        }

        if (this.isChangeDestinationAsPerClientTicket(this.ticket)) {
          inputPayload.hubid = this.ticket.adlinfo && this.ticket.adlinfo.hubIds ? this.ticket.adlinfo.hubIds : '';
          inputPayload.type = "Client";
        }
        console.log(this.selectedSubReasonObj.value,"this.selectedSubReasonObj.value=========");

        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'saveUploadDataOnS3changedest',
            'data': inputPayload,
            headers: commonFunction.getusertoken(),
          })
          .then(async (result) => {

            //#7472 old code 
            console.log(result,"result============");

            this.isLoading = false;
            this.setActiveUploadDocsModal(this.ticket);
            this.isModelLoading = false;
            if (result.data.status == true) {
              this.rtodocdata = result.data.data
              // Clear the current list so Vue re-renders the table cleanly when
              // the fresh response arrives, and to hide stale rows if the
              // refresh call fails for any reason.
              this.RTOresultTicket = [];
              await this.resultSUMofInvoiceschangedest();
              this.getRTOTicketsdata = await this.getDestinatioTickets();
              await this.$nextTick();
              this.$alertify.success(result.data.message);
              this.resetRTOuploadDoc();

            } else {
              this.rtodocdata = "No Data Found";
              this.$alertify.error(result.data.message)
            }
            this.setActiveUploadDocsModal(this.ticket);

          }, error => {
            let msg = error + " - uploadDocsons3changedest";
            console.log(msg);
            this.$alertify.error(msg);
            this.isModelLoading = false;
            this.setActiveUploadDocsModal(this.ticket);
            console.error(error);
          })

      } catch (error) {
        this.isLoading = false
        this.isModelLoading = false;
        let msg = error + " - uploadDocsons3changedest";
        console.log(msg);
        this.$alertify.error(msg);
      }
    },
    createRTODocDataSQS() {
      this.input = {
        "parentawb": this.ShippingID,
        "ticketid": this.ticket.ticketid
      };
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'createRTODocDataSQS',
        'data': this.input,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        var resultsqsData = result.data.data;

        if (resultsqsData.status == true) {
          this.resultsqsData = resultsqsData.data;
          this.$alertify.success(resultsqsData.msg);
        } else {
          let msg = resultsqsData.msg;
          this.$alertify.error(msg);
        }
      }, error => {
        this.isLoading = false;
        var commonVariable = commonFunction.showNetworkError(error);
        this.$alertify.error(commonVariable);
      })

    },

    onlyNumber($event) {
      //console.log($event.keyCode); //keyCodes value
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
        $event.preventDefault();
        this.isShowError = true
      } else {
        this.isShowError = false
      }
    },

    closeModelPreviewImage() {
      this.previewImageModel = false
      this.previewImageModelChangeDesti=false    //#changedesti
      //#7472
      this.setActiveUploadDocsModal(this.ticket);
       //#changedesti
      this.previewImageData = ''
      this.displayImageInBox = ''
    },


    async uploadDocsons3(data) {
      try {


        //Start isEWayBillExistAgainstParentAWB   
        if (!this.EwaybillNo) {
          let result = await this.isEWayBillExistAgainstParentAWB();
          if (result) {
            this.isModelLoading = false;
            let resultDataCrm = result.data.data;
            let msg = (resultDataCrm.msg) ? resultDataCrm.msg : "Error in isEWayBillExistAgainstParentAWB API.";
            if (resultDataCrm.status) {
              //let resultData = result.data.data.data;
              this.$alertify.error(msg);
              return false;
            } else {
             // this.$alertify.error(msg);
              //return true;
            }
          } else {
           this.isModelLoading = false;
           this.$alertify.error("Error in isEWayBillExistAgainstParentAWB API.");
           return false;
          }

        }
        // End isEWayBillExistAgainstParentAWB


        // Start Validtion 
        if (this.EwaybillNo || this.isShow) {
          let result = await this.checkEwayBillNumberValid();
          if (result) {
            this.isModelLoading = false;
            let resultDataCrm = result.data.data;
            if (resultDataCrm.status) {
              let resultData = result.data.data.data;
              if (resultData.statusCode && resultData.statusCode === 200 && resultData.isValid) {
                this.isEwayBillNumberValid = true;
              } else {
                this.isEwayBillNumberValid = false;
                let msg = resultDataCrm.msg;
                this.$alertify.error(msg);
                return false;
              }
            } else {
              let msg = resultDataCrm.msg;
              this.$alertify.error(msg);
              this.isEwayBillNumberValid = false;
              return false;
            }

          } else {
            this.isEwayBillNumberValid = false;
            return false;
          }
          // End validation E - Way Bill Number

        }


        var inputPayload = {
          "salesReturnNoteNo": this.salesReturnNoteNo,
          "salesReturnNoteValue": this.salesReturnNoteValue,
          "EwaybillNo": this.EwaybillNo,
          "parentawb": this.ShippingID,
          "ticketid": this.ticket.ticketid,
          "uploadEbn": this.ebnRTODocDataLink != '' ? this.ebnRTODocDataLink : 'NA',
          "ebnexpirydate": this.ebnExpiryDate, //#5278_b2b_expirydate ebn validity date 
        };
        if (this.SalesReturnNoteRTODocDataLink != '') {
          inputPayload.uploadSalesReturnNote = this.SalesReturnNoteRTODocDataLink;
        } else {
          this.$alertify.error("File not uploaded on s3 bucket");
          return;
        }
        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'saveUploadDataOnS3',
            'data': inputPayload,
            headers: commonFunction.getusertoken(),
          })
          .then(result => {
            this.isLoading = false;
            this.UploadRTODocsmodal = true;
            this.isModelLoading = false;
            if (result.data.status == true) {
              this.rtodocdata = result.data.data
              this.SumOfTotalInvoices = this.resultSUMofInvoices();
              this.getRTOTicketsdata = this.getRTOTickets();
              this.$alertify.success(result.data.message);
              this.resetRTOuploadDoc();
              this.UploadRTODocsmodal = true;

            } else {
              this.rtodocdata = "No Data Found";
              this.$alertify.error(result.data.message)
            }
            this.UploadRTODocsmodal = true;

          }, error => {
            let msg = error + " - uploadDocsons3";
            console.log(msg);
            this.$alertify.error(msg);
            this.isModelLoading = false;
            this.UploadRTODocsmodal = true;
            console.error(error);
          })

      } catch (error) {
        this.isLoading = false
        this.isModelLoading = false;
        let msg = error + " - uploadDocsons3";
        console.log(msg);
        this.$alertify.error(msg);
      }
    },



    async isEWayBillExistAgainstParentAWB() {
      try {

        this.input = ({
          "ParentAWB": this.ShippingID,
          "clientBuisnessAccountid":this.SalesDemo.ClientBusinessAccountID
        })
        this.isModelLoading = true;

        // Start isEWayBillExistAgainstParentAWB
        var options = {
          headers: commonFunction.getusertoken(),
          'timeout': 60000
        };
        let response = await axios.post(apiUrl.api_url + 'isEWayBillExistAgainstParentAWB', this.input, options);
        this.isModelLoading = false;
        return response;

      } catch (error) {
        this.isModelLoading = false;
        let msg = error + " - TMS isEWayBillExistAgainstParentAWB";
        this.$alertify.error(msg);

        return false;

      }
    },

    async checkEwayBillNumberValid() {
      try {

        this.isEwayBillNumberValid = false;
        if (this.EwaybillNo === '') {
          this.$alertify.error('Please enter E-Way Bill Number.');
          return false;
        }

        if (this.salesReturnNoteNo === '') {
          this.$alertify.error('Please enter Sales Return Note Number.');
          return false;
        }

        if (this.salesReturnNoteValue === '') {
          this.$alertify.error('Please enter Sales Return Note Value.');
          return false;
        }


        this.input = ({
          EwaybillNo: this.EwaybillNo,
          salesReturnNoteNo: this.salesReturnNoteNo,
          salesReturnNoteValue: this.salesReturnNoteValue,
          clientBuisnessAccountid:this.SalesDemo.ClientBusinessAccountID
        })
        this.isModelLoading = true;

        // Start validation E - Way Bill Number
        var options = {
          headers: commonFunction.getusertoken(),
           'timeout': 60000
        };
        let response = await axios.post(apiUrl.api_url + 'checkEwayBillNumberValid', this.input, options);
        let rtoData=response.data.data.data; //#5278_b2b_expirydate rto data 
        this.ebnExpiryDate = rtoData.validUpto ? moment(String(rtoData.validUpto)).format('YYYY-MM-DD HH:mm:ss') : null ; //#5278_b2b_expirydate 'validUpto' to 'YYYY-MM-DD HH:mm:ss' 
        
        return response;

      } catch (error) {
        this.isModelLoading = false;
        this.isEwayBillNumberValid = false;
        let msg = error + " - TMS checkEwayBillNumberValid";
        this.$alertify.error(msg);

        return false;

      }
    },


    //isEwayBillNumberValid EwaybillNo
    validateEwayBillNumberValid() {
      try {

        this.isEwayBillNumberValid = false;
        if (this.EwaybillNo === '') {
          this.$alertify.error('Please enter E-Way Bill Number.');
          return false;
        }

        if (this.salesReturnNoteNo === '') {
          this.$alertify.error('Please enter Sales Return Note Number.');
          return false;
        }

        if (this.salesReturnNoteValue === '') {
          this.$alertify.error('Please enter Sales Return Note Value.');
          return false;
        }


        this.input = ({
          EwaybillNo: this.EwaybillNo,
          salesReturnNoteNo: this.salesReturnNoteNo,
          salesReturnNoteValue: this.salesReturnNoteValue,
          clientBuisnessAccountid:this.SalesDemo.ClientBusinessAccountID
        })

        this.isModelLoading = true;
        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'checkEwayBillNumberValid',
            headers: commonFunction.getusertoken(),
            'data': this.input
          })
          .then(result => {
            this.isModelLoading = false;
            let resultDataCrm = result.data.data;
            if (resultDataCrm.status) {
              let resultData = result.data.data.data;
              if (resultData.statusCode && resultData.statusCode === 200 && resultData.isValid) {
                this.isEwayBillNumberValid = true;
                let msg = resultDataCrm.msg;
                this.$alertify.success(msg);
              } else {
                this.isEwayBillNumberValid = false;
                let msg = resultDataCrm.msg;
                this.$alertify.error(msg);
              }
            } else {
              let msg = resultDataCrm.msg;
              this.$alertify.error(msg);
              this.isEwayBillNumberValid = false;
            }
          }, error => {
            this.isEwayBillNumberValid = false;
            let msg = error;
            this.$alertify.error(msg);
          })
      } catch (error) {
        this.isModelLoading = false;
        this.isEwayBillNumberValid = false;
        let msg = error + " - validateEwayBillNumberValid";
        this.$alertify.error(msg);
      }
    },

    validateB2BEwayBillNumberValid() {
      try {
        this.validateB2BEwayclick=true;
        this.isEwayBillNumberValid = false;
        if (this.EwaybillNo === '') {
          this.$alertify.error('Please enter E-Way Bill Number.');
          return false;
        }

        this.input = ({
          EwaybillNo: this.EwaybillNo,
          clientBuisnessAccountid:this.SalesDemo.ClientBusinessAccountID
        })

        this.isModelLoading = true;
        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'checkB2BEwayBillNumberValid',
            headers: commonFunction.getusertoken(),
            'data': this.input
          })
          .then(result => {
            this.isModelLoading = false;
            let resultDataCrm = result.data.data;
            if (resultDataCrm.status) {
              let resultData = result.data.data.data;
              if (resultData.statusCode && resultData.statusCode === 200 && resultData.isValid) {
                this.isEwayBillNumberValid = true;
                let msg = resultDataCrm.msg;
                this.$alertify.success(msg);
              } else {
                this.isEwayBillNumberValid = false;
                let msg = resultDataCrm.msg;
                this.$alertify.error(msg);
              }
            } else {
              let msg = resultDataCrm.msg;
              this.$alertify.error(msg);
              this.isEwayBillNumberValid = false;
            }
          }, error => {
            this.isEwayBillNumberValid = false;
            let msg = error;
            this.$alertify.error(msg);
          })
      } catch (error) {
        this.isModelLoading = false;
        this.isEwayBillNumberValid = false;
        let msg = error + " - validateEwayBillNumberValid";
        this.$alertify.error(msg);
      }
    },   


  


    //#7472 Fetch KAM POC from GO API
    fetchKamPocFromClientId(ClientID, preserveSelection = false) {
      this.kamPocList = [];
      if (!preserveSelection) {
        this.selectedKamPocObj= {
          value: '',
          text: ''
        };
      }
      this.inputPayload = ({
        "clientid": ClientID
      })
      axios({
        method: 'POST',
        'url': apiUrl.api_url + "getKamPocFromClientId",
        'data': this.inputPayload,
        headers: commonFunction.getusertoken(),
      }).then(result => {
          const response = result.data && result.data.data && result.data.data.data;
          if (!response) {
            return;
          }
          if (response.statusCode === 200 && response.data && response.data.entity) {
            const item = response.data.entity;
            let tempArr = [];
            if (item.email) {
              tempArr.push({
                value: item.name,
                text: item.email
              });
            }
            this.kamPocList = tempArr;
          } else {
            this.$alertify.error("No KAM POC user found for the selected client.");
          }
      }, error => {
        this.isLoading = false;
        var commonVariable = commonFunction.showNetworkError(error);
        this.$alertify.error(commonVariable);
      })
    },
    selectedKamPoc(kamPocData) {
      try {
        this.selectedKamPocObj = kamPocData;
        this.kamPocIds = kamPocData.text.toString(); // email
      } catch (error) {
        let msg = error + " - selectedKamPoc";
        this.$alertify.error(msg);
      }
    },
     //#7472 Fetch KAM POC from GO API
   fetchOpsPocFromCurrentHubId(OriginHubID, preserveSelection = false) {    
    if (!preserveSelection) {
      this.selectedOpsPocObj = { value: "", text: "" };
    }
    this.opsPocList = [];
    const payload = { hubid: OriginHubID };    
      axios({
        method: "POST",
        url: apiUrl.api_url + "getOpsPocFromCurrentHubId",
        data: payload,
        headers: commonFunction.getusertoken(),
      })
      .then((result) => {
        const response = result.data && result.data.data && result.data.data.data;
        if (!response) return;
        if (response.code === 200) {
          const item = response.data;  // this contains username, email
          let tempArr = [];
          if (item && item.email) {
            tempArr.push({
              value: item.username,   // value = name
              text: item.email    // text = email
            });
          }
          this.opsPocList = tempArr;
        } 
        else if (response.code === 204) {
          this.$alertify.error("No Ops POC user found for the origin hub ID.");
        }
      })
      .catch((error) => {
        this.isLoading = false;
        var commonVariable = commonFunction.showNetworkError(error);
        this.$alertify.error(commonVariable);
      });
},
   selectedOpsPoc(opsPocData) {
      try {
        this.selectedOpsPocObj = opsPocData;
        this.opsPocIds = opsPocData.text.toString(); // email
      } catch (error) {
        let msg = error + " - selectedOpsPoc";
        this.$alertify.error(msg);
      }
},

 //#7472
 openUpdateConsigneeDetails(pincode, event) {
  event.preventDefault();
   
   //#7472
      if (!this.isPincodeServiceable) {

        this.$alertify.error('Pincode is not serviceable.');
        return;
      }

  //  If already validated once, just reopen modal
  if (this.isConsigneeValidated && this.savedConsigneeSnapshot) {
    Object.assign(this.consignee, this.savedConsigneeSnapshot);
    this.UpdateConsigneeDetails = true;
    return;
  }

  this.isModelLoading = true;

  const payload = {
    clientid: String(this.SalesDemo.ClientID || ''),
    clientbusinessaccountid: String(this.SalesDemo.ClientBusinessAccountID || ''),
    destinationpincode: String(pincode || '')
  };

  axios.post(
    apiUrl.api_url + 'getConsigneeDeatilsFLM',
    payload,
    { headers: commonFunction.getusertoken() }
  )
  .then(res => {
    const apiRes = res.data.data.data;
  
    //getConsigneeDeatilsFLM  If api failure or no data
    if (!apiRes || apiRes.code !== 200) {
      this.$alertify.error('No consignee found. Please add new consignee details.');
  
      this.consigneeDetailslist = [];
      this.filteredConsigneeList = [
        { id: 'ADD_NEW', consigneecode: 'ADD_NEW' }
      ];
  
      this.UpdateConsigneeDetails = true;
      return; 
    }
  
    // getConsigneeDeatilsFLM API success
    this.consigneeDetailslist = apiRes.data || [];
    this.filteredConsigneeList = [];
    this.UpdateConsigneeDetails = true;
  })
  .catch(error => {
    this.$alertify.error(commonFunction.showNetworkError(error));
  })
  .finally(() => {
    this.isModelLoading = false;
  });
},

fetchConsigneeByGST() {
  if (!this.gstNo) {
    this.resetConsigneeSelection();
    return;
  }

  const gstUpper = this.gstNo.toUpperCase();

  const matchedConsignees = this.consigneeDetailslist.filter(
    item => (item.consigneegstno && item.consigneegstno.toUpperCase()) === gstUpper
  );

  this.filteredConsigneeList = [
    { id: 'ADD_NEW', consigneecode: 'ADD_NEW' },
    ...matchedConsignees
  ];

  this.resetConsigneeSelection();
},


onConsigneeChange() {
  if (this.consignee.consigneecode === 'ADD_NEW') {
    this.enableAddNewConsignee();
  } else {
    this.disableAddNewConsignee();
    this.fillExistingConsigneeDetails();
  }
},
enableAddNewConsignee() {
  this.AddNewConsigneeFlag = true;

  this.locationPrefix = this.setLocationPrefix(
    this.SalesDemo.ClientName || '',
    this.gstNo || '',
    this.pincode || ''
  );

  this.NewConsigneeCode = '';
  this.clearConsigneeFields(true);
  this.updateFullConsigneeCode();
},

disableAddNewConsignee() {
  this.AddNewConsigneeFlag = false;
  this.locationPrefix = '';
  this.NewConsigneeCode = '';
},

fillExistingConsigneeDetails() {
  const selected = this.filteredConsigneeList.find(
    item => item.consigneecode === this.consignee.consigneecode
  );

  if (!selected) return;

  Object.assign(this.consignee, {
    id: selected.id || '',
    consigneecode: selected.consigneecode || '',
    consigneegstno: selected.consigneegstno || '',
    consigneecompanyname: selected.consigneecompanyname || '',
    consigneeaddress: selected.consigneeaddress || '',
    consigneemobile: selected.consigneemobile || '',
    consigneetelephone: selected.consigneetelephone || '',
    consigneespoc: selected.consigneespoc || '',
    consigneemail: selected.consigneemail || ''
  });
},

updateFullConsigneeCode() {
  if (!this.AddNewConsigneeFlag) return;

  const maxSuffixLength = 30 - this.locationPrefix.length;
  if (this.NewConsigneeCode.length > maxSuffixLength) {
    this.NewConsigneeCode = this.NewConsigneeCode.substring(0, maxSuffixLength);
  }

  this.consignee.consigneecode =
    (this.locationPrefix || '') + (this.NewConsigneeCode || '');
},

setLocationPrefix(clientName, gstNo, pincode) {
let clientCode = clientName.replace(/\s+/g, '').toUpperCase();

clientCode = clientCode.length < 5
  ? clientCode.padEnd(5, 'X')
  : clientCode.substring(0, 5);

const pinCode = String(pincode || '').padStart(6, '0');
const gstCode = gstNo ? gstNo.slice(-3).toUpperCase() : 'XXX';

return `${clientCode}-${pinCode}-${gstCode}-`;
},

resetConsigneeSelection() {
this.consignee.consigneecode = '';
this.disableAddNewConsignee();
this.clearConsigneeFields(true);
},



clearConsigneeFields(preserveHubCityState = false) {
Object.assign(this.consignee, {
  id: '',
  consigneegstno: '',
  consigneecompanyname: '',
  consigneeaddress: '',
  consigneemobile: '',
  consigneetelephone: '',
  consigneespoc: '',
  consigneestate: preserveHubCityState ? this.consignee.consigneestate : '',
  consigneecity: preserveHubCityState ? this.consignee.consigneecity : '',
  consigneehub: preserveHubCityState ? this.consignee.consigneehub : '',
  consigneemail: ''
});
},

closeConsigneeModal() {
// reset loaders
this.isModelLoading = false;
this.isLoading = false;
this.AddNewConsigneeFlag = false;
},

async onSubmitConsignee() {
if (this.AddNewConsigneeFlag) {
  if (!this.gstNo ) {
    return this.$alertify.error(
      "GST No is required "
    );
  }
  if (!this.consignee.consigneecode || this.consignee.consigneecode.length > 30) {
    return this.$alertify.error(
      "Consignee Location Name (Code) is required and must not exceed 30 characters"
    );
  }

  if (!(this.consignee.consigneecompanyname && this.consignee.consigneecompanyname.trim())) {
    return this.$alertify.error("Consignee Company Name is required");
  }

  if (
    !(this.consignee.consigneemobile && this.consignee.consigneemobile.trim()) ||
    !/^[6-9]\d{9}$/.test(this.consignee.consigneemobile)
  ) {
    return this.$alertify.error(
      "Mobile number must be 10 digits and start with 6, 7, 8, or 9"
    );
  }

  if (!(this.consignee.consigneespoc && this.consignee.consigneespoc.trim())) {
    return this.$alertify.error("Consignee Person Name is required");
  }

  if (!(this.consignee.consigneemail && this.consignee.consigneemail.trim())) {
    return this.$alertify.error("Email is required");
  }

  if (!(this.consignee.consigneeaddress && this.consignee.consigneeaddress.trim())) {
    return this.$alertify.error("Address is required");
  }

  // -------------------------------
  // BUILD PAYLOAD FOR API
  // -------------------------------
  const payload = {
    clientid: String(this.SalesDemo.ClientID || ''),
    clientbusinessaccountid: String(this.SalesDemo.ClientBusinessAccountID || ''),
    destinationpincode: String(this.pincode || ''),
    consigneecode: this.consignee.consigneecode,
    consigneecompanyname: this.consignee.consigneecompanyname,
    consigneemobile: this.consignee.consigneemobile,
    consigneetelephone: this.consignee.consigneetelephone || '',
    consigneespoc: this.consignee.consigneespoc,
    consigneegstno: this.gstNo || '',
    consigneeemail: this.consignee.consigneemail,
    consigneeaddress: this.consignee.consigneeaddress,
    awbnumber: this.ShippingID || '',
    lastmodifiedby: this.username
  };

  this.isLoading = true;

  try {
    const res = await axios.post(
      apiUrl.api_url + "addNewConsigneeFLM",
      payload,
      { headers: commonFunction.getusertoken() }
    );

    const apiRes = res.data.data.data;
    console.log(apiRes,"addNewConsigneeFLM response---");
    

    if ( res && apiRes && apiRes.code === 200 ) {
      this.$alertify.success('Consignee added successfully.');

      // Add newly created consignee to dropdown
      this.filteredConsigneeList.push({
        id: apiRes.data.id,
        consigneecode: apiRes.data.consigneecode,
        consigneecompanyname: apiRes.data.consigneename,
        consigneeaddress: apiRes.data.address,
        consigneemobile: apiRes.data.mobile,
        consigneetelephone: apiRes.data.telephone,
        consigneespoc: apiRes.data.attn,
        consigneegstno: apiRes.data.csttin,
        consigneemail: apiRes.data.email,
        consigneestate: this.consignee.consigneestate,
        consigneecity: this.consignee.consigneecity,
        consigneehub: this.consignee.consigneehub
      });
      //#7472 change - update consignee details on addition of new consignee and close modal
      this.consignee.consigneegstno = this.consignee.consigneegstno ?  apiRes.data.csttin : this.gstNo;

      // Select the newly added consignee and disable editing
      this.consignee.consigneecode = apiRes.data.consigneecode;
      this.savedConsigneeSnapshot = JSON.parse(
        JSON.stringify(this.consignee)
      );
      this.AddNewConsigneeFlag = false;

    } else {
      this.$alertify.error('Failed to add consignee');
    }
  } catch (err) {
    this.$alertify.error(commonFunction.showNetworkError(err));
  } finally {
    this.isLoading = false;
  }
} else {
  if (!this.gstNo ) {
    return this.$alertify.error(
      "GST No is required "
    );
  }
  if (!this.consignee.consigneecode ) {
    return this.$alertify.error(
      "Please select Consignee Location Name (Code)"
    );
  }
  // -------------------------------
  // EXISTING CONSIGNEE LOGIC
  // -------------------------------
  this.isConsigneeValidated = true;
  //#7472 change - update consignee details on selection of existing consignee and close modal
  this.consignee.consigneegstno = this.consignee.consigneegstno ?  this.consignee.consigneegstno : this.gstNo;

// STORE SNAPSHOT
this.savedConsigneeSnapshot = JSON.parse(
  JSON.stringify(this.consignee)
);
this.isLoading = false;
this.UpdateConsigneeDetails = false;

this.$alertify.success('Consignee details saved successfully.');
}
},

viewConsigneeDetails(ticket, event) {
event.preventDefault();
console.log(ticket,"viewConsigneeDetails---");


if (!ticket.adlinfo || !ticket.adlinfo.consigneeDetails) {
  this.$alertify.error('Consignee details not available');
  return;
}

const cd = ticket.adlinfo.consigneeDetails;

this.consignee.id = cd.id || '';
this.consignee.consigneecode = cd.consigneecode || '';
this.consignee.consigneegstno = (cd.consigneegstno).toUpperCase() || '';
this.consignee.consigneecompanyname = cd.consigneecompanyname || '';
this.consignee.consigneeaddress = cd.consigneeaddress || '';
this.consignee.consigneemobile = cd.consigneemobile || '';
this.consignee.consigneetelephone = cd.consigneetelephone || '';
this.consignee.consigneespoc = cd.consigneespoc || '';
this.consignee.consigneestate = cd.consigneestate || '';
this.consignee.consigneecity = cd.consigneecity || '';
this.consignee.consigneehub = cd.consigneehub || '';
this.consignee.consigneemail = cd.consigneemail || '';

this.ViewConsigneeDetails = true;
},
//#7472
//#sr_vehicle_7686  Fetch BA/SR details for given Parent AWB
getBASRDetails(parentawb) {    
  const payload = { parentawb };

  axios({
    method: "POST",
    url: apiUrl.api_url + "getBASRDetailsagainstAWB",
    data: payload,
    headers: commonFunction.getusertoken(),
  })
  .then((result) => {

   
    const apiResponse = result.data.data.data;
     // Handle SUCCESS and FAILURE API response
      if (apiResponse.status.toUpperCase() === "SUCCESS" && apiResponse.data) {

  const basrData = apiResponse.data;

  this.b2b_sr_vehicle_details = {
    vehicle_number: basrData.vehiclenumber ? basrData.vehiclenumber : null,
    driver_name: basrData.drivername ? basrData.drivername : null,
    driver_mobile_number: basrData.drivermobileno ? basrData.drivermobileno : null
  };

      } else {
  // FAILURE 
       this.b2b_sr_vehicle_details = {
    vehicle_number: null,
    driver_name: null,
    driver_mobile_number: null
  };
      }
  })
.catch((error) => {
    this.isLoading = false;
    // API/network error → reset values
    this.b2b_sr_vehicle_details = {
      vehicle_number: null,
      driver_name: null,
      driver_mobile_number: null
    };
    const msg = commonFunction.showNetworkError(error);
    this.$alertify.error(msg);
  });
}


},

  



}



// WEBPACK FOOTER //
// ./src/views/components/b2b/trackshipment/trackshipment.component.js